import { useQuery, useMutation, UseQueryOptions, UseMutationOptions } from 'react-query';
import { fetchData } from '../lib/fetcher';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  DateTime: any;
  JSON: any;
  Upload: any;
};

export type AcceptJobInput = {
  errorPath: Scalars['String'];
  jobId: Scalars['Float'];
  startTime?: InputMaybe<Scalars['DateTime']>;
  statusId: Scalars['Float'];
  supplierId: Scalars['String'];
};

export type AccessToken = {
  __typename?: 'AccessToken';
  accessToken?: Maybe<Scalars['String']>;
  client?: Maybe<Profile>;
  clientId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  enabled?: Maybe<Scalars['Boolean']>;
  expiresAt?: Maybe<Scalars['DateTime']>;
  id: Scalars['Float'];
};

export type AddChatMessageInput = {
  errorPath: Scalars['String'];
  isAdmin?: InputMaybe<Scalars['Boolean']>;
  jobAddress?: InputMaybe<Scalars['String']>;
  jobId: Scalars['Float'];
  jobTitle: Scalars['String'];
  receiverId?: InputMaybe<Scalars['String']>;
  text: Scalars['String'];
};

export type AddChatMessagePayload = {
  __typename?: 'AddChatMessagePayload';
  chatMessage?: Maybe<ChatMessage>;
  errors?: Maybe<Array<Error>>;
};

export type AddCityInput = {
  city: Scalars['String'];
  country: Scalars['String'];
  currency: Scalars['String'];
  currencySymbol: Scalars['String'];
  errorPath: Scalars['String'];
  timezone: Scalars['String'];
};

export type AnalyticFinancial = {
  __typename?: 'AnalyticFinancial';
  cogs: Scalars['Float'];
  month: Scalars['String'];
  netRevenues?: Maybe<Scalars['Float']>;
  profit: Scalars['Float'];
  revenues: Scalars['Float'];
};

export type AnalyticFinancialPayload = {
  __typename?: 'AnalyticFinancialPayload';
  dataList?: Maybe<Array<AnalyticFinancial>>;
  errors?: Maybe<Array<Error>>;
};

export type AnalyticIndividualRevenues = {
  __typename?: 'AnalyticIndividualRevenues';
  month: Scalars['String'];
  revenueType?: Maybe<Scalars['String']>;
  revenues?: Maybe<Scalars['Float']>;
};

export type AnalyticIndividualRevenuesInput = {
  endDate: Scalars['DateTime'];
  revenueType: Scalars['String'];
  startDate: Scalars['DateTime'];
};

export type AnalyticIndividualRevenuesPayload = {
  __typename?: 'AnalyticIndividualRevenuesPayload';
  dataList?: Maybe<Array<AnalyticIndividualRevenues>>;
  errors?: Maybe<Array<Error>>;
};

export type AnalyticInput = {
  endDate: Scalars['DateTime'];
  startDate: Scalars['DateTime'];
};

export type AnalyticJobListInput = {
  endDate: Scalars['DateTime'];
  startDate: Scalars['DateTime'];
};

export type AnalyticList = {
  __typename?: 'AnalyticList';
  avg?: Maybe<Scalars['Float']>;
  label?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['Int']>;
};

export type AnalyticPiePayload = {
  __typename?: 'AnalyticPiePayload';
  dataList?: Maybe<Array<AnalyticList>>;
  errors?: Maybe<Array<Error>>;
  totalAvg?: Maybe<Scalars['Float']>;
};

export type AppHomeSearchJobListInput = {
  cityId?: InputMaybe<Scalars['Float']>;
  clientId?: InputMaybe<Scalars['String']>;
  dateFilter?: InputMaybe<Scalars['String']>;
  dateSort?: InputMaybe<Scalars['String']>;
  excludeStatusIdList?: InputMaybe<Array<Scalars['Int']>>;
  isAccepted?: InputMaybe<Scalars['Boolean']>;
  isPreferredSupplier?: InputMaybe<Scalars['Boolean']>;
  isRemoteQuote?: InputMaybe<Scalars['Boolean']>;
  isStartTimeNull?: InputMaybe<Scalars['Boolean']>;
  location?: InputMaybe<Array<Scalars['Float']>>;
  publishedToApp?: InputMaybe<Scalars['Boolean']>;
  skillFilter?: InputMaybe<Array<Scalars['Int']>>;
  statusIdList?: InputMaybe<Array<Scalars['Int']>>;
  supplierId?: InputMaybe<Scalars['String']>;
  text?: InputMaybe<Scalars['String']>;
};

export type ApproveQuoteInput = {
  details: Scalars['String'];
  errorPath: Scalars['String'];
  jobId: Scalars['Float'];
  quoteId: Scalars['Float'];
};

export type ChangePasswordInput = {
  errorPath: Scalars['String'];
  newPassword: Scalars['String'];
  password: Scalars['String'];
  profileId: Scalars['String'];
};

export type ChatCheckedInput = {
  isAdmin: Scalars['Boolean'];
  jobId: Scalars['Int'];
};

export type ChatMessage = {
  __typename?: 'ChatMessage';
  createdAt?: Maybe<Scalars['DateTime']>;
  id: Scalars['Float'];
  isAdmin?: Maybe<Scalars['Boolean']>;
  job?: Maybe<Job>;
  jobId: Scalars['Float'];
  receiver?: Maybe<Profile>;
  receiverId?: Maybe<Scalars['ID']>;
  sender?: Maybe<Profile>;
  senderId?: Maybe<Scalars['ID']>;
  text: Scalars['String'];
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type City = {
  __typename?: 'City';
  city: Scalars['String'];
  country?: Maybe<Scalars['String']>;
  currency?: Maybe<Scalars['String']>;
  currencySymbol?: Maybe<Scalars['String']>;
  id: Scalars['Float'];
  jobs?: Maybe<Array<Job>>;
  timezone?: Maybe<Scalars['String']>;
};

export type CityDetailsInput = {
  cityId?: InputMaybe<Scalars['Float']>;
};

export type CityPayload = {
  __typename?: 'CityPayload';
  city?: Maybe<City>;
  errors?: Maybe<Array<Error>>;
};

export type CityPrice = {
  __typename?: 'CityPrice';
  city?: Maybe<City>;
  cityId?: Maybe<Scalars['Int']>;
  price?: Maybe<Scalars['Float']>;
  problemCategoryId?: Maybe<Scalars['Int']>;
  problemSubcategory?: Maybe<ProblemSubcategory>;
  problemSubcategoryId?: Maybe<Scalars['Int']>;
};

export type CityProfilePrice = {
  __typename?: 'CityProfilePrice';
  city?: Maybe<City>;
  cityId?: Maybe<Scalars['Int']>;
  dayServicePrice?: Maybe<Scalars['Float']>;
  fixedPrice?: Maybe<Scalars['Float']>;
  problemSubcategory?: Maybe<ProblemSubcategory>;
  problemSubcategoryId?: Maybe<Scalars['Int']>;
  profile?: Maybe<Profile>;
  profileId?: Maybe<Scalars['ID']>;
  servicePrice?: Maybe<Scalars['Float']>;
};

export type CityProfilePriceDetailsInput = {
  cityId: Scalars['Float'];
  problemSubcategoryId: Scalars['Float'];
  profileId: Scalars['String'];
};

export type CityProfilePriceDetailsPayload = {
  __typename?: 'CityProfilePriceDetailsPayload';
  dayPrice?: Maybe<Scalars['Float']>;
  fixedPrice?: Maybe<Scalars['Float']>;
  price?: Maybe<Scalars['Float']>;
};

export type CompletionTime = {
  __typename?: 'CompletionTime';
  month: Scalars['String'];
  status: Scalars['String'];
};

export type CompletionTimePayload = {
  __typename?: 'CompletionTimePayload';
  dataList?: Maybe<Array<CompletionTime>>;
  errors?: Maybe<Array<Error>>;
};

export type ConfirmEmailInput = {
  token: Scalars['String'];
  url: Scalars['String'];
};

export type CopyQuoteToNewQuoteInput = {
  endId?: InputMaybe<Scalars['Float']>;
  startId?: InputMaybe<Scalars['Float']>;
};

export type CopyUnattachedQuoteToJobInput = {
  endId?: InputMaybe<Scalars['Float']>;
  startId?: InputMaybe<Scalars['Float']>;
};

export type CreateAccessTokenPayload = {
  __typename?: 'CreateAccessTokenPayload';
  accessToken?: Maybe<Scalars['String']>;
  errors?: Maybe<Array<Error>>;
};

export type CreateB2CClientProfileInput = {
  address?: InputMaybe<Scalars['String']>;
  adminPassword?: InputMaybe<Scalars['String']>;
  areaCovered?: InputMaybe<Array<Scalars['String']>>;
  blocked?: InputMaybe<Scalars['Boolean']>;
  cityId?: InputMaybe<Scalars['Float']>;
  commission?: InputMaybe<Scalars['Float']>;
  companyName?: InputMaybe<Scalars['String']>;
  creatorId?: InputMaybe<Scalars['String']>;
  creditControlNotes?: InputMaybe<Scalars['String']>;
  documents?: InputMaybe<Array<Scalars['Upload']>>;
  email: Scalars['String'];
  emailConfirmationLink?: InputMaybe<Scalars['String']>;
  errorPath: Scalars['String'];
  fullName?: InputMaybe<Scalars['String']>;
  image?: InputMaybe<Scalars['Upload']>;
  insuranceExpiryDate?: InputMaybe<Scalars['DateTime']>;
  invoiceEmailList?: InputMaybe<Scalars['String']>;
  invoiceNotes?: InputMaybe<Scalars['String']>;
  isB2B?: InputMaybe<Scalars['Int']>;
  isCongestionCharged?: InputMaybe<Scalars['Boolean']>;
  isDayRate?: InputMaybe<Scalars['Boolean']>;
  isHourly?: InputMaybe<Scalars['Boolean']>;
  isLandlordInvoicing?: InputMaybe<Scalars['Boolean']>;
  isNewClientPrice?: InputMaybe<Scalars['Boolean']>;
  isParkingCharged?: InputMaybe<Scalars['Boolean']>;
  jobUpdatesEmailList?: InputMaybe<Scalars['String']>;
  notes?: InputMaybe<Scalars['String']>;
  password?: InputMaybe<Scalars['String']>;
  paymentTerms?: InputMaybe<Scalars['Float']>;
  permissions?: InputMaybe<Array<Scalars['String']>>;
  phoneNumber?: InputMaybe<Scalars['String']>;
  qualificationDocuments?: InputMaybe<Array<Scalars['Upload']>>;
  qualificationExpiryDate?: InputMaybe<Scalars['DateTime']>;
  rating?: InputMaybe<Scalars['String']>;
  roles?: InputMaybe<Array<Scalars['String']>>;
  shiftOptions?: InputMaybe<Array<Scalars['String']>>;
  skillList?: InputMaybe<Array<Scalars['Int']>>;
  stripePaymentIntentId: Scalars['String'];
  tncAcceptedList?: InputMaybe<Array<TncAcceptedItemInput>>;
};

export type CreateBookingInput = {
  address?: InputMaybe<Scalars['String']>;
  b2cNotes?: InputMaybe<Scalars['String']>;
  beforeImages?: InputMaybe<Array<Scalars['Upload']>>;
  cityId?: InputMaybe<Scalars['Float']>;
  clientEmailStartedAt?: InputMaybe<Scalars['DateTime']>;
  clientId?: InputMaybe<Scalars['String']>;
  completionNotes?: InputMaybe<Scalars['String']>;
  deletedBeforeImages?: InputMaybe<Array<Scalars['String']>>;
  deletedDocuments?: InputMaybe<Array<Scalars['String']>>;
  deletedImages?: InputMaybe<Array<Scalars['String']>>;
  deletedParkingImages?: InputMaybe<Array<Scalars['String']>>;
  deletedPreferredSupplierList?: InputMaybe<Array<Scalars['String']>>;
  deletedSkillList?: InputMaybe<Array<Scalars['Int']>>;
  deletedTagList?: InputMaybe<Array<Scalars['Int']>>;
  deletedVideos?: InputMaybe<Array<Scalars['String']>>;
  details?: InputMaybe<Scalars['String']>;
  documents?: InputMaybe<Array<Scalars['Upload']>>;
  email: Scalars['String'];
  emailConfirmationLink?: InputMaybe<Scalars['String']>;
  errorPath: Scalars['String'];
  fullName: Scalars['String'];
  id?: InputMaybe<Scalars['Int']>;
  images?: InputMaybe<Array<Scalars['Upload']>>;
  internalNotes?: InputMaybe<Scalars['String']>;
  invoiceEmailList?: InputMaybe<Scalars['String']>;
  invoiceRef?: InputMaybe<Scalars['String']>;
  isClientAgreedForOOH?: InputMaybe<Scalars['Boolean']>;
  isRemedialQuote?: InputMaybe<Scalars['Boolean']>;
  isRemoteQuote?: InputMaybe<Scalars['Boolean']>;
  jobReportSubmitted?: InputMaybe<Scalars['DateTime']>;
  jobStatusId?: InputMaybe<Scalars['Float']>;
  jobUpdatesEmailList?: InputMaybe<Scalars['String']>;
  lat?: InputMaybe<Scalars['Float']>;
  lng?: InputMaybe<Scalars['Float']>;
  parkingImages?: InputMaybe<Array<Scalars['Upload']>>;
  phoneNumber?: InputMaybe<Scalars['String']>;
  postCode?: InputMaybe<Scalars['String']>;
  preferredSupplierList?: InputMaybe<Array<Scalars['String']>>;
  problemCategoryId?: InputMaybe<Scalars['Float']>;
  problemSubcategoryId?: InputMaybe<Scalars['Float']>;
  propertyAccess?: InputMaybe<Scalars['String']>;
  publishedToApp?: InputMaybe<Scalars['Boolean']>;
  referenceId?: InputMaybe<Scalars['String']>;
  remedialNotes?: InputMaybe<Scalars['String']>;
  roles: Array<Scalars['String']>;
  skillList?: InputMaybe<Array<Scalars['Int']>>;
  slotDuration?: InputMaybe<Scalars['Float']>;
  startTime?: InputMaybe<Scalars['DateTime']>;
  startTimeSlots?: InputMaybe<Array<IJobTimeSlot>>;
  supplierId?: InputMaybe<Scalars['String']>;
  supplierJobStatusId?: InputMaybe<Scalars['Float']>;
  tagList?: InputMaybe<Array<Scalars['Int']>>;
  title?: InputMaybe<Scalars['String']>;
  videos?: InputMaybe<Array<Scalars['Upload']>>;
};

export type CreateCategoryInput = {
  errorPath: Scalars['String'];
  iconName: Scalars['String'];
  id: Scalars['Float'];
  name: Scalars['String'];
};

export type CreateCityPriceInput = {
  cityId: Scalars['Float'];
  errorPath: Scalars['String'];
  price: Scalars['Float'];
  problemCategoryId: Scalars['Float'];
  problemSubcategoryId: Scalars['Float'];
};

export type CreateCityProfilePriceInput = {
  cityId: Scalars['Float'];
  errorPath: Scalars['String'];
  priceList: Array<ICityProfilePrice>;
  profileId: Scalars['String'];
};

export type CreateEntityInput = {
  address?: InputMaybe<Scalars['String']>;
  documents?: InputMaybe<Array<Scalars['Upload']>>;
  email?: InputMaybe<Scalars['String']>;
  errorPath: Scalars['String'];
  fullName?: InputMaybe<Scalars['String']>;
  image?: InputMaybe<Scalars['Upload']>;
  insuranceExpiryDate?: InputMaybe<Scalars['DateTime']>;
  isB2B?: InputMaybe<Scalars['Int']>;
  notes?: InputMaybe<Scalars['String']>;
  phoneNumber?: InputMaybe<Scalars['String']>;
  roles?: InputMaybe<Array<Scalars['String']>>;
};

export type CreateFeedbackInput = {
  errorPath: Scalars['String'];
  message: Scalars['String'];
};

export type CreateFeedbackPayload = {
  __typename?: 'CreateFeedbackPayload';
  errors?: Maybe<Array<Error>>;
};

export type CreateInvoicePayload = {
  __typename?: 'CreateInvoicePayload';
  errors?: Maybe<Array<Error>>;
  onlineInvoiceUrl?: Maybe<Scalars['String']>;
};

export type CreateJobStatusInput = {
  description: Scalars['String'];
  enabled?: InputMaybe<Scalars['Boolean']>;
  errorPath: Scalars['String'];
  id: Scalars['Int'];
  roleId: Scalars['Float'];
  title: Scalars['String'];
};

export type CreatePaymentInput = {
  address?: InputMaybe<Scalars['String']>;
  adminPassword?: InputMaybe<Scalars['String']>;
  amount: Scalars['Float'];
  areaCovered?: InputMaybe<Array<Scalars['String']>>;
  blocked?: InputMaybe<Scalars['Boolean']>;
  cardName: Scalars['String'];
  cityId?: InputMaybe<Scalars['Float']>;
  commission?: InputMaybe<Scalars['Float']>;
  companyName?: InputMaybe<Scalars['String']>;
  creatorId?: InputMaybe<Scalars['String']>;
  creditControlNotes?: InputMaybe<Scalars['String']>;
  currency: Scalars['String'];
  documents?: InputMaybe<Array<Scalars['Upload']>>;
  email: Scalars['String'];
  emailConfirmationLink?: InputMaybe<Scalars['String']>;
  errorPath: Scalars['String'];
  failureUrl: Scalars['String'];
  fullName?: InputMaybe<Scalars['String']>;
  image?: InputMaybe<Scalars['Upload']>;
  insuranceExpiryDate?: InputMaybe<Scalars['DateTime']>;
  invoiceEmailList?: InputMaybe<Scalars['String']>;
  invoiceNotes?: InputMaybe<Scalars['String']>;
  isB2B?: InputMaybe<Scalars['Int']>;
  isCongestionCharged?: InputMaybe<Scalars['Boolean']>;
  isDayRate?: InputMaybe<Scalars['Boolean']>;
  isHourly?: InputMaybe<Scalars['Boolean']>;
  isLandlordInvoicing?: InputMaybe<Scalars['Boolean']>;
  isNewClientPrice?: InputMaybe<Scalars['Boolean']>;
  isParkingCharged?: InputMaybe<Scalars['Boolean']>;
  jobTitle: Scalars['String'];
  jobUpdatesEmailList?: InputMaybe<Scalars['String']>;
  notes?: InputMaybe<Scalars['String']>;
  password?: InputMaybe<Scalars['String']>;
  paymentMethodId: Scalars['String'];
  paymentTerms?: InputMaybe<Scalars['Float']>;
  permissions?: InputMaybe<Array<Scalars['String']>>;
  phoneNumber?: InputMaybe<Scalars['String']>;
  qualificationDocuments?: InputMaybe<Array<Scalars['Upload']>>;
  qualificationExpiryDate?: InputMaybe<Scalars['DateTime']>;
  rating?: InputMaybe<Scalars['String']>;
  roles?: InputMaybe<Array<Scalars['String']>>;
  shiftOptions?: InputMaybe<Array<Scalars['String']>>;
  skillList?: InputMaybe<Array<Scalars['Int']>>;
  stripePriceId: Scalars['String'];
  successUrl: Scalars['String'];
  tncAcceptedList?: InputMaybe<Array<TncAcceptedItemInput>>;
};

export type CreatePaymentIntentInput = {
  amount: Scalars['Float'];
  currency: Scalars['String'];
};

export type CreatePaymentIntentPayload = {
  __typename?: 'CreatePaymentIntentPayload';
  clientSecret?: Maybe<Scalars['String']>;
  errors?: Maybe<Array<Error>>;
};

export type CreateProfileInput = {
  address?: InputMaybe<Scalars['String']>;
  adminPassword?: InputMaybe<Scalars['String']>;
  areaCovered?: InputMaybe<Array<Scalars['String']>>;
  blocked?: InputMaybe<Scalars['Boolean']>;
  cityId?: InputMaybe<Scalars['Float']>;
  commission?: InputMaybe<Scalars['Float']>;
  companyName?: InputMaybe<Scalars['String']>;
  creatorId?: InputMaybe<Scalars['String']>;
  creditControlNotes?: InputMaybe<Scalars['String']>;
  documents?: InputMaybe<Array<Scalars['Upload']>>;
  email: Scalars['String'];
  emailConfirmationLink?: InputMaybe<Scalars['String']>;
  errorPath: Scalars['String'];
  fullName?: InputMaybe<Scalars['String']>;
  image?: InputMaybe<Scalars['Upload']>;
  insuranceExpiryDate?: InputMaybe<Scalars['DateTime']>;
  invoiceEmailList?: InputMaybe<Scalars['String']>;
  invoiceNotes?: InputMaybe<Scalars['String']>;
  isB2B?: InputMaybe<Scalars['Int']>;
  isCongestionCharged?: InputMaybe<Scalars['Boolean']>;
  isDayRate?: InputMaybe<Scalars['Boolean']>;
  isHourly?: InputMaybe<Scalars['Boolean']>;
  isLandlordInvoicing?: InputMaybe<Scalars['Boolean']>;
  isNewClientPrice?: InputMaybe<Scalars['Boolean']>;
  isParkingCharged?: InputMaybe<Scalars['Boolean']>;
  jobUpdatesEmailList?: InputMaybe<Scalars['String']>;
  notes?: InputMaybe<Scalars['String']>;
  password?: InputMaybe<Scalars['String']>;
  paymentTerms?: InputMaybe<Scalars['Float']>;
  permissions?: InputMaybe<Array<Scalars['String']>>;
  phoneNumber?: InputMaybe<Scalars['String']>;
  qualificationDocuments?: InputMaybe<Array<Scalars['Upload']>>;
  qualificationExpiryDate?: InputMaybe<Scalars['DateTime']>;
  rating?: InputMaybe<Scalars['String']>;
  roles?: InputMaybe<Array<Scalars['String']>>;
  shiftOptions?: InputMaybe<Array<Scalars['String']>>;
  skillList?: InputMaybe<Array<Scalars['Int']>>;
  tncAcceptedList?: InputMaybe<Array<TncAcceptedItemInput>>;
};

export type CreateQuoteInput = {
  beforeImageFiles?: InputMaybe<Array<Scalars['Upload']>>;
  beforeImages?: InputMaybe<Array<Scalars['String']>>;
  description?: InputMaybe<Scalars['String']>;
  documentFiles?: InputMaybe<Array<Scalars['Upload']>>;
  documents?: InputMaybe<Array<Scalars['String']>>;
  errorPath: Scalars['String'];
  id?: InputMaybe<Scalars['Int']>;
  imageFiles?: InputMaybe<Array<Scalars['Upload']>>;
  images?: InputMaybe<Array<Scalars['String']>>;
  inputRevenuesManually?: InputMaybe<Scalars['Boolean']>;
  isApproved?: InputMaybe<Scalars['Boolean']>;
  isJobReport?: InputMaybe<Scalars['Boolean']>;
  labourCost?: InputMaybe<Scalars['Float']>;
  labourHours?: InputMaybe<Scalars['Float']>;
  labourRevenue?: InputMaybe<Scalars['Float']>;
  materialCost?: InputMaybe<Scalars['Float']>;
  materialQuotes?: InputMaybe<Array<MeterialQuoteInput>>;
  materialRevenue?: InputMaybe<Scalars['Float']>;
  netProfit?: InputMaybe<Scalars['Float']>;
  netRevenues?: InputMaybe<Scalars['Float']>;
  otherCost?: InputMaybe<Scalars['Float']>;
  otherRevenue?: InputMaybe<Scalars['Float']>;
  parkingCost?: InputMaybe<Scalars['Float']>;
  parkingImageFiles?: InputMaybe<Array<Scalars['Upload']>>;
  parkingImages?: InputMaybe<Array<Scalars['String']>>;
  parkingRevenue?: InputMaybe<Scalars['Float']>;
  profit?: InputMaybe<Scalars['Float']>;
  quoteDescription?: InputMaybe<Scalars['String']>;
  quoteJobId?: InputMaybe<Scalars['Int']>;
  reasonForManualPricing?: InputMaybe<Scalars['String']>;
  reportJobId?: InputMaybe<Scalars['Int']>;
  supplierJobStatusId?: InputMaybe<Scalars['Float']>;
  totalCost?: InputMaybe<Scalars['Float']>;
  totalRevenues?: InputMaybe<Scalars['Float']>;
  videoFiles?: InputMaybe<Array<Scalars['Upload']>>;
  videos?: InputMaybe<Array<Scalars['String']>>;
};

export type CreateRemoteQuoteInput = {
  address: Scalars['String'];
  details: Scalars['String'];
  email: Scalars['String'];
  errorPath: Scalars['String'];
  fullName: Scalars['String'];
  images?: InputMaybe<Array<Scalars['Upload']>>;
  videos?: InputMaybe<Array<Scalars['Upload']>>;
};

export type CreateReviewInput = {
  jobId?: InputMaybe<Scalars['Float']>;
  qeeperComments?: InputMaybe<Scalars['String']>;
  qeeperFeedbackDetails?: InputMaybe<Scalars['String']>;
  qeeperFeedbackRating?: InputMaybe<Scalars['Float']>;
  reviewStatus?: InputMaybe<Scalars['String']>;
  supplierFeedbackDetails?: InputMaybe<Scalars['String']>;
  supplierFeedbackRating?: InputMaybe<Scalars['Float']>;
};

export type CreateSkillInput = {
  enabled?: InputMaybe<Scalars['Boolean']>;
  errorPath: Scalars['String'];
  icon: Scalars['String'];
  iconName: Scalars['String'];
  name: Scalars['String'];
};

export type CreateSubcategoryInput = {
  errorPath: Scalars['String'];
  id: Scalars['Float'];
  name: Scalars['String'];
  problemCategoryId: Scalars['Float'];
  skillId: Scalars['Float'];
};

export type CreateTagInput = {
  errorPath: Scalars['String'];
  name: Scalars['String'];
};

export type CreateTrackingCategoriesInput = {
  pageNumber?: InputMaybe<Scalars['Int']>;
};

export type CursorPayload = {
  __typename?: 'CursorPayload';
  date: Scalars['DateTime'];
  id: Scalars['String'];
  score: Scalars['Float'];
};

export type DeleteReviewInput = {
  jobId?: InputMaybe<Scalars['Float']>;
};

export type Error = {
  __typename?: 'Error';
  message: Array<Scalars['String']>;
  path: Scalars['String'];
};

export type ErrorLog = {
  __typename?: 'ErrorLog';
  author?: Maybe<Profile>;
  authorId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  details?: Maybe<Scalars['String']>;
  id: Scalars['Float'];
};

export type ErrorPayload = {
  __typename?: 'ErrorPayload';
  errors?: Maybe<Array<Error>>;
};

export type Feedback = {
  __typename?: 'Feedback';
  createdAt?: Maybe<Scalars['DateTime']>;
  id: Scalars['Float'];
  message: Scalars['String'];
  sender?: Maybe<Profile>;
  senderId?: Maybe<Scalars['ID']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type FeedbackListPayload = {
  __typename?: 'FeedbackListPayload';
  feedbackList?: Maybe<Array<Feedback>>;
};

export type FindJobItemInput = {
  jobId?: InputMaybe<Scalars['Float']>;
  slug?: InputMaybe<Scalars['String']>;
};

export type FirstTimeIssue = {
  __typename?: 'FirstTimeIssue';
  firstTimeFixJobs: Scalars['Float'];
  supplierName?: Maybe<Scalars['String']>;
  totalJobs: Scalars['Float'];
};

export type FirstTimeIssueResolveInput = {
  creatorId?: InputMaybe<Scalars['String']>;
  dateType?: InputMaybe<Scalars['String']>;
  endDate: Scalars['DateTime'];
  skillId?: InputMaybe<Scalars['Int']>;
  startDate: Scalars['DateTime'];
};

export type FirstTimeIssueResolvePayload = {
  __typename?: 'FirstTimeIssueResolvePayload';
  dataList?: Maybe<Array<FirstTimeIssue>>;
  errors?: Maybe<Array<Error>>;
};

export type ForgotPasswordConfirmEmailInput = {
  emailConfirmationLink: Scalars['String'];
  token: Scalars['String'];
};

export type ForgotPasswordConfirmEmailPayload = {
  __typename?: 'ForgotPasswordConfirmEmailPayload';
  errors?: Maybe<Array<Error>>;
  profileId?: Maybe<Scalars['String']>;
};

export type ForgotPasswordSendEmailInput = {
  email: Scalars['String'];
  emailConfirmationLink: Scalars['String'];
};

export type GetAllJobInvoiceEmailsPayload = {
  __typename?: 'GetAllJobInvoiceEmailsPayload';
  emailList?: Maybe<Scalars['String']>;
};

export type History = {
  __typename?: 'History';
  createdAt?: Maybe<Scalars['DateTime']>;
  id: Scalars['Float'];
  newValue?: Maybe<Scalars['JSON']>;
  oldValue?: Maybe<Scalars['JSON']>;
  operation: Scalars['String'];
  primaryId: Scalars['String'];
  tableName?: Maybe<Scalars['String']>;
};

export type HistoryResultObject = {
  __typename?: 'HistoryResultObject';
  createdAt?: Maybe<Scalars['DateTime']>;
  id: Scalars['Float'];
  newValue?: Maybe<Scalars['JSON']>;
  oldValue?: Maybe<Scalars['JSON']>;
  operation: Scalars['String'];
  primaryId: Scalars['String'];
  result: Scalars['String'];
  tableName?: Maybe<Scalars['String']>;
};

export type IAccessTokenList = {
  enabled: Scalars['Boolean'];
  token: Scalars['String'];
};

export type ICityProfilePrice = {
  dayServicePrice?: InputMaybe<Scalars['Float']>;
  fixedPrice?: InputMaybe<Scalars['Float']>;
  problemSubcategoryId: Scalars['Float'];
  servicePrice: Scalars['Float'];
};

export type IInvoiceList = {
  __typename?: 'IInvoiceList';
  id: Scalars['Int'];
  invoiceId: Scalars['String'];
  invoiceStatus: Scalars['String'];
  referenceId: Scalars['String'];
  title: Scalars['String'];
};

export type IJobTimeSlot = {
  date: Scalars['String'];
  slots: Array<Scalars['Int']>;
};

export type InvoiceSentHrs = {
  __typename?: 'InvoiceSentHrs';
  count?: Maybe<Scalars['Int']>;
  hours: Scalars['String'];
  name?: Maybe<Scalars['String']>;
};

export type InvoiceSentHrsInput = {
  dateType?: InputMaybe<Scalars['String']>;
  endDate: Scalars['DateTime'];
  startDate: Scalars['DateTime'];
};

export type InvoiceSentPayload = {
  __typename?: 'InvoiceSentPayload';
  dataList?: Maybe<Array<InvoiceSentHrs>>;
  errors?: Maybe<Array<Error>>;
};

export type Job = {
  __typename?: 'Job';
  address?: Maybe<Scalars['String']>;
  adminJobReportNotes?: Maybe<Scalars['String']>;
  author?: Maybe<Profile>;
  authorId?: Maybe<Scalars['String']>;
  b2cNotes?: Maybe<Scalars['String']>;
  chatCheckedAdmin?: Maybe<Scalars['DateTime']>;
  chatCheckedSupplier?: Maybe<Scalars['DateTime']>;
  chatMessages?: Maybe<Array<ChatMessage>>;
  city?: Maybe<City>;
  cityId?: Maybe<Scalars['Float']>;
  client?: Maybe<Profile>;
  clientCost?: Maybe<Scalars['Float']>;
  clientEmailStartedAt?: Maybe<Scalars['DateTime']>;
  clientId?: Maybe<Scalars['String']>;
  clientReview?: Maybe<Review>;
  completionDocuments?: Maybe<Array<Scalars['String']>>;
  completionImages?: Maybe<Array<Scalars['String']>>;
  completionNotes?: Maybe<Scalars['String']>;
  completionVideos?: Maybe<Array<Scalars['String']>>;
  createdAt?: Maybe<Scalars['DateTime']>;
  details?: Maybe<Scalars['String']>;
  id: Scalars['Float'];
  images?: Maybe<Array<Scalars['String']>>;
  internalNotes?: Maybe<Scalars['String']>;
  invoiceEmailList?: Maybe<Scalars['String']>;
  invoiceRef?: Maybe<Scalars['String']>;
  invoiceSentAt?: Maybe<Scalars['DateTime']>;
  invoiceSentBy?: Maybe<Scalars['String']>;
  invoiceStatusCode?: Maybe<Scalars['String']>;
  isClientAgreedForOOH?: Maybe<Scalars['Boolean']>;
  isParkingVAT?: Maybe<Scalars['Boolean']>;
  isRemedialQuote?: Maybe<Scalars['Boolean']>;
  isRemoteQuote?: Maybe<Scalars['Boolean']>;
  jobAcceptedAt?: Maybe<Scalars['DateTime']>;
  jobReport?: Maybe<Quote>;
  jobReportId?: Maybe<Scalars['Int']>;
  jobReportSubmitted?: Maybe<Scalars['DateTime']>;
  jobStatus?: Maybe<JobStatus>;
  jobStatusId?: Maybe<Scalars['Float']>;
  jobUpdatesEmailList?: Maybe<Scalars['String']>;
  labourCost?: Maybe<Scalars['Float']>;
  labourRevenue?: Maybe<Scalars['Float']>;
  location?: Maybe<PointObject>;
  materialCost?: Maybe<Scalars['Float']>;
  materialRevenue?: Maybe<Scalars['Float']>;
  netRevenues?: Maybe<Scalars['Float']>;
  onlineInvoiceUrl?: Maybe<Scalars['String']>;
  otherCost?: Maybe<Scalars['Float']>;
  otherRevenue?: Maybe<Scalars['Float']>;
  parkingCost?: Maybe<Scalars['Float']>;
  parkingRevenue?: Maybe<Scalars['Float']>;
  postCode?: Maybe<Scalars['String']>;
  preferredSupplierList?: Maybe<Array<Profile>>;
  problemCategory?: Maybe<ProblemCategory>;
  problemCategoryId?: Maybe<Scalars['Float']>;
  problemSubcategory?: Maybe<ProblemSubcategory>;
  problemSubcategoryId?: Maybe<Scalars['Float']>;
  profile?: Maybe<Profile>;
  profileId?: Maybe<Scalars['String']>;
  profit?: Maybe<Scalars['Float']>;
  propertyAccess?: Maybe<Scalars['String']>;
  publishedToApp?: Maybe<Scalars['Boolean']>;
  quotes?: Maybe<Array<Quote>>;
  referenceId?: Maybe<Scalars['String']>;
  remedialNotes?: Maybe<Scalars['String']>;
  skillList?: Maybe<Array<Skill>>;
  slotDuration?: Maybe<Scalars['Int']>;
  slug?: Maybe<Scalars['String']>;
  startTime?: Maybe<Scalars['DateTime']>;
  startTimeSlots?: Maybe<Array<JobTimeSlot>>;
  supplier?: Maybe<Profile>;
  supplierCost?: Maybe<Scalars['Float']>;
  supplierId?: Maybe<Scalars['String']>;
  supplierJobStatus?: Maybe<JobStatus>;
  supplierJobStatusId?: Maybe<Scalars['Float']>;
  tagList?: Maybe<Array<Tag>>;
  title?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  videos?: Maybe<Array<Scalars['String']>>;
  xeroInvoiceId?: Maybe<Scalars['String']>;
};

export type JobApprovalSupplier = {
  __typename?: 'JobApprovalSupplier';
  approved: Scalars['Float'];
  date?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  unapproved: Scalars['Float'];
};

export type JobApprovalSupplierInput = {
  creatorId?: InputMaybe<Scalars['String']>;
  dateType?: InputMaybe<Scalars['String']>;
  endDate: Scalars['DateTime'];
  skillId?: InputMaybe<Scalars['Int']>;
  startDate: Scalars['DateTime'];
};

export type JobApprovalSupplierPayload = {
  __typename?: 'JobApprovalSupplierPayload';
  dataList?: Maybe<Array<JobApprovalSupplier>>;
  errors?: Maybe<Array<Error>>;
};

export type JobChatListInput = {
  limit?: InputMaybe<Scalars['Int']>;
  supplierId?: InputMaybe<Scalars['String']>;
};

export type JobChatListPayload = {
  __typename?: 'JobChatListPayload';
  chatList?: Maybe<Array<ChatMessage>>;
  cursor?: Maybe<CursorPayload>;
  hasMore: Scalars['Boolean'];
};

export type JobCityProfilePriceDetailsInput = {
  jobId: Scalars['Float'];
};

export type JobCompletion = {
  __typename?: 'JobCompletion';
  month: Scalars['String'];
  status: Scalars['String'];
};

export type JobCompletionPayload = {
  __typename?: 'JobCompletionPayload';
  dataList?: Maybe<Array<JobCompletion>>;
  errors?: Maybe<Array<Error>>;
};

export type JobCountInput = {
  __typename?: 'JobCountInput';
  count: Scalars['Float'];
  month: Scalars['String'];
};

export type JobCountInputPayload = {
  __typename?: 'JobCountInputPayload';
  dataList?: Maybe<Array<JobCountInput>>;
  errors?: Maybe<Array<Error>>;
};

export type JobDetailsInput = {
  jobId?: InputMaybe<Scalars['Float']>;
  limit?: InputMaybe<Scalars['Float']>;
  slug?: InputMaybe<Scalars['String']>;
};

export type JobNotes = {
  __typename?: 'JobNotes';
  createdAt?: Maybe<Scalars['DateTime']>;
  createdBy?: Maybe<Scalars['String']>;
  text: Scalars['String'];
};

export type JobNotesInput = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  createdBy?: InputMaybe<Scalars['String']>;
  text: Scalars['String'];
};

export type JobPayload = {
  __typename?: 'JobPayload';
  errors?: Maybe<Array<Error>>;
  job?: Maybe<Job>;
};

export type JobReportSubmissionTime = {
  __typename?: 'JobReportSubmissionTime';
  count?: Maybe<Scalars['Int']>;
  hours: Scalars['String'];
  name?: Maybe<Scalars['String']>;
};

export type JobReportSubmissionTimeInput = {
  dateType?: InputMaybe<Scalars['String']>;
  endDate: Scalars['DateTime'];
  startDate: Scalars['DateTime'];
};

export type JobReportSubmissionTimePayload = {
  __typename?: 'JobReportSubmissionTimePayload';
  dataList?: Maybe<Array<JobReportSubmissionTime>>;
  errors?: Maybe<Array<Error>>;
};

export type JobReviewListInput = {
  clientId?: InputMaybe<Scalars['String']>;
};

export type JobStatus = {
  __typename?: 'JobStatus';
  description?: Maybe<Scalars['String']>;
  enabled?: Maybe<Scalars['Boolean']>;
  id: Scalars['Float'];
  profileId?: Maybe<Scalars['String']>;
  roleId?: Maybe<Scalars['Float']>;
  title: Scalars['String'];
};

export type JobStatusListPayload = {
  __typename?: 'JobStatusListPayload';
  jobStatusList?: Maybe<Array<JobStatus>>;
};

export type JobStatusPayload = {
  __typename?: 'JobStatusPayload';
  errors?: Maybe<Array<Error>>;
  jobStatus?: Maybe<JobStatus>;
};

export type JobTimeSlot = {
  __typename?: 'JobTimeSlot';
  date: Scalars['String'];
  slots: Array<Scalars['Int']>;
};

export type ListJobPayload = {
  __typename?: 'ListJobPayload';
  jobList?: Maybe<Array<Job>>;
};

export type LoginInput = {
  email: Scalars['String'];
  password: Scalars['String'];
};

export type LogoutAppInput = {
  notiToken?: InputMaybe<Scalars['String']>;
};

export type MarkJobReportAndInvoiceSentManuallyInput = {
  errorPath: Scalars['String'];
  jobId?: InputMaybe<Scalars['Float']>;
};

export type MeterialQuote = {
  __typename?: 'MeterialQuote';
  materialCost?: Maybe<Scalars['Float']>;
  materialRevenues?: Maybe<Scalars['Float']>;
  materialText: Scalars['String'];
};

export type MeterialQuoteInput = {
  materialCost?: InputMaybe<Scalars['Float']>;
  materialRevenues?: InputMaybe<Scalars['Float']>;
  materialText: Scalars['String'];
};

export type Mutation = {
  __typename?: 'Mutation';
  acceptJob: JobPayload;
  addChatMessage: AddChatMessagePayload;
  addCity: CityPayload;
  approveQuote?: Maybe<QuotePayload>;
  blockAllSuppliers: Scalars['Boolean'];
  changePassword?: Maybe<ProfilePayload>;
  chatChecked: Scalars['Boolean'];
  cleanNotifications: Scalars['Boolean'];
  confirmEmail?: Maybe<ErrorPayload>;
  copyInvoiceEmailToJobUpdate: Scalars['Boolean'];
  copyQuoteToNewQuote: Scalars['Boolean'];
  copyTncHistory: Scalars['Boolean'];
  copyUnattachedQuoteToJob: SearchJobListPayload;
  createAccessToken: CreateAccessTokenPayload;
  createB2BClientProfile: ProfilePayload;
  createB2CClientProfile: ProfilePayload;
  createBooking?: Maybe<JobPayload>;
  createCategory?: Maybe<ErrorPayload>;
  createCityPrice?: Maybe<ErrorPayload>;
  createCityProfilePrice: ErrorPayload;
  createClientProfile: ProfilePayload;
  createComment?: Maybe<Scalars['String']>;
  createFeedback: CreateFeedbackPayload;
  createJob?: Maybe<JobPayload>;
  createJobApi?: Maybe<JobPayload>;
  createJobStatus: JobStatusPayload;
  createPaymentIntent?: Maybe<CreatePaymentIntentPayload>;
  createProfile: ProfilePayload;
  createQuote?: Maybe<QuotePayload>;
  createRemoteQuote?: Maybe<ErrorPayload>;
  createReview?: Maybe<ReviewPayload>;
  createSkill: TagPayload;
  createSubcategory?: Maybe<ErrorPayload>;
  createSubscription: PaymentPayload;
  createTrackingCategories: Scalars['Float'];
  deleteInvoice: ErrorPayload;
  deleteReviews?: Maybe<Scalars['Boolean']>;
  enableAllSuppliersAccess: Scalars['Boolean'];
  forgotPasswordConfirmEmail?: Maybe<ForgotPasswordConfirmEmailPayload>;
  forgotPasswordSendEmail?: Maybe<ErrorPayload>;
  includeCommissionInRevenues: Scalars['Boolean'];
  jobUpdateAdminJobList?: Maybe<JobPayload>;
  login: ProfilePayload;
  logout: Scalars['Boolean'];
  logoutApp: Scalars['Boolean'];
  markJobReportAndInvoiceSentManually: ErrorPayload;
  markSkillsEnabled: Scalars['Boolean'];
  register: ProfilePayload;
  resetPassword?: Maybe<ErrorPayload>;
  saveTokenToProfile: ErrorPayload;
  sendInvoice: ErrorPayload;
  setJobReportToNull: Scalars['Boolean'];
  tempProfile: Scalars['Boolean'];
  tempUpdateNetRevenues: Scalars['Boolean'];
  tempXeroCreateTrackingCategory: Scalars['Boolean'];
  updateCity: CityPayload;
  updateCityPrice?: Maybe<ErrorPayload>;
  updateCityProfilePrice: ErrorPayload;
  updateInvoiceFieldsForJob?: Maybe<JobPayload>;
  updateJob?: Maybe<JobPayload>;
  updateJobCompDoc: Scalars['Boolean'];
  updateJobFilesSupplier?: Maybe<JobPayload>;
  updateJobReportForJob: Scalars['Boolean'];
  updateJobStatus: JobStatusPayload;
  updateJobSupplier?: Maybe<JobPayload>;
  updateJobTags: Scalars['Boolean'];
  updatePartialJob?: Maybe<JobPayload>;
  updateProfile: ProfilePayload;
  updateQuote?: Maybe<QuotePayload>;
  updateQuoteAsPerJobReport: Scalars['Boolean'];
  updateSkill: SkillPayload;
  xeroAccounts: Scalars['Boolean'];
  xeroCreateInvoice: CreateInvoicePayload;
  xeroFetchInvoiceUrl: Scalars['Boolean'];
  xeroInvoice: Scalars['Boolean'];
};


export type MutationAcceptJobArgs = {
  input: AcceptJobInput;
};


export type MutationAddChatMessageArgs = {
  input: AddChatMessageInput;
};


export type MutationAddCityArgs = {
  input: AddCityInput;
};


export type MutationApproveQuoteArgs = {
  input: ApproveQuoteInput;
};


export type MutationChangePasswordArgs = {
  input: ChangePasswordInput;
};


export type MutationChatCheckedArgs = {
  input: ChatCheckedInput;
};


export type MutationConfirmEmailArgs = {
  input: ConfirmEmailInput;
};


export type MutationCopyQuoteToNewQuoteArgs = {
  input: CopyQuoteToNewQuoteInput;
};


export type MutationCopyUnattachedQuoteToJobArgs = {
  input: CopyUnattachedQuoteToJobInput;
};


export type MutationCreateB2BClientProfileArgs = {
  input: CreateProfileInput;
};


export type MutationCreateB2CClientProfileArgs = {
  input: CreateB2CClientProfileInput;
};


export type MutationCreateBookingArgs = {
  input: CreateBookingInput;
};


export type MutationCreateCategoryArgs = {
  input: CreateCategoryInput;
};


export type MutationCreateCityPriceArgs = {
  input: CreateCityPriceInput;
};


export type MutationCreateCityProfilePriceArgs = {
  input: CreateCityProfilePriceInput;
};


export type MutationCreateClientProfileArgs = {
  input: CreateProfileInput;
};


export type MutationCreateFeedbackArgs = {
  input: CreateFeedbackInput;
};


export type MutationCreateJobArgs = {
  input: UpdateJobInput;
};


export type MutationCreateJobApiArgs = {
  input: UpdateJobInput;
};


export type MutationCreateJobStatusArgs = {
  input: CreateJobStatusInput;
};


export type MutationCreatePaymentIntentArgs = {
  input: CreatePaymentIntentInput;
};


export type MutationCreateProfileArgs = {
  input: CreateProfileInput;
};


export type MutationCreateQuoteArgs = {
  input: CreateQuoteInput;
};


export type MutationCreateRemoteQuoteArgs = {
  input: CreateRemoteQuoteInput;
};


export type MutationCreateReviewArgs = {
  input: CreateReviewInput;
};


export type MutationCreateSkillArgs = {
  input: CreateTagInput;
};


export type MutationCreateSubcategoryArgs = {
  input: CreateSubcategoryInput;
};


export type MutationCreateSubscriptionArgs = {
  input: CreatePaymentInput;
};


export type MutationCreateTrackingCategoriesArgs = {
  input: CreateTrackingCategoriesInput;
};


export type MutationDeleteInvoiceArgs = {
  input: SendInvoiceInput;
};


export type MutationDeleteReviewsArgs = {
  input: DeleteReviewInput;
};


export type MutationForgotPasswordConfirmEmailArgs = {
  input: ForgotPasswordConfirmEmailInput;
};


export type MutationForgotPasswordSendEmailArgs = {
  input: ForgotPasswordSendEmailInput;
};


export type MutationIncludeCommissionInRevenuesArgs = {
  input: TempJobInput;
};


export type MutationJobUpdateAdminJobListArgs = {
  input: UpdateJobInput;
};


export type MutationLoginArgs = {
  input: LoginInput;
};


export type MutationLogoutAppArgs = {
  input: LogoutAppInput;
};


export type MutationMarkJobReportAndInvoiceSentManuallyArgs = {
  input: MarkJobReportAndInvoiceSentManuallyInput;
};


export type MutationRegisterArgs = {
  input: RegisterInput;
};


export type MutationResetPasswordArgs = {
  input: ResetPasswordInput;
};


export type MutationSaveTokenToProfileArgs = {
  input: SaveTokenToProfileInput;
};


export type MutationSendInvoiceArgs = {
  input: SendInvoiceInput;
};


export type MutationSetJobReportToNullArgs = {
  input: SetJobReportToNullInput;
};


export type MutationTempUpdateNetRevenuesArgs = {
  input: TempUpdateNetRevenuesInput;
};


export type MutationTempXeroCreateTrackingCategoryArgs = {
  input: UpdateProfileInput;
};


export type MutationUpdateCityArgs = {
  input: UpdateCityInput;
};


export type MutationUpdateCityPriceArgs = {
  input: UpdateCityPriceInput;
};


export type MutationUpdateCityProfilePriceArgs = {
  input: CreateCityProfilePriceInput;
};


export type MutationUpdateInvoiceFieldsForJobArgs = {
  input: UpdateInvoiceFieldsForJobInput;
};


export type MutationUpdateJobArgs = {
  input: UpdateJobInput;
};


export type MutationUpdateJobCompDocArgs = {
  input: UpdateJobCompDocInput;
};


export type MutationUpdateJobFilesSupplierArgs = {
  input: UpdateJobFilesSupplierInput;
};


export type MutationUpdateJobReportForJobArgs = {
  input: UpdateJobReportForJobInput;
};


export type MutationUpdateJobStatusArgs = {
  input: UpdateJobStatusInput;
};


export type MutationUpdateJobSupplierArgs = {
  input: UpdateJobSupplierInput;
};


export type MutationUpdateJobTagsArgs = {
  input: UpdateJobTagsInput;
};


export type MutationUpdatePartialJobArgs = {
  input: UpdateJobInput;
};


export type MutationUpdateProfileArgs = {
  input: UpdateProfileInput;
};


export type MutationUpdateQuoteArgs = {
  input: UpdateQuoteInput;
};


export type MutationUpdateQuoteAsPerJobReportArgs = {
  input: UpdateQuoteAsPerJobReportInput;
};


export type MutationUpdateSkillArgs = {
  input: UpdateSkillInput;
};


export type MutationXeroCreateInvoiceArgs = {
  input: XeroCreateInvoiceInput;
};

export type NoShowJobStatus = {
  __typename?: 'NoShowJobStatus';
  count: Scalars['Float'];
  suppliername?: Maybe<Scalars['String']>;
};

export type NoShowJobStatusPayload = {
  __typename?: 'NoShowJobStatusPayload';
  dataList?: Maybe<Array<NoShowJobStatus>>;
  errors?: Maybe<Array<Error>>;
};

export type OpsReportCount = {
  __typename?: 'OpsReportCount';
  count: Scalars['Float'];
  opsname?: Maybe<Scalars['String']>;
};

export type OpsReportCountInputPayload = {
  __typename?: 'OpsReportCountInputPayload';
  dataList?: Maybe<Array<OpsReportCount>>;
  errors?: Maybe<Array<Error>>;
};

export type PaymentPayload = {
  __typename?: 'PaymentPayload';
  errors?: Maybe<Array<Error>>;
  url?: Maybe<Scalars['String']>;
};

export type Permission = {
  __typename?: 'Permission';
  category?: Maybe<PermissionCategory>;
  categoryId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  enabled?: Maybe<Scalars['Boolean']>;
  id: Scalars['Float'];
  permissionType?: Maybe<PermissionType>;
  permissionTypeId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type PermissionCategory = {
  __typename?: 'PermissionCategory';
  createdAt?: Maybe<Scalars['DateTime']>;
  enabled?: Maybe<Scalars['Boolean']>;
  id: Scalars['String'];
  name: Scalars['String'];
  permissions?: Maybe<Array<Permission>>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type PermissionType = {
  __typename?: 'PermissionType';
  createdAt?: Maybe<Scalars['DateTime']>;
  enabled?: Maybe<Scalars['Boolean']>;
  id: Scalars['String'];
  name: Scalars['String'];
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type PiePayload = {
  __typename?: 'PiePayload';
  approved: Scalars['Float'];
  unapproved: Scalars['Float'];
};

/** Point Object */
export type PointObject = {
  __typename?: 'PointObject';
  coordinates: Array<Scalars['Float']>;
  type: Scalars['String'];
};

export type ProblemCategory = {
  __typename?: 'ProblemCategory';
  createdAt?: Maybe<Scalars['DateTime']>;
  enabled?: Maybe<Scalars['Boolean']>;
  iconName?: Maybe<Scalars['String']>;
  id: Scalars['Float'];
  name?: Maybe<Scalars['String']>;
  problemSubcategoryConnection?: Maybe<Array<ProblemSubcategory>>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ProblemCategoryListPayload = {
  __typename?: 'ProblemCategoryListPayload';
  problemCategoryList?: Maybe<Array<ProblemCategory>>;
};

export type ProblemSubcategory = {
  __typename?: 'ProblemSubcategory';
  createdAt?: Maybe<Scalars['DateTime']>;
  enabled?: Maybe<Scalars['Boolean']>;
  id: Scalars['Float'];
  isFixed?: Maybe<Scalars['Boolean']>;
  isHourly?: Maybe<Scalars['Boolean']>;
  name?: Maybe<Scalars['String']>;
  problemCategory?: Maybe<ProblemCategory>;
  problemCategoryId?: Maybe<Scalars['Int']>;
  skill?: Maybe<Skill>;
  skillId?: Maybe<Scalars['Int']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type Profile = {
  __typename?: 'Profile';
  accessTokenList?: Maybe<Array<AccessToken>>;
  address?: Maybe<Scalars['String']>;
  areaCovered?: Maybe<Array<Scalars['String']>>;
  blocked?: Maybe<Scalars['Boolean']>;
  city?: Maybe<City>;
  cityId?: Maybe<Scalars['Float']>;
  commission?: Maybe<Scalars['Float']>;
  companyName?: Maybe<Scalars['String']>;
  confirmed?: Maybe<Scalars['Boolean']>;
  createdAt?: Maybe<Scalars['String']>;
  creator?: Maybe<Profile>;
  creatorId?: Maybe<Scalars['String']>;
  creditControlNotes?: Maybe<Scalars['String']>;
  documents?: Maybe<Array<Scalars['String']>>;
  email?: Maybe<Scalars['String']>;
  forgotPasswordLocked?: Maybe<Scalars['Boolean']>;
  fullName?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  image?: Maybe<Scalars['String']>;
  insuranceExpiryDate?: Maybe<Scalars['DateTime']>;
  invoiceEmailList?: Maybe<Scalars['String']>;
  invoiceNotes?: Maybe<Scalars['String']>;
  isAccepted?: Maybe<Scalars['Boolean']>;
  isB2B?: Maybe<Scalars['Float']>;
  isCongestionCharged?: Maybe<Scalars['Boolean']>;
  isDayRate?: Maybe<Scalars['Boolean']>;
  isHourly?: Maybe<Scalars['Boolean']>;
  isLandlordInvoicing?: Maybe<Scalars['Boolean']>;
  isNewClientPrice?: Maybe<Scalars['Boolean']>;
  isParkingCharged?: Maybe<Scalars['Boolean']>;
  isPreferred?: Maybe<Scalars['Boolean']>;
  jobUpdatesEmailList?: Maybe<Scalars['String']>;
  notes?: Maybe<Scalars['String']>;
  notiTokens?: Maybe<Array<Scalars['String']>>;
  paymentTerms?: Maybe<Scalars['Float']>;
  phoneNumber?: Maybe<Scalars['String']>;
  qualificationDocuments?: Maybe<Array<Scalars['String']>>;
  qualificationExpiryDate?: Maybe<Scalars['DateTime']>;
  rating?: Maybe<Scalars['String']>;
  refreshTokenVersion?: Maybe<Scalars['Float']>;
  reported?: Maybe<Scalars['Boolean']>;
  roleId?: Maybe<Scalars['Float']>;
  roles?: Maybe<Array<Role>>;
  secondaryEmails?: Maybe<Array<Scalars['String']>>;
  shiftOptions?: Maybe<Array<Scalars['String']>>;
  skillList?: Maybe<Array<Skill>>;
  stripeCustomerId?: Maybe<Scalars['String']>;
  tempBlocked?: Maybe<Scalars['Boolean']>;
  tncAcceptedAt?: Maybe<Scalars['DateTime']>;
  tncAcceptedAtHistory?: Maybe<Scalars['DateTime']>;
  tncAcceptedList?: Maybe<Array<TncAcceptedItem>>;
  trackingCategoryOptions?: Maybe<Array<TrackingOption>>;
  trackingOptionsIds?: Maybe<Array<Scalars['String']>>;
  unavailableDates?: Maybe<Array<Scalars['String']>>;
  updatedAt?: Maybe<Scalars['String']>;
  xeroContactId?: Maybe<Scalars['String']>;
};

export type ProfileDetailsInput = {
  profileId?: InputMaybe<Scalars['String']>;
};

export type ProfilePayload = {
  __typename?: 'ProfilePayload';
  accessToken?: Maybe<Scalars['String']>;
  errors?: Maybe<Array<Error>>;
  profile?: Maybe<Profile>;
};

export type Query = {
  __typename?: 'Query';
  adminChatViewJobDetails: JobPayload;
  adminJobCreationTimePie: AnalyticPiePayload;
  adminJobStatus: JobCompletionPayload;
  adminSearchJobList: SearchJobListPayload;
  analyticFinancial: AnalyticFinancialPayload;
  analyticIndividualRevenues: AnalyticIndividualRevenuesPayload;
  analyticJobApprovalClient: JobApprovalSupplierPayload;
  analyticJobApprovalClientPie: PiePayload;
  analyticJobApprovalSupplierPie: PiePayload;
  analyticJobCount: JobCountInputPayload;
  analyticJobList: SearchJobListPayload;
  analyticJobsByCity: AnalyticPiePayload;
  analyticJobsByClient: AnalyticPiePayload;
  analyticSkillList: AnalyticPiePayload;
  analyticSupplierlList: AnalyticPiePayload;
  appDetailsViewJobDetails: JobPayload;
  appHomeSearchJobList: SearchJobListPayload;
  appJobReportJobDetails: JobPayload;
  appMyJobList: SearchJobListPayload;
  appNewChatJobList: SearchJobListPayload;
  appTabsViewDetails: JobPayload;
  chatNotificationCount: Scalars['Float'];
  cityDetails?: Maybe<CityPayload>;
  cityProfilePriceDetails: CityProfilePriceDetailsPayload;
  clientSearchJobList: SearchJobListPayload;
  completionTime: CompletionTimePayload;
  feedbackList: FeedbackListPayload;
  findJobItem: JobPayload;
  firstTimeIssueResolve: FirstTimeIssueResolvePayload;
  firstTimeIssueResolvePie: AnalyticPiePayload;
  getAllJobInvoiceEmails: GetAllJobInvoiceEmailsPayload;
  getJobReviewDetails: JobPayload;
  invoiceJobDetails: JobPayload;
  invoiceSentHrs: InvoiceSentPayload;
  invoiceSentHrsTrackingPie: AnalyticPiePayload;
  jobApprovalSupplier: JobApprovalSupplierPayload;
  jobChatList: JobChatListPayload;
  jobCityProfilePriceDetails: CityProfilePriceDetailsPayload;
  jobCompletion: JobCompletionPayload;
  jobDetails: JobPayload;
  jobReportJobDetails: JobPayload;
  jobReportSubmissionTime: JobReportSubmissionTimePayload;
  jobReviewList: SearchJobListPayload;
  jobUpdateJobDetails: JobPayload;
  listJob: ListJobPayload;
  listSkill: Array<Skill>;
  me?: Maybe<ProfilePayload>;
  meAppTnC?: Maybe<ProfilePayload>;
  newProfileList: Scalars['Boolean'];
  noShowJobStatus: NoShowJobStatusPayload;
  opsJobOwner: OpsReportCountInputPayload;
  opsReportCount: OpsReportCountInputPayload;
  problemCategoryList: ProblemCategoryListPayload;
  profileDetails?: Maybe<UserPayload>;
  profileList: SearchProfileListPayload;
  quoteCreateJobDetails: JobPayload;
  quoteDetails: QuoteDetailsPayload;
  quoteUpdateJobDetails: JobPayload;
  remedialJobSearch: JobPayload;
  reportUpdateJobDetails: JobPayload;
  rescheduledJobStatus: JobCountInputPayload;
  rescheduledJobStatusByTP: NoShowJobStatusPayload;
  seachJobReport?: Maybe<JobPayload>;
  searchAccessTokenList: UserPayload;
  searchChatMessage: SearchChatMessagePayload;
  searchCityList: SearchCityListPayload;
  searchCityPrice: SearchCityPricePayload;
  searchCityProfilePrice: SearchCityProfilePricePayload;
  searchErrorLog: SearchErrorLogPayload;
  searchHistory: SearchHistoryPayload;
  searchInvoiceList: SearchInvoiceListPayload;
  searchJobList: SearchJobListPayload;
  searchJobStatusList: JobStatusListPayload;
  searchProfileList: SearchProfileListPayload;
  searchQuote: SearchQuotePayload;
  searchSkill: SearchSkillPayload;
  searchSupplierList: SearchProfileListPayload;
  supplierJobReportSubmissionTimePie: AnalyticPiePayload;
  supplierList: SearchProfileListPayload;
  supplierMargin: SupplierMarginPayload;
  supplierProfit: SupplierProfitlPayload;
  tagList: Array<Tag>;
  unscheduledJobStatusMore6hours: JobCountInputPayload;
  xeroTrackingOptions?: Maybe<Scalars['Boolean']>;
};


export type QueryAdminChatViewJobDetailsArgs = {
  input: JobDetailsInput;
};


export type QueryAdminJobCreationTimePieArgs = {
  input: AnalyticInput;
};


export type QueryAdminJobStatusArgs = {
  input: AnalyticInput;
};


export type QueryAdminSearchJobListArgs = {
  input: SeachJobListInput;
};


export type QueryAnalyticFinancialArgs = {
  input: AnalyticInput;
};


export type QueryAnalyticIndividualRevenuesArgs = {
  input: AnalyticIndividualRevenuesInput;
};


export type QueryAnalyticJobApprovalClientArgs = {
  input: JobApprovalSupplierInput;
};


export type QueryAnalyticJobApprovalClientPieArgs = {
  input: AnalyticInput;
};


export type QueryAnalyticJobApprovalSupplierPieArgs = {
  input: AnalyticInput;
};


export type QueryAnalyticJobCountArgs = {
  input: AnalyticInput;
};


export type QueryAnalyticJobListArgs = {
  input: AnalyticJobListInput;
};


export type QueryAnalyticJobsByCityArgs = {
  input: AnalyticInput;
};


export type QueryAnalyticJobsByClientArgs = {
  input: AnalyticInput;
};


export type QueryAnalyticSkillListArgs = {
  input: AnalyticInput;
};


export type QueryAnalyticSupplierlListArgs = {
  input: AnalyticInput;
};


export type QueryAppDetailsViewJobDetailsArgs = {
  input: JobDetailsInput;
};


export type QueryAppHomeSearchJobListArgs = {
  input: AppHomeSearchJobListInput;
};


export type QueryAppJobReportJobDetailsArgs = {
  input: JobDetailsInput;
};


export type QueryAppMyJobListArgs = {
  input: SeachJobListInput;
};


export type QueryAppNewChatJobListArgs = {
  input: SeachJobListInput;
};


export type QueryAppTabsViewDetailsArgs = {
  input: JobDetailsInput;
};


export type QueryCityDetailsArgs = {
  input: CityDetailsInput;
};


export type QueryCityProfilePriceDetailsArgs = {
  input: CityProfilePriceDetailsInput;
};


export type QueryClientSearchJobListArgs = {
  input: SeachJobListInput;
};


export type QueryCompletionTimeArgs = {
  input: AnalyticInput;
};


export type QueryFindJobItemArgs = {
  input: FindJobItemInput;
};


export type QueryFirstTimeIssueResolveArgs = {
  input: FirstTimeIssueResolveInput;
};


export type QueryFirstTimeIssueResolvePieArgs = {
  input: AnalyticInput;
};


export type QueryGetAllJobInvoiceEmailsArgs = {
  input: AnalyticInput;
};


export type QueryGetJobReviewDetailsArgs = {
  input: FindJobItemInput;
};


export type QueryInvoiceJobDetailsArgs = {
  input: JobDetailsInput;
};


export type QueryInvoiceSentHrsArgs = {
  input: InvoiceSentHrsInput;
};


export type QueryInvoiceSentHrsTrackingPieArgs = {
  input: AnalyticInput;
};


export type QueryJobApprovalSupplierArgs = {
  input: JobApprovalSupplierInput;
};


export type QueryJobChatListArgs = {
  input: JobChatListInput;
};


export type QueryJobCityProfilePriceDetailsArgs = {
  input: JobCityProfilePriceDetailsInput;
};


export type QueryJobCompletionArgs = {
  input: AnalyticInput;
};


export type QueryJobDetailsArgs = {
  input: JobDetailsInput;
};


export type QueryJobReportJobDetailsArgs = {
  input: JobDetailsInput;
};


export type QueryJobReportSubmissionTimeArgs = {
  input: JobReportSubmissionTimeInput;
};


export type QueryJobReviewListArgs = {
  input: JobReviewListInput;
};


export type QueryJobUpdateJobDetailsArgs = {
  input: JobDetailsInput;
};


export type QueryNoShowJobStatusArgs = {
  input: AnalyticInput;
};


export type QueryOpsJobOwnerArgs = {
  input: AnalyticInput;
};


export type QueryOpsReportCountArgs = {
  input: AnalyticInput;
};


export type QueryProfileDetailsArgs = {
  input: ProfileDetailsInput;
};


export type QueryProfileListArgs = {
  input: SearchProfileListInput;
};


export type QueryQuoteCreateJobDetailsArgs = {
  input: JobDetailsInput;
};


export type QueryQuoteDetailsArgs = {
  input: QuoteDetailsInput;
};


export type QueryQuoteUpdateJobDetailsArgs = {
  input: QuoteDetailsInput;
};


export type QueryRemedialJobSearchArgs = {
  input: RemedialJobSearchInput;
};


export type QueryReportUpdateJobDetailsArgs = {
  input: JobDetailsInput;
};


export type QueryRescheduledJobStatusArgs = {
  input: RescheduledJobStatusInput;
};


export type QueryRescheduledJobStatusByTpArgs = {
  input: RescheduledJobStatusByTpInput;
};


export type QuerySeachJobReportArgs = {
  input: SeachJobReportInput;
};


export type QuerySearchChatMessageArgs = {
  input: SearchChatMessageInput;
};


export type QuerySearchCityPriceArgs = {
  input: SearchCityPriceInput;
};


export type QuerySearchCityProfilePriceArgs = {
  input: SearchCityProfilePriceInput;
};


export type QuerySearchErrorLogArgs = {
  input: SearchErrorLogInput;
};


export type QuerySearchHistoryArgs = {
  input: SearchHistoryInput;
};


export type QuerySearchInvoiceListArgs = {
  input: SearchInvoiceListInput;
};


export type QuerySearchJobListArgs = {
  input: SeachJobListInput;
};


export type QuerySearchJobStatusListArgs = {
  input: StatusListInput;
};


export type QuerySearchProfileListArgs = {
  input: SearchProfileListInput;
};


export type QuerySearchQuoteArgs = {
  input: SearchQuoteInput;
};


export type QuerySearchSkillArgs = {
  input: SearchSkillInput;
};


export type QuerySearchSupplierListArgs = {
  input: SearchProfileListInput;
};


export type QuerySupplierJobReportSubmissionTimePieArgs = {
  input: AnalyticInput;
};


export type QuerySupplierListArgs = {
  input: SearchProfileListInput;
};


export type QuerySupplierMarginArgs = {
  input: AnalyticInput;
};


export type QuerySupplierProfitArgs = {
  input: SupplierProfitInput;
};


export type QueryUnscheduledJobStatusMore6hoursArgs = {
  input: UnscheduledJobStatusMore6hoursInput;
};

export type Quote = {
  __typename?: 'Quote';
  beforeImages?: Maybe<Array<Scalars['String']>>;
  clientLabourHours?: Maybe<Scalars['Float']>;
  description?: Maybe<Scalars['String']>;
  documents?: Maybe<Array<Scalars['String']>>;
  id: Scalars['Float'];
  images?: Maybe<Array<Scalars['String']>>;
  inputRevenuesManually?: Maybe<Scalars['Boolean']>;
  isApproved?: Maybe<Scalars['Boolean']>;
  isJobReport?: Maybe<Scalars['Boolean']>;
  labourCost?: Maybe<Scalars['Float']>;
  labourHours?: Maybe<Scalars['Float']>;
  labourRevenue?: Maybe<Scalars['Float']>;
  materialQuotes?: Maybe<Array<MeterialQuote>>;
  materialRevenue?: Maybe<Scalars['Float']>;
  netProfit?: Maybe<Scalars['Float']>;
  netRevenues?: Maybe<Scalars['Float']>;
  otherCost?: Maybe<Scalars['Float']>;
  otherRevenue?: Maybe<Scalars['Float']>;
  parkingCost?: Maybe<Scalars['Float']>;
  parkingImages?: Maybe<Array<Scalars['String']>>;
  parkingRevenue?: Maybe<Scalars['Float']>;
  profileId?: Maybe<Scalars['String']>;
  profit?: Maybe<Scalars['Float']>;
  quoteDescription?: Maybe<Scalars['String']>;
  quoteJob?: Maybe<Job>;
  quoteJobId?: Maybe<Scalars['Int']>;
  reasonForManualPricing?: Maybe<Scalars['String']>;
  reportJob?: Maybe<Job>;
  reportJobId?: Maybe<Scalars['Int']>;
  totalCost?: Maybe<Scalars['Float']>;
  totalRevenues?: Maybe<Scalars['Float']>;
  videos?: Maybe<Array<Scalars['String']>>;
};

export type QuoteDetailsInput = {
  quoteId?: InputMaybe<Scalars['Float']>;
  quoteJobId?: InputMaybe<Scalars['Float']>;
  reportJobId?: InputMaybe<Scalars['Float']>;
};

export type QuoteDetailsPayload = {
  __typename?: 'QuoteDetailsPayload';
  quote?: Maybe<Quote>;
};

export type QuoteInput = {
  beforeImages?: InputMaybe<Array<Scalars['String']>>;
  description?: InputMaybe<Scalars['String']>;
  documents?: InputMaybe<Array<Scalars['String']>>;
  id?: InputMaybe<Scalars['Int']>;
  images?: InputMaybe<Array<Scalars['String']>>;
  inputRevenuesManually?: InputMaybe<Scalars['Boolean']>;
  isApproved?: InputMaybe<Scalars['Boolean']>;
  isJobReport?: InputMaybe<Scalars['Boolean']>;
  labourCost?: InputMaybe<Scalars['Float']>;
  labourHours?: InputMaybe<Scalars['Float']>;
  labourRevenue?: InputMaybe<Scalars['Float']>;
  materialCost?: InputMaybe<Scalars['Float']>;
  materialQuotes?: InputMaybe<Array<MeterialQuoteInput>>;
  materialRevenue?: InputMaybe<Scalars['Float']>;
  netProfit?: InputMaybe<Scalars['Float']>;
  netRevenues?: InputMaybe<Scalars['Float']>;
  otherCost?: InputMaybe<Scalars['Float']>;
  otherRevenue?: InputMaybe<Scalars['Float']>;
  parkingCost?: InputMaybe<Scalars['Float']>;
  parkingImages?: InputMaybe<Array<Scalars['String']>>;
  parkingRevenue?: InputMaybe<Scalars['Float']>;
  profit?: InputMaybe<Scalars['Float']>;
  quoteDescription?: InputMaybe<Scalars['String']>;
  quoteJobId?: InputMaybe<Scalars['Int']>;
  reasonForManualPricing?: InputMaybe<Scalars['String']>;
  reportJobId?: InputMaybe<Scalars['Int']>;
  totalCost?: InputMaybe<Scalars['Float']>;
  totalRevenues?: InputMaybe<Scalars['Float']>;
  videos?: InputMaybe<Array<Scalars['String']>>;
};

export type QuotePayload = {
  __typename?: 'QuotePayload';
  errors?: Maybe<Array<Error>>;
  quote?: Maybe<Quote>;
};

export type RegisterInput = {
  email: Scalars['String'];
  fullName: Scalars['String'];
  password: Scalars['String'];
  roles: Array<Scalars['String']>;
};

export type RemedialJobSearchInput = {
  errorPath: Scalars['String'];
  isAdmin?: InputMaybe<Scalars['Boolean']>;
  jobReference: Scalars['String'];
};

export type RescheduledJobStatusByTpInput = {
  endDate: Scalars['DateTime'];
  includedJobStatusList: Array<Scalars['Int']>;
  startDate: Scalars['DateTime'];
};

export type RescheduledJobStatusInput = {
  endDate: Scalars['DateTime'];
  includedJobStatusList: Array<Scalars['Int']>;
  startDate: Scalars['DateTime'];
};

export type ResetPasswordInput = {
  errorPath: Scalars['String'];
  password: Scalars['String'];
  profileId: Scalars['String'];
};

export type Review = {
  __typename?: 'Review';
  createdAt?: Maybe<Scalars['DateTime']>;
  id: Scalars['Float'];
  job?: Maybe<Job>;
  jobId: Scalars['Int'];
  qeeperComments?: Maybe<Scalars['String']>;
  qeeperFeedbackDetails?: Maybe<Scalars['String']>;
  qeeperFeedbackRating?: Maybe<Scalars['Float']>;
  reviewStatus?: Maybe<Scalars['String']>;
  supplierFeedbackDetails?: Maybe<Scalars['String']>;
  supplierFeedbackRating?: Maybe<Scalars['Float']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ReviewPayload = {
  __typename?: 'ReviewPayload';
  errors?: Maybe<Array<Error>>;
  review?: Maybe<Review>;
};

export type Role = {
  __typename?: 'Role';
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  enabled?: Maybe<Scalars['Boolean']>;
  id: Scalars['Float'];
  name?: Maybe<Scalars['String']>;
  permissions?: Maybe<Array<Permission>>;
  profiles?: Maybe<Array<Profile>>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type SaveTokenToProfileInput = {
  accessTokenList?: InputMaybe<Array<IAccessTokenList>>;
};

export type SeachJobListInput = {
  cityId?: InputMaybe<Scalars['Float']>;
  clientId?: InputMaybe<Scalars['String']>;
  dateFilter?: InputMaybe<Scalars['String']>;
  dateSort?: InputMaybe<Scalars['String']>;
  excludeStatusIdList?: InputMaybe<Array<Scalars['Int']>>;
  isAccepted?: InputMaybe<Scalars['Boolean']>;
  isRemoteQuote?: InputMaybe<Scalars['Boolean']>;
  isStartTimeNull?: InputMaybe<Scalars['Boolean']>;
  location?: InputMaybe<Array<Scalars['Float']>>;
  publishedToApp?: InputMaybe<Scalars['Boolean']>;
  skillFilter?: InputMaybe<Array<Scalars['Int']>>;
  statusIdList?: InputMaybe<Array<Scalars['Int']>>;
  supplierId?: InputMaybe<Scalars['String']>;
  text?: InputMaybe<Scalars['String']>;
};

export type SeachJobReportInput = {
  jobId: Scalars['Float'];
};

export type SearchChatMessageInput = {
  jobId?: InputMaybe<Scalars['Int']>;
  slug?: InputMaybe<Scalars['String']>;
};

export type SearchChatMessagePayload = {
  __typename?: 'SearchChatMessagePayload';
  chatMessageList?: Maybe<Array<ChatMessage>>;
  cursor?: Maybe<CursorPayload>;
  hasMore: Scalars['Boolean'];
  jobDetails?: Maybe<Job>;
};

export type SearchCityListInput = {
  text: Scalars['String'];
};

export type SearchCityListPayload = {
  __typename?: 'SearchCityListPayload';
  cityList?: Maybe<Array<City>>;
};

export type SearchCityPriceInput = {
  cityId: Scalars['Float'];
  problemSubcategoryId?: InputMaybe<Scalars['Float']>;
};

export type SearchCityPricePayload = {
  __typename?: 'SearchCityPricePayload';
  cityPriceList?: Maybe<Array<CityPrice>>;
};

export type SearchCityProfilePriceInput = {
  cityId?: InputMaybe<Scalars['Float']>;
  profileId?: InputMaybe<Scalars['String']>;
};

export type SearchCityProfilePricePayload = {
  __typename?: 'SearchCityProfilePricePayload';
  cityProfilePriceList?: Maybe<Array<CityProfilePrice>>;
};

export type SearchErrorLogInput = {
  authorId?: InputMaybe<Scalars['String']>;
  fullName?: InputMaybe<Scalars['String']>;
};

export type SearchErrorLogPayload = {
  __typename?: 'SearchErrorLogPayload';
  errorLogList?: Maybe<Array<ErrorLog>>;
};

export type SearchHistoryInput = {
  primaryId?: InputMaybe<Scalars['String']>;
  profileId?: InputMaybe<Scalars['String']>;
  tableName?: InputMaybe<Scalars['String']>;
};

export type SearchHistoryPayload = {
  __typename?: 'SearchHistoryPayload';
  historyList?: Maybe<Array<HistoryResultObject>>;
};

export type SearchInvoiceListInput = {
  skip?: InputMaybe<Scalars['Int']>;
  status?: InputMaybe<Scalars['String']>;
};

export type SearchInvoiceListPayload = {
  __typename?: 'SearchInvoiceListPayload';
  hasMore: Scalars['Boolean'];
  jobList?: Maybe<Array<IInvoiceList>>;
  skip: Scalars['Int'];
};

export type SearchJobListPayload = {
  __typename?: 'SearchJobListPayload';
  cursor?: Maybe<CursorPayload>;
  hasMore: Scalars['Boolean'];
  jobList?: Maybe<Array<Job>>;
};

export type SearchProfileListInput = {
  blocked?: InputMaybe<Scalars['Float']>;
  isB2B?: InputMaybe<Scalars['Float']>;
  isInsuranceValid?: InputMaybe<Scalars['Boolean']>;
  isTnCAccepted?: InputMaybe<Scalars['Boolean']>;
  roles?: InputMaybe<Array<Scalars['Int']>>;
  text?: InputMaybe<Scalars['String']>;
};

export type SearchProfileListPayload = {
  __typename?: 'SearchProfileListPayload';
  profileList?: Maybe<Array<Profile>>;
};

export type SearchQuoteInput = {
  quoteId?: InputMaybe<Scalars['Float']>;
  quoteJobId?: InputMaybe<Scalars['Float']>;
};

export type SearchQuotePayload = {
  __typename?: 'SearchQuotePayload';
  quotes?: Maybe<Array<Quote>>;
};

export type SearchSkillInput = {
  enabled: Scalars['Boolean'];
};

export type SearchSkillPayload = {
  __typename?: 'SearchSkillPayload';
  skillList?: Maybe<Array<Skill>>;
};

export type SendInvoiceInput = {
  emailIdList?: InputMaybe<Scalars['String']>;
  errorPath: Scalars['String'];
  jobId?: InputMaybe<Scalars['Float']>;
};

export type SetJobReportToNullInput = {
  jobId: Scalars['Float'];
};

export type Skill = {
  __typename?: 'Skill';
  cityList?: Maybe<Array<SkillToCity>>;
  enabled?: Maybe<Scalars['Boolean']>;
  icon?: Maybe<Scalars['String']>;
  iconName?: Maybe<Scalars['String']>;
  id: Scalars['Float'];
  name: Scalars['String'];
};

export type SkillPayload = {
  __typename?: 'SkillPayload';
  errors?: Maybe<Array<Error>>;
  skill?: Maybe<Skill>;
};

export type SkillToCity = {
  __typename?: 'SkillToCity';
  city?: Maybe<Array<City>>;
  cityId: Scalars['Float'];
  price?: Maybe<Scalars['Float']>;
};

export type StatusListInput = {
  roleId?: InputMaybe<Scalars['Float']>;
};

export type Subscription = {
  __typename?: 'Subscription';
  newChatMessage: ChatMessage;
  newComment: Scalars['String'];
};


export type SubscriptionNewChatMessageArgs = {
  receiverId?: InputMaybe<Scalars['String']>;
};

export type SupplierMargin = {
  __typename?: 'SupplierMargin';
  date?: Maybe<Scalars['String']>;
  margin: Scalars['Float'];
  suppliername?: Maybe<Scalars['String']>;
};

export type SupplierMarginPayload = {
  __typename?: 'SupplierMarginPayload';
  dataList?: Maybe<Array<SupplierMargin>>;
  errors?: Maybe<Array<Error>>;
};

export type SupplierProfit = {
  __typename?: 'SupplierProfit';
  cogs: Scalars['Float'];
  creatorid?: Maybe<Scalars['String']>;
  date?: Maybe<Scalars['String']>;
  revenues: Scalars['Float'];
  suppliername?: Maybe<Scalars['String']>;
};

export type SupplierProfitInput = {
  creatorId?: InputMaybe<Scalars['String']>;
  dateType?: InputMaybe<Scalars['String']>;
  endDate: Scalars['DateTime'];
  skillId?: InputMaybe<Scalars['Int']>;
  startDate: Scalars['DateTime'];
};

export type SupplierProfitlPayload = {
  __typename?: 'SupplierProfitlPayload';
  dataList?: Maybe<Array<SupplierProfit>>;
  errors?: Maybe<Array<Error>>;
};

export type Tag = {
  __typename?: 'Tag';
  createdAt?: Maybe<Scalars['DateTime']>;
  id: Scalars['Float'];
  name?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type TagPayload = {
  __typename?: 'TagPayload';
  errors?: Maybe<Array<Error>>;
  tag?: Maybe<Tag>;
};

export type TempJobInput = {
  endId?: InputMaybe<Scalars['Float']>;
  startId?: InputMaybe<Scalars['Float']>;
};

export type TempUpdateNetRevenuesInput = {
  endId?: InputMaybe<Scalars['Float']>;
  startId?: InputMaybe<Scalars['Float']>;
};

export type TncAcceptedItem = {
  __typename?: 'TncAcceptedItem';
  ipAddress?: Maybe<Scalars['String']>;
  lat?: Maybe<Scalars['String']>;
  long?: Maybe<Scalars['String']>;
  networkType?: Maybe<Scalars['String']>;
  tncAcceptedAt?: Maybe<Scalars['String']>;
};

export type TncAcceptedItemInput = {
  ipAddress: Scalars['String'];
  lat: Scalars['String'];
  long: Scalars['String'];
  networkType: Scalars['String'];
  tncAcceptedAt: Scalars['String'];
};

export type TopUsersPayload = {
  __typename?: 'TopUsersPayload';
  errors?: Maybe<Array<Error>>;
  profiles?: Maybe<Array<Profile>>;
};

export type TrackingOption = {
  __typename?: 'TrackingOption';
  trackingCategoryID: Scalars['String'];
  trackingOptionID: Scalars['String'];
};

export type UnscheduledJobStatusMore6hoursInput = {
  endDate: Scalars['DateTime'];
  includedJobStatusList: Array<Scalars['Int']>;
  startDate: Scalars['DateTime'];
};

export type UpdateCityInput = {
  city: Scalars['String'];
  cityId: Scalars['Float'];
  country: Scalars['String'];
  currency: Scalars['String'];
  currencySymbol: Scalars['String'];
  errorPath: Scalars['String'];
  timezone: Scalars['String'];
};

export type UpdateCityPriceInput = {
  cityId: Scalars['Float'];
  errorPath: Scalars['String'];
  price: Scalars['Float'];
  problemSubcategoryId: Scalars['Float'];
};

export type UpdateInvoiceFieldsForJobInput = {
  errorPath: Scalars['String'];
  id: Scalars['Int'];
  invoiceEmailList: Scalars['String'];
  onlineInvoiceUrl: Scalars['String'];
  xeroInvoiceId: Scalars['String'];
};

export type UpdateJobCompDocInput = {
  completionDoc?: InputMaybe<Array<Scalars['String']>>;
  jobId?: InputMaybe<Scalars['Int']>;
};

export type UpdateJobFilesSupplierInput = {
  beforeImages?: InputMaybe<Array<Scalars['String']>>;
  completionDocuments?: InputMaybe<Array<Scalars['String']>>;
  completionImages?: InputMaybe<Array<Scalars['String']>>;
  completionVideos?: InputMaybe<Array<Scalars['String']>>;
  deletedBeforeImages?: InputMaybe<Array<Scalars['String']>>;
  deletedDocuments?: InputMaybe<Array<Scalars['String']>>;
  deletedImages?: InputMaybe<Array<Scalars['String']>>;
  deletedParkingImages?: InputMaybe<Array<Scalars['String']>>;
  deletedVideos?: InputMaybe<Array<Scalars['String']>>;
  documents?: InputMaybe<Array<Scalars['String']>>;
  errorPath: Scalars['String'];
  id?: InputMaybe<Scalars['Int']>;
  images?: InputMaybe<Array<Scalars['String']>>;
  parkingImages?: InputMaybe<Array<Scalars['String']>>;
  videos?: InputMaybe<Array<Scalars['String']>>;
};

export type UpdateJobInput = {
  address?: InputMaybe<Scalars['String']>;
  b2cNotes?: InputMaybe<Scalars['String']>;
  beforeImages?: InputMaybe<Array<Scalars['Upload']>>;
  cityId?: InputMaybe<Scalars['Float']>;
  clientEmailStartedAt?: InputMaybe<Scalars['DateTime']>;
  clientId?: InputMaybe<Scalars['String']>;
  completionNotes?: InputMaybe<Scalars['String']>;
  deletedBeforeImages?: InputMaybe<Array<Scalars['String']>>;
  deletedDocuments?: InputMaybe<Array<Scalars['String']>>;
  deletedImages?: InputMaybe<Array<Scalars['String']>>;
  deletedParkingImages?: InputMaybe<Array<Scalars['String']>>;
  deletedPreferredSupplierList?: InputMaybe<Array<Scalars['String']>>;
  deletedSkillList?: InputMaybe<Array<Scalars['Int']>>;
  deletedTagList?: InputMaybe<Array<Scalars['Int']>>;
  deletedVideos?: InputMaybe<Array<Scalars['String']>>;
  details?: InputMaybe<Scalars['String']>;
  documents?: InputMaybe<Array<Scalars['Upload']>>;
  emailConfirmationLink?: InputMaybe<Scalars['String']>;
  errorPath: Scalars['String'];
  id?: InputMaybe<Scalars['Int']>;
  images?: InputMaybe<Array<Scalars['Upload']>>;
  internalNotes?: InputMaybe<Scalars['String']>;
  invoiceEmailList?: InputMaybe<Scalars['String']>;
  invoiceRef?: InputMaybe<Scalars['String']>;
  isClientAgreedForOOH?: InputMaybe<Scalars['Boolean']>;
  isRemedialQuote?: InputMaybe<Scalars['Boolean']>;
  isRemoteQuote?: InputMaybe<Scalars['Boolean']>;
  jobReportSubmitted?: InputMaybe<Scalars['DateTime']>;
  jobStatusId?: InputMaybe<Scalars['Float']>;
  jobUpdatesEmailList?: InputMaybe<Scalars['String']>;
  lat?: InputMaybe<Scalars['Float']>;
  lng?: InputMaybe<Scalars['Float']>;
  parkingImages?: InputMaybe<Array<Scalars['Upload']>>;
  postCode?: InputMaybe<Scalars['String']>;
  preferredSupplierList?: InputMaybe<Array<Scalars['String']>>;
  problemCategoryId?: InputMaybe<Scalars['Float']>;
  problemSubcategoryId?: InputMaybe<Scalars['Float']>;
  propertyAccess?: InputMaybe<Scalars['String']>;
  publishedToApp?: InputMaybe<Scalars['Boolean']>;
  referenceId?: InputMaybe<Scalars['String']>;
  remedialNotes?: InputMaybe<Scalars['String']>;
  skillList?: InputMaybe<Array<Scalars['Int']>>;
  slotDuration?: InputMaybe<Scalars['Float']>;
  startTime?: InputMaybe<Scalars['DateTime']>;
  startTimeSlots?: InputMaybe<Array<IJobTimeSlot>>;
  supplierId?: InputMaybe<Scalars['String']>;
  supplierJobStatusId?: InputMaybe<Scalars['Float']>;
  tagList?: InputMaybe<Array<Scalars['Int']>>;
  title?: InputMaybe<Scalars['String']>;
  videos?: InputMaybe<Array<Scalars['Upload']>>;
};

export type UpdateJobReportForJobInput = {
  isUpdateJob: Scalars['Boolean'];
  isUpdateJobReport: Scalars['Boolean'];
  jobId: Scalars['Float'];
  jobReportId: Scalars['Float'];
};

export type UpdateJobStatusInput = {
  description?: InputMaybe<Scalars['String']>;
  enabled?: InputMaybe<Scalars['Boolean']>;
  errorPath?: InputMaybe<Scalars['String']>;
  id: Scalars['Int'];
  roleId?: InputMaybe<Scalars['Float']>;
  title?: InputMaybe<Scalars['String']>;
};

export type UpdateJobSupplierInput = {
  address?: InputMaybe<Scalars['String']>;
  b2cNotes?: InputMaybe<Scalars['String']>;
  beforeImages?: InputMaybe<Array<Scalars['Upload']>>;
  cityId?: InputMaybe<Scalars['Float']>;
  clientEmailStartedAt?: InputMaybe<Scalars['DateTime']>;
  clientId?: InputMaybe<Scalars['String']>;
  completionNotes?: InputMaybe<Scalars['String']>;
  deletedBeforeImages?: InputMaybe<Array<Scalars['String']>>;
  deletedDocuments?: InputMaybe<Array<Scalars['String']>>;
  deletedImages?: InputMaybe<Array<Scalars['String']>>;
  deletedParkingImages?: InputMaybe<Array<Scalars['String']>>;
  deletedPreferredSupplierList?: InputMaybe<Array<Scalars['String']>>;
  deletedQuoteIds?: InputMaybe<Array<Scalars['Int']>>;
  deletedSkillList?: InputMaybe<Array<Scalars['Int']>>;
  deletedTagList?: InputMaybe<Array<Scalars['Int']>>;
  deletedVideos?: InputMaybe<Array<Scalars['String']>>;
  details?: InputMaybe<Scalars['String']>;
  documents?: InputMaybe<Array<Scalars['Upload']>>;
  emailConfirmationLink?: InputMaybe<Scalars['String']>;
  errorPath: Scalars['String'];
  id?: InputMaybe<Scalars['Int']>;
  images?: InputMaybe<Array<Scalars['Upload']>>;
  internalNotes?: InputMaybe<Scalars['String']>;
  invoiceEmailList?: InputMaybe<Scalars['String']>;
  invoiceRef?: InputMaybe<Scalars['String']>;
  isClientAgreedForOOH?: InputMaybe<Scalars['Boolean']>;
  isRemedialQuote?: InputMaybe<Scalars['Boolean']>;
  isRemoteQuote?: InputMaybe<Scalars['Boolean']>;
  jobReport: QuoteInput;
  jobReportSubmitted?: InputMaybe<Scalars['DateTime']>;
  jobStatusId?: InputMaybe<Scalars['Float']>;
  jobUpdatesEmailList?: InputMaybe<Scalars['String']>;
  lat?: InputMaybe<Scalars['Float']>;
  lng?: InputMaybe<Scalars['Float']>;
  parkingImages?: InputMaybe<Array<Scalars['Upload']>>;
  postCode?: InputMaybe<Scalars['String']>;
  preferredSupplierList?: InputMaybe<Array<Scalars['String']>>;
  problemCategoryId?: InputMaybe<Scalars['Float']>;
  problemSubcategoryId?: InputMaybe<Scalars['Float']>;
  propertyAccess?: InputMaybe<Scalars['String']>;
  publishedToApp?: InputMaybe<Scalars['Boolean']>;
  quotes?: InputMaybe<Array<QuoteInput>>;
  referenceId?: InputMaybe<Scalars['String']>;
  remedialNotes?: InputMaybe<Scalars['String']>;
  skillList?: InputMaybe<Array<Scalars['Int']>>;
  slotDuration?: InputMaybe<Scalars['Float']>;
  startTime?: InputMaybe<Scalars['DateTime']>;
  startTimeSlots?: InputMaybe<Array<IJobTimeSlot>>;
  supplierId?: InputMaybe<Scalars['String']>;
  supplierJobStatusId?: InputMaybe<Scalars['Float']>;
  tagList?: InputMaybe<Array<Scalars['Int']>>;
  title?: InputMaybe<Scalars['String']>;
  videos?: InputMaybe<Array<Scalars['Upload']>>;
};

export type UpdateJobTagsInput = {
  deletedTagList?: InputMaybe<Array<Scalars['Int']>>;
  jobId: Scalars['Int'];
  tagList?: InputMaybe<Array<Scalars['Int']>>;
};

export type UpdateProfileInput = {
  address?: InputMaybe<Scalars['String']>;
  adminPassword?: InputMaybe<Scalars['String']>;
  areaCovered?: InputMaybe<Array<Scalars['String']>>;
  blocked?: InputMaybe<Scalars['Boolean']>;
  cityId?: InputMaybe<Scalars['Float']>;
  commission?: InputMaybe<Scalars['Float']>;
  companyName?: InputMaybe<Scalars['String']>;
  creatorId?: InputMaybe<Scalars['String']>;
  creditControlNotes?: InputMaybe<Scalars['String']>;
  deleteNotiToken?: InputMaybe<Scalars['String']>;
  deletedDocuments?: InputMaybe<Array<Scalars['String']>>;
  deletedQualDocuments?: InputMaybe<Array<Scalars['String']>>;
  documents?: InputMaybe<Array<Scalars['Upload']>>;
  email: Scalars['String'];
  emailConfirmationLink?: InputMaybe<Scalars['String']>;
  errorPath: Scalars['String'];
  fullName?: InputMaybe<Scalars['String']>;
  image?: InputMaybe<Scalars['Upload']>;
  insuranceExpiryDate?: InputMaybe<Scalars['DateTime']>;
  invoiceEmailList?: InputMaybe<Scalars['String']>;
  invoiceNotes?: InputMaybe<Scalars['String']>;
  isB2B?: InputMaybe<Scalars['Int']>;
  isCongestionCharged?: InputMaybe<Scalars['Boolean']>;
  isDayRate?: InputMaybe<Scalars['Boolean']>;
  isHourly?: InputMaybe<Scalars['Boolean']>;
  isLandlordInvoicing?: InputMaybe<Scalars['Boolean']>;
  isNewClientPrice?: InputMaybe<Scalars['Boolean']>;
  isParkingCharged?: InputMaybe<Scalars['Boolean']>;
  jobUpdatesEmailList?: InputMaybe<Scalars['String']>;
  notes?: InputMaybe<Scalars['String']>;
  notiToken?: InputMaybe<Scalars['String']>;
  password?: InputMaybe<Scalars['String']>;
  paymentTerms?: InputMaybe<Scalars['Float']>;
  permissions?: InputMaybe<Array<Scalars['String']>>;
  phoneNumber?: InputMaybe<Scalars['String']>;
  profileId?: InputMaybe<Scalars['String']>;
  qualificationDocuments?: InputMaybe<Array<Scalars['Upload']>>;
  qualificationExpiryDate?: InputMaybe<Scalars['DateTime']>;
  rating?: InputMaybe<Scalars['String']>;
  roles?: InputMaybe<Array<Scalars['String']>>;
  shiftOptions?: InputMaybe<Array<Scalars['String']>>;
  skillList?: InputMaybe<Array<Scalars['Int']>>;
  tncAcceptedAt?: InputMaybe<Scalars['DateTime']>;
  tncAcceptedList?: InputMaybe<Array<TncAcceptedItemInput>>;
  unavailableDates?: InputMaybe<Array<Scalars['String']>>;
  xeroContactId?: InputMaybe<Scalars['String']>;
};

export type UpdateQuoteAsPerJobReportInput = {
  endId?: InputMaybe<Scalars['Float']>;
  startId?: InputMaybe<Scalars['Float']>;
};

export type UpdateQuoteInput = {
  beforeImageFiles?: InputMaybe<Array<Scalars['Upload']>>;
  beforeImages?: InputMaybe<Array<Scalars['String']>>;
  deletedBeforeImages?: InputMaybe<Array<Scalars['String']>>;
  deletedDocuments?: InputMaybe<Array<Scalars['String']>>;
  deletedImages?: InputMaybe<Array<Scalars['String']>>;
  deletedParkingImages?: InputMaybe<Array<Scalars['String']>>;
  deletedVideos?: InputMaybe<Array<Scalars['String']>>;
  description?: InputMaybe<Scalars['String']>;
  documentFiles?: InputMaybe<Array<Scalars['Upload']>>;
  documents?: InputMaybe<Array<Scalars['String']>>;
  errorPath: Scalars['String'];
  id?: InputMaybe<Scalars['Int']>;
  imageFiles?: InputMaybe<Array<Scalars['Upload']>>;
  images?: InputMaybe<Array<Scalars['String']>>;
  inputRevenuesManually?: InputMaybe<Scalars['Boolean']>;
  isApproved?: InputMaybe<Scalars['Boolean']>;
  isJobReport?: InputMaybe<Scalars['Boolean']>;
  labourCost?: InputMaybe<Scalars['Float']>;
  labourHours?: InputMaybe<Scalars['Float']>;
  labourRevenue?: InputMaybe<Scalars['Float']>;
  materialCost?: InputMaybe<Scalars['Float']>;
  materialQuotes?: InputMaybe<Array<MeterialQuoteInput>>;
  materialRevenue?: InputMaybe<Scalars['Float']>;
  netProfit?: InputMaybe<Scalars['Float']>;
  netRevenues?: InputMaybe<Scalars['Float']>;
  otherCost?: InputMaybe<Scalars['Float']>;
  otherRevenue?: InputMaybe<Scalars['Float']>;
  parkingCost?: InputMaybe<Scalars['Float']>;
  parkingImageFiles?: InputMaybe<Array<Scalars['Upload']>>;
  parkingImages?: InputMaybe<Array<Scalars['String']>>;
  parkingRevenue?: InputMaybe<Scalars['Float']>;
  profit?: InputMaybe<Scalars['Float']>;
  quoteDescription?: InputMaybe<Scalars['String']>;
  quoteJobId?: InputMaybe<Scalars['Int']>;
  reasonForManualPricing?: InputMaybe<Scalars['String']>;
  reportJobId?: InputMaybe<Scalars['Int']>;
  supplierJobStatusId?: InputMaybe<Scalars['Float']>;
  totalCost?: InputMaybe<Scalars['Float']>;
  totalRevenues?: InputMaybe<Scalars['Float']>;
  videoFiles?: InputMaybe<Array<Scalars['Upload']>>;
  videos?: InputMaybe<Array<Scalars['String']>>;
};

export type UpdateSkillInput = {
  enabled?: InputMaybe<Scalars['Boolean']>;
  errorPath: Scalars['String'];
  icon: Scalars['String'];
  iconName: Scalars['String'];
  name: Scalars['String'];
  skillId: Scalars['Float'];
};

export type UserPayload = {
  __typename?: 'UserPayload';
  accessToken?: Maybe<Scalars['String']>;
  errors?: Maybe<Array<Error>>;
  profile?: Maybe<Profile>;
};

export type XeroCreateInvoiceInput = {
  errorPath: Scalars['String'];
  invoiceEmailList?: InputMaybe<Scalars['String']>;
  isParkingVAT?: InputMaybe<Scalars['Boolean']>;
  jobId?: InputMaybe<Scalars['Float']>;
  labourText: Scalars['String'];
  landlordAddress?: InputMaybe<Scalars['String']>;
};

export type ChatMessageFragments_ChatMessageFragment = { __typename?: 'ChatMessage', id: number, text: string, isAdmin?: boolean | null, jobId: number, createdAt?: any | null };

export type ChatMessageFragments_ChatMessageDetailsFragment = { __typename?: 'ChatMessage', id: number, text: string, isAdmin?: boolean | null, jobId: number, createdAt?: any | null };

export type CityFragments_CityFragment = { __typename?: 'City', id: number, city: string, country?: string | null, timezone?: string | null, currency?: string | null, currencySymbol?: string | null };

export type CityFragments_AdminCityJobListFragment = { __typename?: 'City', id: number, city: string, timezone?: string | null, currency?: string | null, currencySymbol?: string | null };

export type CursorFragments_CursorFragment = { __typename?: 'CursorPayload', id: string, date: any, score: number };

export type ErrorFragments_ErrorFragment = { __typename?: 'Error', path: string, message: Array<string> };

export type FeedbackFragments_FeedbackFragment = { __typename?: 'Feedback', id: number, message: string, senderId?: string | null, createdAt?: any | null, updatedAt?: any | null };

export type JobFragments_JobFragment = { __typename?: 'Job', id: number, referenceId?: string | null, title?: string | null, slug?: string | null, details?: string | null, completionNotes?: string | null, remedialNotes?: string | null, adminJobReportNotes?: string | null, address?: string | null, postCode?: string | null, propertyAccess?: string | null, slotDuration?: number | null, startTime?: any | null, images?: Array<string> | null, completionImages?: Array<string> | null, videos?: Array<string> | null, completionVideos?: Array<string> | null, completionDocuments?: Array<string> | null, jobStatusId?: number | null, supplierJobStatusId?: number | null, profileId?: string | null, authorId?: string | null, clientId?: string | null, supplierId?: string | null, cityId?: number | null, internalNotes?: string | null, labourCost?: number | null, materialCost?: number | null, otherCost?: number | null, clientCost?: number | null, supplierCost?: number | null, createdAt?: any | null, updatedAt?: any | null, publishedToApp?: boolean | null, b2cNotes?: string | null, skillList?: Array<{ __typename?: 'Skill', id: number, name: string, icon?: string | null, iconName?: string | null }> | null, location?: { __typename?: 'PointObject', type: string, coordinates: Array<number> } | null, startTimeSlots?: Array<{ __typename?: 'JobTimeSlot', date: string, slots: Array<number> }> | null, jobStatus?: { __typename?: 'JobStatus', id: number, title: string } | null, supplierJobStatus?: { __typename?: 'JobStatus', id: number, title: string } | null, profile?: { __typename?: 'Profile', id: string, fullName?: string | null } | null, author?: { __typename?: 'Profile', id: string, fullName?: string | null } | null, client?: { __typename?: 'Profile', id: string, fullName?: string | null, email?: string | null, phoneNumber?: string | null } | null, supplier?: { __typename?: 'Profile', id: string, fullName?: string | null } | null, preferredSupplierList?: Array<{ __typename?: 'Profile', id: string, fullName?: string | null }> | null, city?: { __typename?: 'City', id: number, city: string, country?: string | null, timezone?: string | null, currency?: string | null, currencySymbol?: string | null } | null };

export type JobFragments_JobSimpleFragment = { __typename?: 'Job', id: number, referenceId?: string | null, title?: string | null, slug?: string | null, completionNotes?: string | null, details?: string | null, address?: string | null, postCode?: string | null, propertyAccess?: string | null, slotDuration?: number | null, startTime?: any | null, images?: Array<string> | null, completionImages?: Array<string> | null, videos?: Array<string> | null, completionVideos?: Array<string> | null, completionDocuments?: Array<string> | null, cityId?: number | null, labourCost?: number | null, materialCost?: number | null, otherCost?: number | null, remedialNotes?: string | null, clientCost?: number | null, supplierCost?: number | null, profit?: number | null, createdAt?: any | null, updatedAt?: any | null, jobStatusId?: number | null, supplierJobStatusId?: number | null, location?: { __typename?: 'PointObject', type: string, coordinates: Array<number> } | null, jobStatus?: { __typename?: 'JobStatus', id: number, title: string } | null, supplierJobStatus?: { __typename?: 'JobStatus', id: number, title: string } | null };

export type JobFragments_AdminJobListFragment = { __typename?: 'Job', id: number, referenceId?: string | null, title?: string | null, details?: string | null, address?: string | null, postCode?: string | null, slotDuration?: number | null, jobStatusId?: number | null, supplierJobStatusId?: number | null, clientId?: string | null, supplierId?: string | null, startTime?: any | null, cityId?: number | null, internalNotes?: string | null, propertyAccess?: string | null, invoiceRef?: string | null, supplierCost?: number | null, clientCost?: number | null, profit?: number | null, publishedToApp?: boolean | null, startTimeSlots?: Array<{ __typename?: 'JobTimeSlot', date: string, slots: Array<number> }> | null, jobStatus?: { __typename?: 'JobStatus', id: number, title: string } | null, supplierJobStatus?: { __typename?: 'JobStatus', id: number, title: string } | null, client?: { __typename?: 'Profile', id: string, fullName?: string | null } | null, supplier?: { __typename?: 'Profile', id: string, fullName?: string | null } | null };

export type JobFragments_ChatListFragment = { __typename?: 'Job', id: number, title?: string | null, address?: string | null, chatCheckedAdmin?: any | null, chatCheckedSupplier?: any | null, profileId?: string | null, authorId?: string | null, clientId?: string | null, supplierId?: string | null, profile?: { __typename?: 'Profile', id: string, fullName?: string | null } | null, author?: { __typename?: 'Profile', id: string, fullName?: string | null } | null, client?: { __typename?: 'Profile', id: string, fullName?: string | null } | null, supplier?: { __typename?: 'Profile', id: string, fullName?: string | null } | null, preferredSupplierList?: Array<{ __typename?: 'Profile', id: string, fullName?: string | null }> | null };

export type JobFragments_ChatDetailsFragment = { __typename?: 'Job', id: number, title?: string | null, slug?: string | null, chatCheckedAdmin?: any | null, chatCheckedSupplier?: any | null };

export type JobStatusFragments_JobStatusFragment = { __typename?: 'JobStatus', id: number, title: string, description?: string | null, roleId?: number | null };

export type ProfileFragments_ProfileFragment = { __typename?: 'Profile', id: string, email?: string | null, fullName?: string | null, image?: string | null, address?: string | null, phoneNumber?: string | null, refreshTokenVersion?: number | null, forgotPasswordLocked?: boolean | null, paymentTerms?: number | null, commission?: number | null, documents?: Array<string> | null, confirmed?: boolean | null, reported?: boolean | null, blocked?: boolean | null, createdAt?: string | null, updatedAt?: string | null, insuranceExpiryDate?: any | null, notes?: string | null, rating?: string | null, skillList?: Array<{ __typename?: 'Skill', id: number, name: string, icon?: string | null, iconName?: string | null }> | null, city?: { __typename?: 'City', id: number, city: string } | null, roles?: Array<{ __typename?: 'Role', id: number, name?: string | null }> | null };

export type ProfileFragments_ProfileDetailedFragment = { __typename?: 'Profile', id: string, email?: string | null, fullName?: string | null, image?: string | null, address?: string | null, phoneNumber?: string | null, refreshTokenVersion?: number | null, forgotPasswordLocked?: boolean | null, confirmed?: boolean | null, reported?: boolean | null, blocked?: boolean | null, createdAt?: string | null, updatedAt?: string | null, roles?: Array<{ __typename?: 'Role', id: number, name?: string | null }> | null, skillList?: Array<{ __typename?: 'Skill', id: number, name: string, icon?: string | null, iconName?: string | null }> | null };

export type SkillFragments_SkillFragment = { __typename?: 'Skill', id: number, name: string, icon?: string | null, iconName?: string | null };

export type SkillFragments_AdminJobListSkillFragment = { __typename?: 'Skill', id: number, name: string };

export type AnalyticFinancialQueryVariables = Exact<{
  input: AnalyticInput;
}>;


export type AnalyticFinancialQuery = { __typename?: 'Query', analyticFinancial: { __typename?: 'AnalyticFinancialPayload', dataList?: Array<{ __typename?: 'AnalyticFinancial', month: string, cogs: number, revenues: number }> | null } };

export type AnalyticJobListQueryVariables = Exact<{
  input: AnalyticJobListInput;
}>;


export type AnalyticJobListQuery = { __typename?: 'Query', analyticJobList: { __typename?: 'SearchJobListPayload', hasMore: boolean, jobList?: Array<{ __typename?: 'Job', id: number, title?: string | null, startTime?: any | null, slotDuration?: number | null, jobStatusId?: number | null, city?: { __typename?: 'City', timezone?: string | null } | null, supplier?: { __typename?: 'Profile', fullName?: string | null } | null }> | null, cursor?: { __typename?: 'CursorPayload', id: string, date: any, score: number } | null } };

export type AnalyticSupplierlListQueryVariables = Exact<{
  input: AnalyticInput;
}>;


export type AnalyticSupplierlListQuery = { __typename?: 'Query', analyticSupplierlList: { __typename?: 'AnalyticPiePayload', dataList?: Array<{ __typename?: 'AnalyticList', label?: string | null, value?: number | null }> | null } };

export type AnalyticJobsByCityQueryVariables = Exact<{
  input: AnalyticInput;
}>;


export type AnalyticJobsByCityQuery = { __typename?: 'Query', analyticJobsByCity: { __typename?: 'AnalyticPiePayload', dataList?: Array<{ __typename?: 'AnalyticList', label?: string | null, value?: number | null }> | null } };

export type AnalyticJobsByClientQueryVariables = Exact<{
  input: AnalyticInput;
}>;


export type AnalyticJobsByClientQuery = { __typename?: 'Query', analyticJobsByClient: { __typename?: 'AnalyticPiePayload', dataList?: Array<{ __typename?: 'AnalyticList', label?: string | null, value?: number | null }> | null } };

export type AnalyticJobCountQueryVariables = Exact<{
  input: AnalyticInput;
}>;


export type AnalyticJobCountQuery = { __typename?: 'Query', analyticJobCount: { __typename?: 'JobCountInputPayload', dataList?: Array<{ __typename?: 'JobCountInput', month: string, count: number }> | null } };

export type MeAppQueryVariables = Exact<{ [key: string]: never; }>;


export type MeAppQuery = { __typename?: 'Query', me?: { __typename?: 'ProfilePayload', profile?: { __typename?: 'Profile', id: string, fullName?: string | null, notiTokens?: Array<string> | null, skillList?: Array<{ __typename?: 'Skill', id: number }> | null, roles?: Array<{ __typename?: 'Role', id: number, name?: string | null }> | null } | null, errors?: Array<{ __typename?: 'Error', path: string, message: Array<string> }> | null } | null };

export type CreateBookingMutationVariables = Exact<{
  input: CreateBookingInput;
}>;


export type CreateBookingMutation = { __typename?: 'Mutation', createBooking?: { __typename?: 'JobPayload', job?: { __typename?: 'Job', id: number, referenceId?: string | null, title?: string | null, slug?: string | null, details?: string | null, completionNotes?: string | null, remedialNotes?: string | null, adminJobReportNotes?: string | null, address?: string | null, postCode?: string | null, propertyAccess?: string | null, slotDuration?: number | null, startTime?: any | null, images?: Array<string> | null, completionImages?: Array<string> | null, videos?: Array<string> | null, completionVideos?: Array<string> | null, completionDocuments?: Array<string> | null, jobStatusId?: number | null, supplierJobStatusId?: number | null, profileId?: string | null, authorId?: string | null, clientId?: string | null, supplierId?: string | null, cityId?: number | null, internalNotes?: string | null, labourCost?: number | null, materialCost?: number | null, otherCost?: number | null, clientCost?: number | null, supplierCost?: number | null, createdAt?: any | null, updatedAt?: any | null, publishedToApp?: boolean | null, b2cNotes?: string | null, skillList?: Array<{ __typename?: 'Skill', id: number, name: string, icon?: string | null, iconName?: string | null }> | null, location?: { __typename?: 'PointObject', type: string, coordinates: Array<number> } | null, startTimeSlots?: Array<{ __typename?: 'JobTimeSlot', date: string, slots: Array<number> }> | null, jobStatus?: { __typename?: 'JobStatus', id: number, title: string } | null, supplierJobStatus?: { __typename?: 'JobStatus', id: number, title: string } | null, profile?: { __typename?: 'Profile', id: string, fullName?: string | null } | null, author?: { __typename?: 'Profile', id: string, fullName?: string | null } | null, client?: { __typename?: 'Profile', id: string, fullName?: string | null, email?: string | null, phoneNumber?: string | null } | null, supplier?: { __typename?: 'Profile', id: string, fullName?: string | null } | null, preferredSupplierList?: Array<{ __typename?: 'Profile', id: string, fullName?: string | null }> | null, city?: { __typename?: 'City', id: number, city: string, country?: string | null, timezone?: string | null, currency?: string | null, currencySymbol?: string | null } | null } | null, errors?: Array<{ __typename?: 'Error', path: string, message: Array<string> }> | null } | null };

export type AddChatMessageMutationVariables = Exact<{
  input: AddChatMessageInput;
}>;


export type AddChatMessageMutation = { __typename?: 'Mutation', addChatMessage: { __typename?: 'AddChatMessagePayload', chatMessage?: { __typename?: 'ChatMessage', id: number, text: string, isAdmin?: boolean | null, jobId: number, createdAt?: any | null } | null, errors?: Array<{ __typename?: 'Error', path: string, message: Array<string> }> | null } };

export type NewChatMessageSubscriptionVariables = Exact<{
  receiverId?: InputMaybe<Scalars['String']>;
}>;


export type NewChatMessageSubscription = { __typename?: 'Subscription', newChatMessage: { __typename?: 'ChatMessage', id: number, text: string, isAdmin?: boolean | null, jobId: number, createdAt?: any | null } };

export type ChatCheckedMutationVariables = Exact<{
  input: ChatCheckedInput;
}>;


export type ChatCheckedMutation = { __typename?: 'Mutation', chatChecked: boolean };

export type ChatNotificationCountQueryVariables = Exact<{ [key: string]: never; }>;


export type ChatNotificationCountQuery = { __typename?: 'Query', chatNotificationCount: number };

export type JobChatListQueryVariables = Exact<{
  input: JobChatListInput;
}>;


export type JobChatListQuery = { __typename?: 'Query', jobChatList: { __typename?: 'JobChatListPayload', hasMore: boolean, chatList?: Array<{ __typename?: 'ChatMessage', id: number, text: string, isAdmin?: boolean | null, jobId: number, createdAt?: any | null, job?: { __typename?: 'Job', id: number, title?: string | null, address?: string | null, chatCheckedAdmin?: any | null, chatCheckedSupplier?: any | null, profileId?: string | null, authorId?: string | null, clientId?: string | null, supplierId?: string | null, profile?: { __typename?: 'Profile', id: string, fullName?: string | null } | null, author?: { __typename?: 'Profile', id: string, fullName?: string | null } | null, client?: { __typename?: 'Profile', id: string, fullName?: string | null } | null, supplier?: { __typename?: 'Profile', id: string, fullName?: string | null } | null, preferredSupplierList?: Array<{ __typename?: 'Profile', id: string, fullName?: string | null }> | null } | null }> | null, cursor?: { __typename?: 'CursorPayload', id: string, date: any, score: number } | null } };

export type SearchChatMessageQueryVariables = Exact<{
  input: SearchChatMessageInput;
}>;


export type SearchChatMessageQuery = { __typename?: 'Query', searchChatMessage: { __typename?: 'SearchChatMessagePayload', hasMore: boolean, chatMessageList?: Array<{ __typename?: 'ChatMessage', id: number, text: string, isAdmin?: boolean | null, jobId: number, createdAt?: any | null }> | null, jobDetails?: { __typename?: 'Job', id: number, title?: string | null, slug?: string | null, chatCheckedAdmin?: any | null, chatCheckedSupplier?: any | null } | null, cursor?: { __typename?: 'CursorPayload', id: string, date: any, score: number } | null } };

export type AddCityMutationVariables = Exact<{
  input: AddCityInput;
}>;


export type AddCityMutation = { __typename?: 'Mutation', addCity: { __typename?: 'CityPayload', city?: { __typename?: 'City', id: number, city: string, country?: string | null, timezone?: string | null, currency?: string | null, currencySymbol?: string | null } | null, errors?: Array<{ __typename?: 'Error', path: string, message: Array<string> }> | null } };

export type CityDetailsQueryVariables = Exact<{
  input: CityDetailsInput;
}>;


export type CityDetailsQuery = { __typename?: 'Query', cityDetails?: { __typename?: 'CityPayload', city?: { __typename?: 'City', id: number, city: string, country?: string | null, currency?: string | null, currencySymbol?: string | null, timezone?: string | null } | null, errors?: Array<{ __typename?: 'Error', path: string, message: Array<string> }> | null } | null };

export type SearchCityListQueryVariables = Exact<{ [key: string]: never; }>;


export type SearchCityListQuery = { __typename?: 'Query', searchCityList: { __typename?: 'SearchCityListPayload', cityList?: Array<{ __typename?: 'City', id: number, city: string, country?: string | null, currency?: string | null, currencySymbol?: string | null, timezone?: string | null }> | null } };

export type UpdateCityMutationVariables = Exact<{
  input: UpdateCityInput;
}>;


export type UpdateCityMutation = { __typename?: 'Mutation', updateCity: { __typename?: 'CityPayload', city?: { __typename?: 'City', id: number, city: string, country?: string | null, timezone?: string | null, currency?: string | null, currencySymbol?: string | null } | null, errors?: Array<{ __typename?: 'Error', path: string, message: Array<string> }> | null } };

export type CreateClientProfileMutationVariables = Exact<{
  input: CreateProfileInput;
}>;


export type CreateClientProfileMutation = { __typename?: 'Mutation', createClientProfile: { __typename?: 'ProfilePayload', accessToken?: string | null, profile?: { __typename?: 'Profile', id: string, email?: string | null, fullName?: string | null, image?: string | null, address?: string | null, phoneNumber?: string | null, refreshTokenVersion?: number | null, forgotPasswordLocked?: boolean | null, paymentTerms?: number | null, commission?: number | null, documents?: Array<string> | null, confirmed?: boolean | null, reported?: boolean | null, blocked?: boolean | null, createdAt?: string | null, updatedAt?: string | null, insuranceExpiryDate?: any | null, notes?: string | null, rating?: string | null, skillList?: Array<{ __typename?: 'Skill', id: number, name: string, icon?: string | null, iconName?: string | null }> | null, city?: { __typename?: 'City', id: number, city: string } | null, roles?: Array<{ __typename?: 'Role', id: number, name?: string | null }> | null } | null, errors?: Array<{ __typename?: 'Error', path: string, message: Array<string> }> | null } };

export type CreateFeedbackMutationVariables = Exact<{
  input: CreateFeedbackInput;
}>;


export type CreateFeedbackMutation = { __typename?: 'Mutation', createFeedback: { __typename?: 'CreateFeedbackPayload', errors?: Array<{ __typename?: 'Error', path: string, message: Array<string> }> | null } };

export type FeedbackListQueryVariables = Exact<{ [key: string]: never; }>;


export type FeedbackListQuery = { __typename?: 'Query', feedbackList: { __typename?: 'FeedbackListPayload', feedbackList?: Array<{ __typename?: 'Feedback', id: number, message: string, senderId?: string | null, createdAt?: any | null, updatedAt?: any | null }> | null } };

export type SearchHistoryQueryVariables = Exact<{
  input: SearchHistoryInput;
}>;


export type SearchHistoryQuery = { __typename?: 'Query', searchHistory: { __typename?: 'SearchHistoryPayload', historyList?: Array<{ __typename?: 'HistoryResultObject', id: number, createdAt?: any | null, tableName?: string | null, primaryId: string, operation: string, result: string }> | null } };

export type AcceptJobMutationVariables = Exact<{
  input: AcceptJobInput;
}>;


export type AcceptJobMutation = { __typename?: 'Mutation', acceptJob: { __typename?: 'JobPayload', job?: { __typename?: 'Job', id: number, referenceId?: string | null, title?: string | null, slug?: string | null, details?: string | null, completionNotes?: string | null, remedialNotes?: string | null, adminJobReportNotes?: string | null, address?: string | null, postCode?: string | null, propertyAccess?: string | null, slotDuration?: number | null, startTime?: any | null, images?: Array<string> | null, completionImages?: Array<string> | null, videos?: Array<string> | null, completionVideos?: Array<string> | null, completionDocuments?: Array<string> | null, jobStatusId?: number | null, supplierJobStatusId?: number | null, profileId?: string | null, authorId?: string | null, clientId?: string | null, supplierId?: string | null, cityId?: number | null, internalNotes?: string | null, labourCost?: number | null, materialCost?: number | null, otherCost?: number | null, clientCost?: number | null, supplierCost?: number | null, createdAt?: any | null, updatedAt?: any | null, publishedToApp?: boolean | null, b2cNotes?: string | null, skillList?: Array<{ __typename?: 'Skill', id: number, name: string, icon?: string | null, iconName?: string | null }> | null, location?: { __typename?: 'PointObject', type: string, coordinates: Array<number> } | null, startTimeSlots?: Array<{ __typename?: 'JobTimeSlot', date: string, slots: Array<number> }> | null, jobStatus?: { __typename?: 'JobStatus', id: number, title: string } | null, supplierJobStatus?: { __typename?: 'JobStatus', id: number, title: string } | null, profile?: { __typename?: 'Profile', id: string, fullName?: string | null } | null, author?: { __typename?: 'Profile', id: string, fullName?: string | null } | null, client?: { __typename?: 'Profile', id: string, fullName?: string | null, email?: string | null, phoneNumber?: string | null } | null, supplier?: { __typename?: 'Profile', id: string, fullName?: string | null } | null, preferredSupplierList?: Array<{ __typename?: 'Profile', id: string, fullName?: string | null }> | null, city?: { __typename?: 'City', id: number, city: string, country?: string | null, timezone?: string | null, currency?: string | null, currencySymbol?: string | null } | null } | null, errors?: Array<{ __typename?: 'Error', path: string, message: Array<string> }> | null } };

export type CreateJobMutationVariables = Exact<{
  input: UpdateJobInput;
}>;


export type CreateJobMutation = { __typename?: 'Mutation', createJob?: { __typename?: 'JobPayload', job?: { __typename?: 'Job', id: number, referenceId?: string | null, title?: string | null, slug?: string | null, details?: string | null, completionNotes?: string | null, remedialNotes?: string | null, adminJobReportNotes?: string | null, address?: string | null, postCode?: string | null, propertyAccess?: string | null, slotDuration?: number | null, startTime?: any | null, images?: Array<string> | null, completionImages?: Array<string> | null, videos?: Array<string> | null, completionVideos?: Array<string> | null, completionDocuments?: Array<string> | null, jobStatusId?: number | null, supplierJobStatusId?: number | null, profileId?: string | null, authorId?: string | null, clientId?: string | null, supplierId?: string | null, cityId?: number | null, internalNotes?: string | null, labourCost?: number | null, materialCost?: number | null, otherCost?: number | null, clientCost?: number | null, supplierCost?: number | null, createdAt?: any | null, updatedAt?: any | null, publishedToApp?: boolean | null, b2cNotes?: string | null, skillList?: Array<{ __typename?: 'Skill', id: number, name: string, icon?: string | null, iconName?: string | null }> | null, location?: { __typename?: 'PointObject', type: string, coordinates: Array<number> } | null, startTimeSlots?: Array<{ __typename?: 'JobTimeSlot', date: string, slots: Array<number> }> | null, jobStatus?: { __typename?: 'JobStatus', id: number, title: string } | null, supplierJobStatus?: { __typename?: 'JobStatus', id: number, title: string } | null, profile?: { __typename?: 'Profile', id: string, fullName?: string | null } | null, author?: { __typename?: 'Profile', id: string, fullName?: string | null } | null, client?: { __typename?: 'Profile', id: string, fullName?: string | null, email?: string | null, phoneNumber?: string | null } | null, supplier?: { __typename?: 'Profile', id: string, fullName?: string | null } | null, preferredSupplierList?: Array<{ __typename?: 'Profile', id: string, fullName?: string | null }> | null, city?: { __typename?: 'City', id: number, city: string, country?: string | null, timezone?: string | null, currency?: string | null, currencySymbol?: string | null } | null } | null, errors?: Array<{ __typename?: 'Error', path: string, message: Array<string> }> | null } | null };

export type AdminChatViewJobDetailsQueryVariables = Exact<{
  input: JobDetailsInput;
}>;


export type AdminChatViewJobDetailsQuery = { __typename?: 'Query', adminChatViewJobDetails: { __typename?: 'JobPayload', job?: { __typename?: 'Job', id: number, title?: string | null, supplierId?: string | null, address?: string | null } | null, errors?: Array<{ __typename?: 'Error', path: string, message: Array<string> }> | null } };

export type JobReportJobDetailsQueryVariables = Exact<{
  input: JobDetailsInput;
}>;


export type JobReportJobDetailsQuery = { __typename?: 'Query', jobReportJobDetails: { __typename?: 'JobPayload', job?: { __typename?: 'Job', id: number, referenceId?: string | null, title?: string | null, details?: string | null, address?: string | null, slotDuration?: number | null, startTime?: any | null, supplierJobStatusId?: number | null, supplierJobStatus?: { __typename?: 'JobStatus', id: number, title: string } | null, jobReport?: { __typename?: 'Quote', id: number, reportJobId?: number | null, description?: string | null, labourCost?: number | null, labourRevenue?: number | null, materialRevenue?: number | null, parkingCost?: number | null, parkingRevenue?: number | null, otherCost?: number | null, otherRevenue?: number | null, totalCost?: number | null, totalRevenues?: number | null, beforeImages?: Array<string> | null, images?: Array<string> | null, videos?: Array<string> | null, documents?: Array<string> | null, materialQuotes?: Array<{ __typename?: 'MeterialQuote', materialText: string, materialCost?: number | null, materialRevenues?: number | null }> | null } | null, quotes?: Array<{ __typename?: 'Quote', id: number, description?: string | null, labourRevenue?: number | null, parkingRevenue?: number | null, otherRevenue?: number | null, totalRevenues?: number | null, materialQuotes?: Array<{ __typename?: 'MeterialQuote', materialText: string, materialCost?: number | null, materialRevenues?: number | null }> | null }> | null } | null, errors?: Array<{ __typename?: 'Error', path: string, message: Array<string> }> | null } };

export type JobUpdateJobDetailsQueryVariables = Exact<{
  input: JobDetailsInput;
}>;


export type JobUpdateJobDetailsQuery = { __typename?: 'Query', jobUpdateJobDetails: { __typename?: 'JobPayload', job?: { __typename?: 'Job', id: number, referenceId?: string | null, title?: string | null, slug?: string | null, details?: string | null, completionNotes?: string | null, remedialNotes?: string | null, adminJobReportNotes?: string | null, address?: string | null, postCode?: string | null, propertyAccess?: string | null, slotDuration?: number | null, startTime?: any | null, images?: Array<string> | null, completionImages?: Array<string> | null, videos?: Array<string> | null, completionVideos?: Array<string> | null, completionDocuments?: Array<string> | null, jobStatusId?: number | null, supplierJobStatusId?: number | null, profileId?: string | null, authorId?: string | null, clientId?: string | null, supplierId?: string | null, cityId?: number | null, internalNotes?: string | null, labourCost?: number | null, materialCost?: number | null, otherCost?: number | null, clientCost?: number | null, supplierCost?: number | null, createdAt?: any | null, updatedAt?: any | null, publishedToApp?: boolean | null, b2cNotes?: string | null, problemCategory?: { __typename?: 'ProblemCategory', id: number, name?: string | null } | null, problemSubcategory?: { __typename?: 'ProblemSubcategory', id: number, name?: string | null, skillId?: number | null } | null, skillList?: Array<{ __typename?: 'Skill', id: number, name: string, icon?: string | null, iconName?: string | null }> | null, location?: { __typename?: 'PointObject', type: string, coordinates: Array<number> } | null, startTimeSlots?: Array<{ __typename?: 'JobTimeSlot', date: string, slots: Array<number> }> | null, jobStatus?: { __typename?: 'JobStatus', id: number, title: string } | null, supplierJobStatus?: { __typename?: 'JobStatus', id: number, title: string } | null, profile?: { __typename?: 'Profile', id: string, fullName?: string | null } | null, author?: { __typename?: 'Profile', id: string, fullName?: string | null } | null, client?: { __typename?: 'Profile', id: string, fullName?: string | null, email?: string | null, phoneNumber?: string | null } | null, supplier?: { __typename?: 'Profile', id: string, fullName?: string | null } | null, preferredSupplierList?: Array<{ __typename?: 'Profile', id: string, fullName?: string | null }> | null, city?: { __typename?: 'City', id: number, city: string, country?: string | null, timezone?: string | null, currency?: string | null, currencySymbol?: string | null } | null } | null, errors?: Array<{ __typename?: 'Error', path: string, message: Array<string> }> | null } };

export type JobDetailsQueryVariables = Exact<{
  input: JobDetailsInput;
}>;


export type JobDetailsQuery = { __typename?: 'Query', jobDetails: { __typename?: 'JobPayload', job?: { __typename?: 'Job', id: number, referenceId?: string | null, title?: string | null, slug?: string | null, details?: string | null, completionNotes?: string | null, remedialNotes?: string | null, adminJobReportNotes?: string | null, address?: string | null, postCode?: string | null, propertyAccess?: string | null, slotDuration?: number | null, startTime?: any | null, images?: Array<string> | null, completionImages?: Array<string> | null, videos?: Array<string> | null, completionVideos?: Array<string> | null, completionDocuments?: Array<string> | null, jobStatusId?: number | null, supplierJobStatusId?: number | null, profileId?: string | null, authorId?: string | null, clientId?: string | null, supplierId?: string | null, cityId?: number | null, internalNotes?: string | null, labourCost?: number | null, materialCost?: number | null, otherCost?: number | null, clientCost?: number | null, supplierCost?: number | null, createdAt?: any | null, updatedAt?: any | null, publishedToApp?: boolean | null, b2cNotes?: string | null, skillList?: Array<{ __typename?: 'Skill', id: number, name: string, icon?: string | null, iconName?: string | null }> | null, location?: { __typename?: 'PointObject', type: string, coordinates: Array<number> } | null, startTimeSlots?: Array<{ __typename?: 'JobTimeSlot', date: string, slots: Array<number> }> | null, jobStatus?: { __typename?: 'JobStatus', id: number, title: string } | null, supplierJobStatus?: { __typename?: 'JobStatus', id: number, title: string } | null, profile?: { __typename?: 'Profile', id: string, fullName?: string | null } | null, author?: { __typename?: 'Profile', id: string, fullName?: string | null } | null, client?: { __typename?: 'Profile', id: string, fullName?: string | null, email?: string | null, phoneNumber?: string | null } | null, supplier?: { __typename?: 'Profile', id: string, fullName?: string | null } | null, preferredSupplierList?: Array<{ __typename?: 'Profile', id: string, fullName?: string | null }> | null, city?: { __typename?: 'City', id: number, city: string, country?: string | null, timezone?: string | null, currency?: string | null, currencySymbol?: string | null } | null } | null, errors?: Array<{ __typename?: 'Error', path: string, message: Array<string> }> | null } };

export type ListJobQueryVariables = Exact<{ [key: string]: never; }>;


export type ListJobQuery = { __typename?: 'Query', listJob: { __typename?: 'ListJobPayload', jobList?: Array<{ __typename?: 'Job', id: number, slug?: string | null, jobStatusId?: number | null, supplierJobStatusId?: number | null, jobStatus?: { __typename?: 'JobStatus', id: number, title: string } | null, supplierJobStatus?: { __typename?: 'JobStatus', id: number, title: string } | null }> | null } };

export type AdminSearchJobListQueryVariables = Exact<{
  input: SeachJobListInput;
}>;


export type AdminSearchJobListQuery = { __typename?: 'Query', adminSearchJobList: { __typename?: 'SearchJobListPayload', hasMore: boolean, jobList?: Array<{ __typename?: 'Job', id: number, referenceId?: string | null, title?: string | null, details?: string | null, address?: string | null, postCode?: string | null, slotDuration?: number | null, jobStatusId?: number | null, supplierJobStatusId?: number | null, clientId?: string | null, supplierId?: string | null, startTime?: any | null, cityId?: number | null, internalNotes?: string | null, propertyAccess?: string | null, invoiceRef?: string | null, supplierCost?: number | null, clientCost?: number | null, profit?: number | null, publishedToApp?: boolean | null, city?: { __typename?: 'City', id: number, city: string, timezone?: string | null, currency?: string | null, currencySymbol?: string | null } | null, skillList?: Array<{ __typename?: 'Skill', id: number, name: string }> | null, startTimeSlots?: Array<{ __typename?: 'JobTimeSlot', date: string, slots: Array<number> }> | null, jobStatus?: { __typename?: 'JobStatus', id: number, title: string } | null, supplierJobStatus?: { __typename?: 'JobStatus', id: number, title: string } | null, client?: { __typename?: 'Profile', id: string, fullName?: string | null } | null, supplier?: { __typename?: 'Profile', id: string, fullName?: string | null } | null }> | null, cursor?: { __typename?: 'CursorPayload', id: string, date: any, score: number } | null } };

export type AppHomeSearchJobListQueryVariables = Exact<{
  input: AppHomeSearchJobListInput;
}>;


export type AppHomeSearchJobListQuery = { __typename?: 'Query', appHomeSearchJobList: { __typename?: 'SearchJobListPayload', hasMore: boolean, jobList?: Array<{ __typename?: 'Job', id: number, title?: string | null, address?: string | null, slotDuration?: number | null, startTime?: any | null, postCode?: string | null, location?: { __typename?: 'PointObject', type: string, coordinates: Array<number> } | null, startTimeSlots?: Array<{ __typename?: 'JobTimeSlot', date: string, slots: Array<number> }> | null, skillList?: Array<{ __typename?: 'Skill', id: number, name: string, icon?: string | null, iconName?: string | null }> | null }> | null, cursor?: { __typename?: 'CursorPayload', id: string, date: any, score: number } | null } };

export type AppNewChatJobListQueryVariables = Exact<{
  input: SeachJobListInput;
}>;


export type AppNewChatJobListQuery = { __typename?: 'Query', appNewChatJobList: { __typename?: 'SearchJobListPayload', hasMore: boolean, jobList?: Array<{ __typename?: 'Job', id: number, title?: string | null, createdAt?: any | null, address?: string | null }> | null, cursor?: { __typename?: 'CursorPayload', id: string, date: any, score: number } | null } };

export type SearchJobListQueryVariables = Exact<{
  input: SeachJobListInput;
}>;


export type SearchJobListQuery = { __typename?: 'Query', searchJobList: { __typename?: 'SearchJobListPayload', hasMore: boolean, jobList?: Array<{ __typename?: 'Job', jobStatusId?: number | null, supplierJobStatusId?: number | null, profileId?: string | null, authorId?: string | null, clientId?: string | null, supplierId?: string | null, id: number, referenceId?: string | null, title?: string | null, slug?: string | null, completionNotes?: string | null, details?: string | null, address?: string | null, postCode?: string | null, propertyAccess?: string | null, slotDuration?: number | null, startTime?: any | null, images?: Array<string> | null, completionImages?: Array<string> | null, videos?: Array<string> | null, completionVideos?: Array<string> | null, completionDocuments?: Array<string> | null, cityId?: number | null, labourCost?: number | null, materialCost?: number | null, otherCost?: number | null, remedialNotes?: string | null, clientCost?: number | null, supplierCost?: number | null, profit?: number | null, createdAt?: any | null, updatedAt?: any | null, jobStatus?: { __typename?: 'JobStatus', id: number, title: string } | null, supplierJobStatus?: { __typename?: 'JobStatus', id: number, title: string } | null, profile?: { __typename?: 'Profile', id: string, fullName?: string | null } | null, author?: { __typename?: 'Profile', id: string, fullName?: string | null } | null, client?: { __typename?: 'Profile', id: string, fullName?: string | null } | null, supplier?: { __typename?: 'Profile', id: string, fullName?: string | null } | null, preferredSupplierList?: Array<{ __typename?: 'Profile', id: string, fullName?: string | null }> | null, city?: { __typename?: 'City', id: number, city: string, country?: string | null, timezone?: string | null, currency?: string | null, currencySymbol?: string | null } | null, skillList?: Array<{ __typename?: 'Skill', id: number, name: string, icon?: string | null, iconName?: string | null }> | null, location?: { __typename?: 'PointObject', type: string, coordinates: Array<number> } | null }> | null, cursor?: { __typename?: 'CursorPayload', id: string, date: any, score: number } | null } };

export type SearchJobStatusListQueryVariables = Exact<{
  input: StatusListInput;
}>;


export type SearchJobStatusListQuery = { __typename?: 'Query', searchJobStatusList: { __typename?: 'JobStatusListPayload', jobStatusList?: Array<{ __typename?: 'JobStatus', id: number, title: string, description?: string | null, roleId?: number | null }> | null } };

export type UpdateJobMutationVariables = Exact<{
  input: UpdateJobInput;
}>;


export type UpdateJobMutation = { __typename?: 'Mutation', updateJob?: { __typename?: 'JobPayload', job?: { __typename?: 'Job', id: number, referenceId?: string | null, title?: string | null, slug?: string | null, completionNotes?: string | null, details?: string | null, address?: string | null, postCode?: string | null, propertyAccess?: string | null, slotDuration?: number | null, startTime?: any | null, images?: Array<string> | null, completionImages?: Array<string> | null, videos?: Array<string> | null, completionVideos?: Array<string> | null, completionDocuments?: Array<string> | null, cityId?: number | null, labourCost?: number | null, materialCost?: number | null, otherCost?: number | null, remedialNotes?: string | null, clientCost?: number | null, supplierCost?: number | null, profit?: number | null, createdAt?: any | null, updatedAt?: any | null, jobStatusId?: number | null, supplierJobStatusId?: number | null, city?: { __typename?: 'City', id: number, city: string, country?: string | null, timezone?: string | null, currency?: string | null, currencySymbol?: string | null } | null, skillList?: Array<{ __typename?: 'Skill', id: number, name: string, icon?: string | null, iconName?: string | null }> | null, location?: { __typename?: 'PointObject', type: string, coordinates: Array<number> } | null, jobStatus?: { __typename?: 'JobStatus', id: number, title: string } | null, supplierJobStatus?: { __typename?: 'JobStatus', id: number, title: string } | null } | null, errors?: Array<{ __typename?: 'Error', path: string, message: Array<string> }> | null } | null };

export type UpdatePartialJobMutationVariables = Exact<{
  input: UpdateJobInput;
}>;


export type UpdatePartialJobMutation = { __typename?: 'Mutation', updatePartialJob?: { __typename?: 'JobPayload', job?: { __typename?: 'Job', id: number, referenceId?: string | null, title?: string | null, slug?: string | null, completionNotes?: string | null, details?: string | null, address?: string | null, postCode?: string | null, propertyAccess?: string | null, slotDuration?: number | null, startTime?: any | null, images?: Array<string> | null, completionImages?: Array<string> | null, videos?: Array<string> | null, completionVideos?: Array<string> | null, completionDocuments?: Array<string> | null, cityId?: number | null, labourCost?: number | null, materialCost?: number | null, otherCost?: number | null, remedialNotes?: string | null, clientCost?: number | null, supplierCost?: number | null, profit?: number | null, createdAt?: any | null, updatedAt?: any | null, jobStatusId?: number | null, supplierJobStatusId?: number | null, location?: { __typename?: 'PointObject', type: string, coordinates: Array<number> } | null, jobStatus?: { __typename?: 'JobStatus', id: number, title: string } | null, supplierJobStatus?: { __typename?: 'JobStatus', id: number, title: string } | null } | null, errors?: Array<{ __typename?: 'Error', path: string, message: Array<string> }> | null } | null };

export type CreatePaymentIntentMutationVariables = Exact<{
  input: CreatePaymentIntentInput;
}>;


export type CreatePaymentIntentMutation = { __typename?: 'Mutation', createPaymentIntent?: { __typename?: 'CreatePaymentIntentPayload', clientSecret?: string | null, errors?: Array<{ __typename?: 'Error', path: string, message: Array<string> }> | null } | null };

export type SearchCityPriceQueryVariables = Exact<{
  input: SearchCityPriceInput;
}>;


export type SearchCityPriceQuery = { __typename?: 'Query', searchCityPrice: { __typename?: 'SearchCityPricePayload', cityPriceList?: Array<{ __typename?: 'CityPrice', price?: number | null }> | null } };

export type ProblemCategoryListQueryVariables = Exact<{ [key: string]: never; }>;


export type ProblemCategoryListQuery = { __typename?: 'Query', problemCategoryList: { __typename?: 'ProblemCategoryListPayload', problemCategoryList?: Array<{ __typename?: 'ProblemCategory', id: number, name?: string | null, iconName?: string | null, enabled?: boolean | null, problemSubcategoryConnection?: Array<{ __typename?: 'ProblemSubcategory', id: number, name?: string | null, skillId?: number | null, enabled?: boolean | null }> | null }> | null } };

export type ChangePasswordMutationVariables = Exact<{
  input: ChangePasswordInput;
}>;


export type ChangePasswordMutation = { __typename?: 'Mutation', changePassword?: { __typename?: 'ProfilePayload', profile?: { __typename?: 'Profile', id: string, email?: string | null, fullName?: string | null, image?: string | null, address?: string | null, phoneNumber?: string | null, refreshTokenVersion?: number | null, forgotPasswordLocked?: boolean | null, paymentTerms?: number | null, commission?: number | null, documents?: Array<string> | null, confirmed?: boolean | null, reported?: boolean | null, blocked?: boolean | null, createdAt?: string | null, updatedAt?: string | null, insuranceExpiryDate?: any | null, notes?: string | null, rating?: string | null, skillList?: Array<{ __typename?: 'Skill', id: number, name: string, icon?: string | null, iconName?: string | null }> | null, city?: { __typename?: 'City', id: number, city: string } | null, roles?: Array<{ __typename?: 'Role', id: number, name?: string | null }> | null } | null, errors?: Array<{ __typename?: 'Error', path: string, message: Array<string> }> | null } | null };

export type ConfirmEmailMutationVariables = Exact<{
  input: ConfirmEmailInput;
}>;


export type ConfirmEmailMutation = { __typename?: 'Mutation', confirmEmail?: { __typename?: 'ErrorPayload', errors?: Array<{ __typename?: 'Error', path: string, message: Array<string> }> | null } | null };

export type CreateB2CClientProfileMutationVariables = Exact<{
  input: CreateB2CClientProfileInput;
}>;


export type CreateB2CClientProfileMutation = { __typename?: 'Mutation', createB2CClientProfile: { __typename?: 'ProfilePayload', accessToken?: string | null, profile?: { __typename?: 'Profile', id: string, email?: string | null, fullName?: string | null, image?: string | null, address?: string | null, phoneNumber?: string | null, refreshTokenVersion?: number | null, forgotPasswordLocked?: boolean | null, paymentTerms?: number | null, commission?: number | null, documents?: Array<string> | null, confirmed?: boolean | null, reported?: boolean | null, blocked?: boolean | null, createdAt?: string | null, updatedAt?: string | null, insuranceExpiryDate?: any | null, notes?: string | null, rating?: string | null, skillList?: Array<{ __typename?: 'Skill', id: number, name: string, icon?: string | null, iconName?: string | null }> | null, city?: { __typename?: 'City', id: number, city: string } | null, roles?: Array<{ __typename?: 'Role', id: number, name?: string | null }> | null } | null, errors?: Array<{ __typename?: 'Error', path: string, message: Array<string> }> | null } };

export type CreateProfileMutationVariables = Exact<{
  input: CreateProfileInput;
}>;


export type CreateProfileMutation = { __typename?: 'Mutation', createProfile: { __typename?: 'ProfilePayload', accessToken?: string | null, profile?: { __typename?: 'Profile', id: string, email?: string | null, fullName?: string | null, image?: string | null, address?: string | null, phoneNumber?: string | null, refreshTokenVersion?: number | null, forgotPasswordLocked?: boolean | null, paymentTerms?: number | null, commission?: number | null, documents?: Array<string> | null, confirmed?: boolean | null, reported?: boolean | null, blocked?: boolean | null, createdAt?: string | null, updatedAt?: string | null, insuranceExpiryDate?: any | null, notes?: string | null, rating?: string | null, skillList?: Array<{ __typename?: 'Skill', id: number, name: string, icon?: string | null, iconName?: string | null }> | null, city?: { __typename?: 'City', id: number, city: string } | null, roles?: Array<{ __typename?: 'Role', id: number, name?: string | null }> | null } | null, errors?: Array<{ __typename?: 'Error', path: string, message: Array<string> }> | null } };

export type ForgotPasswordConfirmEmailMutationVariables = Exact<{
  input: ForgotPasswordConfirmEmailInput;
}>;


export type ForgotPasswordConfirmEmailMutation = { __typename?: 'Mutation', forgotPasswordConfirmEmail?: { __typename?: 'ForgotPasswordConfirmEmailPayload', profileId?: string | null, errors?: Array<{ __typename?: 'Error', path: string, message: Array<string> }> | null } | null };

export type ForgotPasswordSendEmailMutationVariables = Exact<{
  input: ForgotPasswordSendEmailInput;
}>;


export type ForgotPasswordSendEmailMutation = { __typename?: 'Mutation', forgotPasswordSendEmail?: { __typename?: 'ErrorPayload', errors?: Array<{ __typename?: 'Error', path: string, message: Array<string> }> | null } | null };

export type ProfileDetailsQueryVariables = Exact<{
  input: ProfileDetailsInput;
}>;


export type ProfileDetailsQuery = { __typename?: 'Query', profileDetails?: { __typename?: 'UserPayload', profile?: { __typename?: 'Profile', id: string, email?: string | null, fullName?: string | null, image?: string | null, address?: string | null, phoneNumber?: string | null, refreshTokenVersion?: number | null, forgotPasswordLocked?: boolean | null, paymentTerms?: number | null, commission?: number | null, documents?: Array<string> | null, confirmed?: boolean | null, reported?: boolean | null, blocked?: boolean | null, createdAt?: string | null, updatedAt?: string | null, insuranceExpiryDate?: any | null, notes?: string | null, rating?: string | null, skillList?: Array<{ __typename?: 'Skill', id: number, name: string, icon?: string | null, iconName?: string | null }> | null, city?: { __typename?: 'City', id: number, city: string } | null, roles?: Array<{ __typename?: 'Role', id: number, name?: string | null }> | null } | null, errors?: Array<{ __typename?: 'Error', path: string, message: Array<string> }> | null } | null };

export type ResetPasswordMutationVariables = Exact<{
  input: ResetPasswordInput;
}>;


export type ResetPasswordMutation = { __typename?: 'Mutation', resetPassword?: { __typename?: 'ErrorPayload', errors?: Array<{ __typename?: 'Error', path: string, message: Array<string> }> | null } | null };

export type SearchProfileListQueryVariables = Exact<{
  input: SearchProfileListInput;
}>;


export type SearchProfileListQuery = { __typename?: 'Query', searchProfileList: { __typename?: 'SearchProfileListPayload', profileList?: Array<{ __typename?: 'Profile', id: string, email?: string | null, fullName?: string | null, image?: string | null, address?: string | null, phoneNumber?: string | null, refreshTokenVersion?: number | null, forgotPasswordLocked?: boolean | null, paymentTerms?: number | null, commission?: number | null, documents?: Array<string> | null, confirmed?: boolean | null, reported?: boolean | null, blocked?: boolean | null, createdAt?: string | null, updatedAt?: string | null, insuranceExpiryDate?: any | null, notes?: string | null, rating?: string | null, skillList?: Array<{ __typename?: 'Skill', id: number, name: string, icon?: string | null, iconName?: string | null }> | null, city?: { __typename?: 'City', id: number, city: string } | null, roles?: Array<{ __typename?: 'Role', id: number, name?: string | null }> | null }> | null } };

export type UpdateProfileMutationVariables = Exact<{
  input: UpdateProfileInput;
}>;


export type UpdateProfileMutation = { __typename?: 'Mutation', updateProfile: { __typename?: 'ProfilePayload', accessToken?: string | null, profile?: { __typename?: 'Profile', id: string, email?: string | null, fullName?: string | null, image?: string | null, address?: string | null, phoneNumber?: string | null, refreshTokenVersion?: number | null, forgotPasswordLocked?: boolean | null, paymentTerms?: number | null, commission?: number | null, documents?: Array<string> | null, confirmed?: boolean | null, reported?: boolean | null, blocked?: boolean | null, createdAt?: string | null, updatedAt?: string | null, insuranceExpiryDate?: any | null, notes?: string | null, rating?: string | null, skillList?: Array<{ __typename?: 'Skill', id: number, name: string, icon?: string | null, iconName?: string | null }> | null, city?: { __typename?: 'City', id: number, city: string } | null, roles?: Array<{ __typename?: 'Role', id: number, name?: string | null }> | null } | null, errors?: Array<{ __typename?: 'Error', path: string, message: Array<string> }> | null } };

export type CreateQuoteMutationVariables = Exact<{
  input: CreateQuoteInput;
}>;


export type CreateQuoteMutation = { __typename?: 'Mutation', createQuote?: { __typename?: 'QuotePayload', quote?: { __typename?: 'Quote', id: number } | null, errors?: Array<{ __typename?: 'Error', path: string, message: Array<string> }> | null } | null };

export type CreateRemoteQuoteMutationVariables = Exact<{
  input: CreateRemoteQuoteInput;
}>;


export type CreateRemoteQuoteMutation = { __typename?: 'Mutation', createRemoteQuote?: { __typename?: 'ErrorPayload', errors?: Array<{ __typename?: 'Error', path: string, message: Array<string> }> | null } | null };

export type SeachJobReportQueryVariables = Exact<{
  input: SeachJobReportInput;
}>;


export type SeachJobReportQuery = { __typename?: 'Query', seachJobReport?: { __typename?: 'JobPayload', job?: { __typename?: 'Job', id: number, referenceId?: string | null, remedialNotes?: string | null, adminJobReportNotes?: string | null, completionImages?: Array<string> | null, completionVideos?: Array<string> | null } | null } | null };

export type GetJobReviewDetailsQueryVariables = Exact<{
  input: FindJobItemInput;
}>;


export type GetJobReviewDetailsQuery = { __typename?: 'Query', getJobReviewDetails: { __typename?: 'JobPayload', job?: { __typename?: 'Job', id: number, referenceId?: string | null, address?: string | null, clientReview?: { __typename?: 'Review', supplierFeedbackRating?: number | null, supplierFeedbackDetails?: string | null, qeeperFeedbackRating?: number | null, qeeperFeedbackDetails?: string | null, qeeperComments?: string | null, reviewStatus?: string | null } | null } | null, errors?: Array<{ __typename?: 'Error', path: string, message: Array<string> }> | null } };

export type CreateReviewMutationVariables = Exact<{
  input: CreateReviewInput;
}>;


export type CreateReviewMutation = { __typename?: 'Mutation', createReview?: { __typename?: 'ReviewPayload', review?: { __typename?: 'Review', id: number } | null, errors?: Array<{ __typename?: 'Error', path: string, message: Array<string> }> | null } | null };

export type AnalyticSkillListQueryVariables = Exact<{
  input: AnalyticInput;
}>;


export type AnalyticSkillListQuery = { __typename?: 'Query', analyticSkillList: { __typename?: 'AnalyticPiePayload', dataList?: Array<{ __typename?: 'AnalyticList', label?: string | null, value?: number | null }> | null } };

export type ListSkillQueryVariables = Exact<{ [key: string]: never; }>;


export type ListSkillQuery = { __typename?: 'Query', listSkill: Array<{ __typename?: 'Skill', id: number, name: string, icon?: string | null, iconName?: string | null }> };

export type LoginMutationVariables = Exact<{
  input: LoginInput;
}>;


export type LoginMutation = { __typename?: 'Mutation', login: { __typename?: 'ProfilePayload', accessToken?: string | null, profile?: { __typename?: 'Profile', id: string, email?: string | null, fullName?: string | null, image?: string | null, address?: string | null, phoneNumber?: string | null, refreshTokenVersion?: number | null, forgotPasswordLocked?: boolean | null, paymentTerms?: number | null, commission?: number | null, documents?: Array<string> | null, confirmed?: boolean | null, reported?: boolean | null, blocked?: boolean | null, createdAt?: string | null, updatedAt?: string | null, insuranceExpiryDate?: any | null, notes?: string | null, rating?: string | null, skillList?: Array<{ __typename?: 'Skill', id: number, name: string, icon?: string | null, iconName?: string | null }> | null, city?: { __typename?: 'City', id: number, city: string } | null, roles?: Array<{ __typename?: 'Role', id: number, name?: string | null }> | null } | null, errors?: Array<{ __typename?: 'Error', path: string, message: Array<string> }> | null } };

export type LogoutMutationVariables = Exact<{ [key: string]: never; }>;


export type LogoutMutation = { __typename?: 'Mutation', logout: boolean };

export type MeQueryVariables = Exact<{ [key: string]: never; }>;


export type MeQuery = { __typename?: 'Query', me?: { __typename?: 'ProfilePayload', accessToken?: string | null, profile?: { __typename?: 'Profile', id: string, email?: string | null, fullName?: string | null, image?: string | null, address?: string | null, phoneNumber?: string | null, refreshTokenVersion?: number | null, forgotPasswordLocked?: boolean | null, confirmed?: boolean | null, reported?: boolean | null, blocked?: boolean | null, createdAt?: string | null, updatedAt?: string | null, roles?: Array<{ __typename?: 'Role', id: number, name?: string | null }> | null, skillList?: Array<{ __typename?: 'Skill', id: number, name: string, icon?: string | null, iconName?: string | null }> | null } | null, errors?: Array<{ __typename?: 'Error', path: string, message: Array<string> }> | null } | null };

export const ChatMessageFragments_ChatMessageFragmentDoc = `
    fragment ChatMessageFragments_chatMessage on ChatMessage {
  id
  text
  isAdmin
  jobId
  createdAt
}
    `;
export const ChatMessageFragments_ChatMessageDetailsFragmentDoc = `
    fragment ChatMessageFragments_chatMessageDetails on ChatMessage {
  id
  text
  isAdmin
  jobId
  createdAt
}
    `;
export const CityFragments_AdminCityJobListFragmentDoc = `
    fragment CityFragments_adminCityJobList on City {
  id
  city
  timezone
  currency
  currencySymbol
}
    `;
export const CursorFragments_CursorFragmentDoc = `
    fragment CursorFragments_cursor on CursorPayload {
  id
  date
  score
}
    `;
export const ErrorFragments_ErrorFragmentDoc = `
    fragment ErrorFragments_error on Error {
  path
  message
}
    `;
export const FeedbackFragments_FeedbackFragmentDoc = `
    fragment FeedbackFragments_feedback on Feedback {
  id
  message
  senderId
  createdAt
  updatedAt
}
    `;
export const SkillFragments_SkillFragmentDoc = `
    fragment SkillFragments_skill on Skill {
  id
  name
  icon
  iconName
}
    `;
export const CityFragments_CityFragmentDoc = `
    fragment CityFragments_city on City {
  id
  city
  country
  timezone
  currency
  currencySymbol
}
    `;
export const JobFragments_JobFragmentDoc = `
    fragment JobFragments_job on Job {
  id
  referenceId
  title
  slug
  details
  completionNotes
  remedialNotes
  adminJobReportNotes
  skillList {
    ...SkillFragments_skill
  }
  address
  location {
    type
    coordinates
  }
  postCode
  propertyAccess
  slotDuration
  startTimeSlots {
    date
    slots
  }
  startTime
  images
  completionImages
  videos
  completionVideos
  completionDocuments
  jobStatusId
  jobStatus {
    id
    title
  }
  supplierJobStatusId
  supplierJobStatus {
    id
    title
  }
  profileId
  profile {
    id
    fullName
  }
  authorId
  author {
    id
    fullName
  }
  clientId
  client {
    id
    fullName
    email
    phoneNumber
  }
  supplierId
  supplier {
    id
    fullName
  }
  preferredSupplierList {
    id
    fullName
  }
  cityId
  city {
    ...CityFragments_city
  }
  internalNotes
  labourCost
  materialCost
  otherCost
  clientCost
  supplierCost
  createdAt
  updatedAt
  publishedToApp
  b2cNotes
}
    ${SkillFragments_SkillFragmentDoc}
${CityFragments_CityFragmentDoc}`;
export const JobFragments_JobSimpleFragmentDoc = `
    fragment JobFragments_jobSimple on Job {
  id
  referenceId
  title
  slug
  completionNotes
  details
  address
  location {
    type
    coordinates
  }
  postCode
  propertyAccess
  slotDuration
  startTime
  images
  completionImages
  videos
  completionVideos
  completionDocuments
  cityId
  labourCost
  materialCost
  otherCost
  remedialNotes
  clientCost
  supplierCost
  profit
  createdAt
  updatedAt
  jobStatusId
  jobStatus {
    id
    title
  }
  supplierJobStatusId
  supplierJobStatus {
    id
    title
  }
}
    `;
export const JobFragments_AdminJobListFragmentDoc = `
    fragment JobFragments_adminJobList on Job {
  id
  referenceId
  title
  details
  address
  postCode
  slotDuration
  startTimeSlots {
    date
    slots
  }
  jobStatusId
  jobStatus {
    id
    title
  }
  supplierJobStatusId
  supplierJobStatus {
    id
    title
  }
  clientId
  client {
    id
    fullName
  }
  supplierId
  supplier {
    id
    fullName
  }
  startTime
  cityId
  internalNotes
  propertyAccess
  invoiceRef
  supplierCost
  clientCost
  profit
  publishedToApp
}
    `;
export const JobFragments_ChatListFragmentDoc = `
    fragment JobFragments_chatList on Job {
  id
  title
  address
  chatCheckedAdmin
  chatCheckedSupplier
  profileId
  profile {
    id
    fullName
  }
  authorId
  author {
    id
    fullName
  }
  clientId
  client {
    id
    fullName
  }
  supplierId
  supplier {
    id
    fullName
  }
  preferredSupplierList {
    id
    fullName
  }
}
    `;
export const JobFragments_ChatDetailsFragmentDoc = `
    fragment JobFragments_chatDetails on Job {
  id
  title
  slug
  chatCheckedAdmin
  chatCheckedSupplier
}
    `;
export const JobStatusFragments_JobStatusFragmentDoc = `
    fragment JobStatusFragments_jobStatus on JobStatus {
  id
  title
  description
  roleId
}
    `;
export const ProfileFragments_ProfileFragmentDoc = `
    fragment ProfileFragments_profile on Profile {
  id
  email
  fullName
  image
  address
  phoneNumber
  refreshTokenVersion
  forgotPasswordLocked
  paymentTerms
  commission
  documents
  confirmed
  reported
  blocked
  createdAt
  updatedAt
  skillList {
    ...SkillFragments_skill
  }
  city {
    id
    city
  }
  roles {
    id
    name
  }
  insuranceExpiryDate
  notes
  rating
}
    ${SkillFragments_SkillFragmentDoc}`;
export const ProfileFragments_ProfileDetailedFragmentDoc = `
    fragment ProfileFragments_profileDetailed on Profile {
  id
  email
  fullName
  image
  address
  phoneNumber
  refreshTokenVersion
  forgotPasswordLocked
  confirmed
  reported
  blocked
  createdAt
  updatedAt
  roles {
    id
    name
  }
  skillList {
    ...SkillFragments_skill
  }
}
    ${SkillFragments_SkillFragmentDoc}`;
export const SkillFragments_AdminJobListSkillFragmentDoc = `
    fragment SkillFragments_adminJobListSkill on Skill {
  id
  name
}
    `;
export const AnalyticFinancialDocument = `
    query AnalyticFinancial($input: AnalyticInput!) {
  analyticFinancial(input: $input) {
    dataList {
      month
      cogs
      revenues
    }
  }
}
    `;
export const useAnalyticFinancialQuery = <
      TData = AnalyticFinancialQuery,
      TError = unknown
    >(
      variables: AnalyticFinancialQueryVariables,
      options?: UseQueryOptions<AnalyticFinancialQuery, TError, TData>
    ) =>
    useQuery<AnalyticFinancialQuery, TError, TData>(
      ['AnalyticFinancial', variables],
      fetchData<AnalyticFinancialQuery, AnalyticFinancialQueryVariables>(AnalyticFinancialDocument, variables),
      options
    );
export const AnalyticJobListDocument = `
    query AnalyticJobList($input: AnalyticJobListInput!) {
  analyticJobList(input: $input) {
    jobList {
      id
      title
      startTime
      slotDuration
      city {
        timezone
      }
      jobStatusId
      supplier {
        fullName
      }
    }
    hasMore
    cursor {
      ...CursorFragments_cursor
    }
  }
}
    ${CursorFragments_CursorFragmentDoc}`;
export const useAnalyticJobListQuery = <
      TData = AnalyticJobListQuery,
      TError = unknown
    >(
      variables: AnalyticJobListQueryVariables,
      options?: UseQueryOptions<AnalyticJobListQuery, TError, TData>
    ) =>
    useQuery<AnalyticJobListQuery, TError, TData>(
      ['AnalyticJobList', variables],
      fetchData<AnalyticJobListQuery, AnalyticJobListQueryVariables>(AnalyticJobListDocument, variables),
      options
    );
export const AnalyticSupplierlListDocument = `
    query AnalyticSupplierlList($input: AnalyticInput!) {
  analyticSupplierlList(input: $input) {
    dataList {
      label
      value
    }
  }
}
    `;
export const useAnalyticSupplierlListQuery = <
      TData = AnalyticSupplierlListQuery,
      TError = unknown
    >(
      variables: AnalyticSupplierlListQueryVariables,
      options?: UseQueryOptions<AnalyticSupplierlListQuery, TError, TData>
    ) =>
    useQuery<AnalyticSupplierlListQuery, TError, TData>(
      ['AnalyticSupplierlList', variables],
      fetchData<AnalyticSupplierlListQuery, AnalyticSupplierlListQueryVariables>(AnalyticSupplierlListDocument, variables),
      options
    );
export const AnalyticJobsByCityDocument = `
    query AnalyticJobsByCity($input: AnalyticInput!) {
  analyticJobsByCity(input: $input) {
    dataList {
      label
      value
    }
  }
}
    `;
export const useAnalyticJobsByCityQuery = <
      TData = AnalyticJobsByCityQuery,
      TError = unknown
    >(
      variables: AnalyticJobsByCityQueryVariables,
      options?: UseQueryOptions<AnalyticJobsByCityQuery, TError, TData>
    ) =>
    useQuery<AnalyticJobsByCityQuery, TError, TData>(
      ['AnalyticJobsByCity', variables],
      fetchData<AnalyticJobsByCityQuery, AnalyticJobsByCityQueryVariables>(AnalyticJobsByCityDocument, variables),
      options
    );
export const AnalyticJobsByClientDocument = `
    query AnalyticJobsByClient($input: AnalyticInput!) {
  analyticJobsByClient(input: $input) {
    dataList {
      label
      value
    }
  }
}
    `;
export const useAnalyticJobsByClientQuery = <
      TData = AnalyticJobsByClientQuery,
      TError = unknown
    >(
      variables: AnalyticJobsByClientQueryVariables,
      options?: UseQueryOptions<AnalyticJobsByClientQuery, TError, TData>
    ) =>
    useQuery<AnalyticJobsByClientQuery, TError, TData>(
      ['AnalyticJobsByClient', variables],
      fetchData<AnalyticJobsByClientQuery, AnalyticJobsByClientQueryVariables>(AnalyticJobsByClientDocument, variables),
      options
    );
export const AnalyticJobCountDocument = `
    query AnalyticJobCount($input: AnalyticInput!) {
  analyticJobCount(input: $input) {
    dataList {
      month
      count
    }
  }
}
    `;
export const useAnalyticJobCountQuery = <
      TData = AnalyticJobCountQuery,
      TError = unknown
    >(
      variables: AnalyticJobCountQueryVariables,
      options?: UseQueryOptions<AnalyticJobCountQuery, TError, TData>
    ) =>
    useQuery<AnalyticJobCountQuery, TError, TData>(
      ['AnalyticJobCount', variables],
      fetchData<AnalyticJobCountQuery, AnalyticJobCountQueryVariables>(AnalyticJobCountDocument, variables),
      options
    );
export const MeAppDocument = `
    query MeApp {
  me {
    profile {
      id
      fullName
      notiTokens
      skillList {
        id
      }
      roles {
        id
        name
      }
    }
    errors {
      ...ErrorFragments_error
    }
  }
}
    ${ErrorFragments_ErrorFragmentDoc}`;
export const useMeAppQuery = <
      TData = MeAppQuery,
      TError = unknown
    >(
      variables?: MeAppQueryVariables,
      options?: UseQueryOptions<MeAppQuery, TError, TData>
    ) =>
    useQuery<MeAppQuery, TError, TData>(
      variables === undefined ? ['MeApp'] : ['MeApp', variables],
      fetchData<MeAppQuery, MeAppQueryVariables>(MeAppDocument, variables),
      options
    );
export const CreateBookingDocument = `
    mutation CreateBooking($input: CreateBookingInput!) {
  createBooking(input: $input) {
    job {
      ...JobFragments_job
    }
    errors {
      ...ErrorFragments_error
    }
  }
}
    ${JobFragments_JobFragmentDoc}
${ErrorFragments_ErrorFragmentDoc}`;
export const useCreateBookingMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<CreateBookingMutation, TError, CreateBookingMutationVariables, TContext>) =>
    useMutation<CreateBookingMutation, TError, CreateBookingMutationVariables, TContext>(
      ['CreateBooking'],
      (variables?: CreateBookingMutationVariables) => fetchData<CreateBookingMutation, CreateBookingMutationVariables>(CreateBookingDocument, variables)(),
      options
    );
export const AddChatMessageDocument = `
    mutation AddChatMessage($input: AddChatMessageInput!) {
  addChatMessage(input: $input) {
    chatMessage {
      ...ChatMessageFragments_chatMessage
    }
    errors {
      ...ErrorFragments_error
    }
  }
}
    ${ChatMessageFragments_ChatMessageFragmentDoc}
${ErrorFragments_ErrorFragmentDoc}`;
export const useAddChatMessageMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<AddChatMessageMutation, TError, AddChatMessageMutationVariables, TContext>) =>
    useMutation<AddChatMessageMutation, TError, AddChatMessageMutationVariables, TContext>(
      ['AddChatMessage'],
      (variables?: AddChatMessageMutationVariables) => fetchData<AddChatMessageMutation, AddChatMessageMutationVariables>(AddChatMessageDocument, variables)(),
      options
    );
export const NewChatMessageDocument = `
    subscription NewChatMessage($receiverId: String) {
  newChatMessage(receiverId: $receiverId) {
    ...ChatMessageFragments_chatMessage
  }
}
    ${ChatMessageFragments_ChatMessageFragmentDoc}`;
export const ChatCheckedDocument = `
    mutation ChatChecked($input: ChatCheckedInput!) {
  chatChecked(input: $input)
}
    `;
export const useChatCheckedMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<ChatCheckedMutation, TError, ChatCheckedMutationVariables, TContext>) =>
    useMutation<ChatCheckedMutation, TError, ChatCheckedMutationVariables, TContext>(
      ['ChatChecked'],
      (variables?: ChatCheckedMutationVariables) => fetchData<ChatCheckedMutation, ChatCheckedMutationVariables>(ChatCheckedDocument, variables)(),
      options
    );
export const ChatNotificationCountDocument = `
    query ChatNotificationCount {
  chatNotificationCount
}
    `;
export const useChatNotificationCountQuery = <
      TData = ChatNotificationCountQuery,
      TError = unknown
    >(
      variables?: ChatNotificationCountQueryVariables,
      options?: UseQueryOptions<ChatNotificationCountQuery, TError, TData>
    ) =>
    useQuery<ChatNotificationCountQuery, TError, TData>(
      variables === undefined ? ['ChatNotificationCount'] : ['ChatNotificationCount', variables],
      fetchData<ChatNotificationCountQuery, ChatNotificationCountQueryVariables>(ChatNotificationCountDocument, variables),
      options
    );
export const JobChatListDocument = `
    query JobChatList($input: JobChatListInput!) {
  jobChatList(input: $input) {
    chatList {
      ...ChatMessageFragments_chatMessage
      job {
        ...JobFragments_chatList
      }
    }
    hasMore
    cursor {
      ...CursorFragments_cursor
    }
  }
}
    ${ChatMessageFragments_ChatMessageFragmentDoc}
${JobFragments_ChatListFragmentDoc}
${CursorFragments_CursorFragmentDoc}`;
export const useJobChatListQuery = <
      TData = JobChatListQuery,
      TError = unknown
    >(
      variables: JobChatListQueryVariables,
      options?: UseQueryOptions<JobChatListQuery, TError, TData>
    ) =>
    useQuery<JobChatListQuery, TError, TData>(
      ['JobChatList', variables],
      fetchData<JobChatListQuery, JobChatListQueryVariables>(JobChatListDocument, variables),
      options
    );
export const SearchChatMessageDocument = `
    query SearchChatMessage($input: SearchChatMessageInput!) {
  searchChatMessage(input: $input) {
    chatMessageList {
      ...ChatMessageFragments_chatMessageDetails
    }
    jobDetails {
      ...JobFragments_chatDetails
    }
    hasMore
    cursor {
      ...CursorFragments_cursor
    }
  }
}
    ${ChatMessageFragments_ChatMessageDetailsFragmentDoc}
${JobFragments_ChatDetailsFragmentDoc}
${CursorFragments_CursorFragmentDoc}`;
export const useSearchChatMessageQuery = <
      TData = SearchChatMessageQuery,
      TError = unknown
    >(
      variables: SearchChatMessageQueryVariables,
      options?: UseQueryOptions<SearchChatMessageQuery, TError, TData>
    ) =>
    useQuery<SearchChatMessageQuery, TError, TData>(
      ['SearchChatMessage', variables],
      fetchData<SearchChatMessageQuery, SearchChatMessageQueryVariables>(SearchChatMessageDocument, variables),
      options
    );
export const AddCityDocument = `
    mutation AddCity($input: AddCityInput!) {
  addCity(input: $input) {
    city {
      ...CityFragments_city
    }
    errors {
      ...ErrorFragments_error
    }
  }
}
    ${CityFragments_CityFragmentDoc}
${ErrorFragments_ErrorFragmentDoc}`;
export const useAddCityMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<AddCityMutation, TError, AddCityMutationVariables, TContext>) =>
    useMutation<AddCityMutation, TError, AddCityMutationVariables, TContext>(
      ['AddCity'],
      (variables?: AddCityMutationVariables) => fetchData<AddCityMutation, AddCityMutationVariables>(AddCityDocument, variables)(),
      options
    );
export const CityDetailsDocument = `
    query CityDetails($input: CityDetailsInput!) {
  cityDetails(input: $input) {
    city {
      id
      city
      country
      currency
      currencySymbol
      timezone
    }
    errors {
      ...ErrorFragments_error
    }
  }
}
    ${ErrorFragments_ErrorFragmentDoc}`;
export const useCityDetailsQuery = <
      TData = CityDetailsQuery,
      TError = unknown
    >(
      variables: CityDetailsQueryVariables,
      options?: UseQueryOptions<CityDetailsQuery, TError, TData>
    ) =>
    useQuery<CityDetailsQuery, TError, TData>(
      ['CityDetails', variables],
      fetchData<CityDetailsQuery, CityDetailsQueryVariables>(CityDetailsDocument, variables),
      options
    );
export const SearchCityListDocument = `
    query SearchCityList {
  searchCityList {
    cityList {
      id
      city
      country
      currency
      currencySymbol
      timezone
    }
  }
}
    `;
export const useSearchCityListQuery = <
      TData = SearchCityListQuery,
      TError = unknown
    >(
      variables?: SearchCityListQueryVariables,
      options?: UseQueryOptions<SearchCityListQuery, TError, TData>
    ) =>
    useQuery<SearchCityListQuery, TError, TData>(
      variables === undefined ? ['SearchCityList'] : ['SearchCityList', variables],
      fetchData<SearchCityListQuery, SearchCityListQueryVariables>(SearchCityListDocument, variables),
      options
    );
export const UpdateCityDocument = `
    mutation UpdateCity($input: UpdateCityInput!) {
  updateCity(input: $input) {
    city {
      ...CityFragments_city
    }
    errors {
      ...ErrorFragments_error
    }
  }
}
    ${CityFragments_CityFragmentDoc}
${ErrorFragments_ErrorFragmentDoc}`;
export const useUpdateCityMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<UpdateCityMutation, TError, UpdateCityMutationVariables, TContext>) =>
    useMutation<UpdateCityMutation, TError, UpdateCityMutationVariables, TContext>(
      ['UpdateCity'],
      (variables?: UpdateCityMutationVariables) => fetchData<UpdateCityMutation, UpdateCityMutationVariables>(UpdateCityDocument, variables)(),
      options
    );
export const CreateClientProfileDocument = `
    mutation CreateClientProfile($input: CreateProfileInput!) {
  createClientProfile(input: $input) {
    profile {
      ...ProfileFragments_profile
    }
    accessToken
    errors {
      ...ErrorFragments_error
    }
  }
}
    ${ProfileFragments_ProfileFragmentDoc}
${ErrorFragments_ErrorFragmentDoc}`;
export const useCreateClientProfileMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<CreateClientProfileMutation, TError, CreateClientProfileMutationVariables, TContext>) =>
    useMutation<CreateClientProfileMutation, TError, CreateClientProfileMutationVariables, TContext>(
      ['CreateClientProfile'],
      (variables?: CreateClientProfileMutationVariables) => fetchData<CreateClientProfileMutation, CreateClientProfileMutationVariables>(CreateClientProfileDocument, variables)(),
      options
    );
export const CreateFeedbackDocument = `
    mutation CreateFeedback($input: CreateFeedbackInput!) {
  createFeedback(input: $input) {
    errors {
      ...ErrorFragments_error
    }
  }
}
    ${ErrorFragments_ErrorFragmentDoc}`;
export const useCreateFeedbackMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<CreateFeedbackMutation, TError, CreateFeedbackMutationVariables, TContext>) =>
    useMutation<CreateFeedbackMutation, TError, CreateFeedbackMutationVariables, TContext>(
      ['CreateFeedback'],
      (variables?: CreateFeedbackMutationVariables) => fetchData<CreateFeedbackMutation, CreateFeedbackMutationVariables>(CreateFeedbackDocument, variables)(),
      options
    );
export const FeedbackListDocument = `
    query FeedbackList {
  feedbackList {
    feedbackList {
      ...FeedbackFragments_feedback
    }
  }
}
    ${FeedbackFragments_FeedbackFragmentDoc}`;
export const useFeedbackListQuery = <
      TData = FeedbackListQuery,
      TError = unknown
    >(
      variables?: FeedbackListQueryVariables,
      options?: UseQueryOptions<FeedbackListQuery, TError, TData>
    ) =>
    useQuery<FeedbackListQuery, TError, TData>(
      variables === undefined ? ['FeedbackList'] : ['FeedbackList', variables],
      fetchData<FeedbackListQuery, FeedbackListQueryVariables>(FeedbackListDocument, variables),
      options
    );
export const SearchHistoryDocument = `
    query SearchHistory($input: SearchHistoryInput!) {
  searchHistory(input: $input) {
    historyList {
      id
      createdAt
      tableName
      primaryId
      operation
      result
    }
  }
}
    `;
export const useSearchHistoryQuery = <
      TData = SearchHistoryQuery,
      TError = unknown
    >(
      variables: SearchHistoryQueryVariables,
      options?: UseQueryOptions<SearchHistoryQuery, TError, TData>
    ) =>
    useQuery<SearchHistoryQuery, TError, TData>(
      ['SearchHistory', variables],
      fetchData<SearchHistoryQuery, SearchHistoryQueryVariables>(SearchHistoryDocument, variables),
      options
    );
export const AcceptJobDocument = `
    mutation AcceptJob($input: AcceptJobInput!) {
  acceptJob(input: $input) {
    job {
      ...JobFragments_job
    }
    errors {
      ...ErrorFragments_error
    }
  }
}
    ${JobFragments_JobFragmentDoc}
${ErrorFragments_ErrorFragmentDoc}`;
export const useAcceptJobMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<AcceptJobMutation, TError, AcceptJobMutationVariables, TContext>) =>
    useMutation<AcceptJobMutation, TError, AcceptJobMutationVariables, TContext>(
      ['AcceptJob'],
      (variables?: AcceptJobMutationVariables) => fetchData<AcceptJobMutation, AcceptJobMutationVariables>(AcceptJobDocument, variables)(),
      options
    );
export const CreateJobDocument = `
    mutation CreateJob($input: UpdateJobInput!) {
  createJob(input: $input) {
    job {
      ...JobFragments_job
    }
    errors {
      ...ErrorFragments_error
    }
  }
}
    ${JobFragments_JobFragmentDoc}
${ErrorFragments_ErrorFragmentDoc}`;
export const useCreateJobMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<CreateJobMutation, TError, CreateJobMutationVariables, TContext>) =>
    useMutation<CreateJobMutation, TError, CreateJobMutationVariables, TContext>(
      ['CreateJob'],
      (variables?: CreateJobMutationVariables) => fetchData<CreateJobMutation, CreateJobMutationVariables>(CreateJobDocument, variables)(),
      options
    );
export const AdminChatViewJobDetailsDocument = `
    query AdminChatViewJobDetails($input: JobDetailsInput!) {
  adminChatViewJobDetails(input: $input) {
    job {
      id
      title
      supplierId
      address
    }
    errors {
      ...ErrorFragments_error
    }
  }
}
    ${ErrorFragments_ErrorFragmentDoc}`;
export const useAdminChatViewJobDetailsQuery = <
      TData = AdminChatViewJobDetailsQuery,
      TError = unknown
    >(
      variables: AdminChatViewJobDetailsQueryVariables,
      options?: UseQueryOptions<AdminChatViewJobDetailsQuery, TError, TData>
    ) =>
    useQuery<AdminChatViewJobDetailsQuery, TError, TData>(
      ['AdminChatViewJobDetails', variables],
      fetchData<AdminChatViewJobDetailsQuery, AdminChatViewJobDetailsQueryVariables>(AdminChatViewJobDetailsDocument, variables),
      options
    );
export const JobReportJobDetailsDocument = `
    query JobReportJobDetails($input: JobDetailsInput!) {
  jobReportJobDetails(input: $input) {
    job {
      id
      referenceId
      title
      details
      address
      slotDuration
      startTime
      supplierJobStatusId
      supplierJobStatus {
        id
        title
      }
      jobReport {
        id
        reportJobId
        description
        labourCost
        labourRevenue
        materialQuotes {
          materialText
          materialCost
          materialRevenues
        }
        materialRevenue
        parkingCost
        parkingRevenue
        otherCost
        otherRevenue
        totalCost
        totalRevenues
        beforeImages
        images
        videos
        documents
      }
      quotes {
        id
        description
        labourRevenue
        materialQuotes {
          materialText
          materialCost
          materialRevenues
        }
        parkingRevenue
        otherRevenue
        totalRevenues
      }
    }
    errors {
      ...ErrorFragments_error
    }
  }
}
    ${ErrorFragments_ErrorFragmentDoc}`;
export const useJobReportJobDetailsQuery = <
      TData = JobReportJobDetailsQuery,
      TError = unknown
    >(
      variables: JobReportJobDetailsQueryVariables,
      options?: UseQueryOptions<JobReportJobDetailsQuery, TError, TData>
    ) =>
    useQuery<JobReportJobDetailsQuery, TError, TData>(
      ['JobReportJobDetails', variables],
      fetchData<JobReportJobDetailsQuery, JobReportJobDetailsQueryVariables>(JobReportJobDetailsDocument, variables),
      options
    );
export const JobUpdateJobDetailsDocument = `
    query JobUpdateJobDetails($input: JobDetailsInput!) {
  jobUpdateJobDetails(input: $input) {
    job {
      ...JobFragments_job
      problemCategory {
        id
        name
      }
      problemSubcategory {
        id
        name
        skillId
      }
    }
    errors {
      ...ErrorFragments_error
    }
  }
}
    ${JobFragments_JobFragmentDoc}
${ErrorFragments_ErrorFragmentDoc}`;
export const useJobUpdateJobDetailsQuery = <
      TData = JobUpdateJobDetailsQuery,
      TError = unknown
    >(
      variables: JobUpdateJobDetailsQueryVariables,
      options?: UseQueryOptions<JobUpdateJobDetailsQuery, TError, TData>
    ) =>
    useQuery<JobUpdateJobDetailsQuery, TError, TData>(
      ['JobUpdateJobDetails', variables],
      fetchData<JobUpdateJobDetailsQuery, JobUpdateJobDetailsQueryVariables>(JobUpdateJobDetailsDocument, variables),
      options
    );
export const JobDetailsDocument = `
    query JobDetails($input: JobDetailsInput!) {
  jobDetails(input: $input) {
    job {
      ...JobFragments_job
    }
    errors {
      ...ErrorFragments_error
    }
  }
}
    ${JobFragments_JobFragmentDoc}
${ErrorFragments_ErrorFragmentDoc}`;
export const useJobDetailsQuery = <
      TData = JobDetailsQuery,
      TError = unknown
    >(
      variables: JobDetailsQueryVariables,
      options?: UseQueryOptions<JobDetailsQuery, TError, TData>
    ) =>
    useQuery<JobDetailsQuery, TError, TData>(
      ['JobDetails', variables],
      fetchData<JobDetailsQuery, JobDetailsQueryVariables>(JobDetailsDocument, variables),
      options
    );
export const ListJobDocument = `
    query ListJob {
  listJob {
    jobList {
      id
      slug
      jobStatusId
      jobStatus {
        id
        title
      }
      supplierJobStatusId
      supplierJobStatus {
        id
        title
      }
    }
  }
}
    `;
export const useListJobQuery = <
      TData = ListJobQuery,
      TError = unknown
    >(
      variables?: ListJobQueryVariables,
      options?: UseQueryOptions<ListJobQuery, TError, TData>
    ) =>
    useQuery<ListJobQuery, TError, TData>(
      variables === undefined ? ['ListJob'] : ['ListJob', variables],
      fetchData<ListJobQuery, ListJobQueryVariables>(ListJobDocument, variables),
      options
    );
export const AdminSearchJobListDocument = `
    query AdminSearchJobList($input: SeachJobListInput!) {
  adminSearchJobList(input: $input) {
    jobList {
      ...JobFragments_adminJobList
      city {
        ...CityFragments_adminCityJobList
      }
      skillList {
        ...SkillFragments_adminJobListSkill
      }
    }
    hasMore
    cursor {
      ...CursorFragments_cursor
    }
  }
}
    ${JobFragments_AdminJobListFragmentDoc}
${CityFragments_AdminCityJobListFragmentDoc}
${SkillFragments_AdminJobListSkillFragmentDoc}
${CursorFragments_CursorFragmentDoc}`;
export const useAdminSearchJobListQuery = <
      TData = AdminSearchJobListQuery,
      TError = unknown
    >(
      variables: AdminSearchJobListQueryVariables,
      options?: UseQueryOptions<AdminSearchJobListQuery, TError, TData>
    ) =>
    useQuery<AdminSearchJobListQuery, TError, TData>(
      ['AdminSearchJobList', variables],
      fetchData<AdminSearchJobListQuery, AdminSearchJobListQueryVariables>(AdminSearchJobListDocument, variables),
      options
    );
export const AppHomeSearchJobListDocument = `
    query AppHomeSearchJobList($input: AppHomeSearchJobListInput!) {
  appHomeSearchJobList(input: $input) {
    jobList {
      id
      title
      location {
        type
        coordinates
      }
      address
      slotDuration
      startTimeSlots {
        date
        slots
      }
      startTime
      postCode
      skillList {
        ...SkillFragments_skill
      }
    }
    hasMore
    cursor {
      ...CursorFragments_cursor
    }
  }
}
    ${SkillFragments_SkillFragmentDoc}
${CursorFragments_CursorFragmentDoc}`;
export const useAppHomeSearchJobListQuery = <
      TData = AppHomeSearchJobListQuery,
      TError = unknown
    >(
      variables: AppHomeSearchJobListQueryVariables,
      options?: UseQueryOptions<AppHomeSearchJobListQuery, TError, TData>
    ) =>
    useQuery<AppHomeSearchJobListQuery, TError, TData>(
      ['AppHomeSearchJobList', variables],
      fetchData<AppHomeSearchJobListQuery, AppHomeSearchJobListQueryVariables>(AppHomeSearchJobListDocument, variables),
      options
    );
export const AppNewChatJobListDocument = `
    query AppNewChatJobList($input: SeachJobListInput!) {
  appNewChatJobList(input: $input) {
    jobList {
      id
      title
      createdAt
      address
    }
    hasMore
    cursor {
      ...CursorFragments_cursor
    }
  }
}
    ${CursorFragments_CursorFragmentDoc}`;
export const useAppNewChatJobListQuery = <
      TData = AppNewChatJobListQuery,
      TError = unknown
    >(
      variables: AppNewChatJobListQueryVariables,
      options?: UseQueryOptions<AppNewChatJobListQuery, TError, TData>
    ) =>
    useQuery<AppNewChatJobListQuery, TError, TData>(
      ['AppNewChatJobList', variables],
      fetchData<AppNewChatJobListQuery, AppNewChatJobListQueryVariables>(AppNewChatJobListDocument, variables),
      options
    );
export const SearchJobListDocument = `
    query SearchJobList($input: SeachJobListInput!) {
  searchJobList(input: $input) {
    jobList {
      ...JobFragments_jobSimple
      jobStatusId
      jobStatus {
        id
        title
      }
      supplierJobStatusId
      supplierJobStatus {
        id
        title
      }
      profileId
      profile {
        id
        fullName
      }
      authorId
      author {
        id
        fullName
      }
      clientId
      client {
        id
        fullName
      }
      supplierId
      supplier {
        id
        fullName
      }
      preferredSupplierList {
        id
        fullName
      }
      city {
        ...CityFragments_city
      }
      skillList {
        ...SkillFragments_skill
      }
    }
    hasMore
    cursor {
      ...CursorFragments_cursor
    }
  }
}
    ${JobFragments_JobSimpleFragmentDoc}
${CityFragments_CityFragmentDoc}
${SkillFragments_SkillFragmentDoc}
${CursorFragments_CursorFragmentDoc}`;
export const useSearchJobListQuery = <
      TData = SearchJobListQuery,
      TError = unknown
    >(
      variables: SearchJobListQueryVariables,
      options?: UseQueryOptions<SearchJobListQuery, TError, TData>
    ) =>
    useQuery<SearchJobListQuery, TError, TData>(
      ['SearchJobList', variables],
      fetchData<SearchJobListQuery, SearchJobListQueryVariables>(SearchJobListDocument, variables),
      options
    );
export const SearchJobStatusListDocument = `
    query SearchJobStatusList($input: StatusListInput!) {
  searchJobStatusList(input: $input) {
    jobStatusList {
      ...JobStatusFragments_jobStatus
    }
  }
}
    ${JobStatusFragments_JobStatusFragmentDoc}`;
export const useSearchJobStatusListQuery = <
      TData = SearchJobStatusListQuery,
      TError = unknown
    >(
      variables: SearchJobStatusListQueryVariables,
      options?: UseQueryOptions<SearchJobStatusListQuery, TError, TData>
    ) =>
    useQuery<SearchJobStatusListQuery, TError, TData>(
      ['SearchJobStatusList', variables],
      fetchData<SearchJobStatusListQuery, SearchJobStatusListQueryVariables>(SearchJobStatusListDocument, variables),
      options
    );
export const UpdateJobDocument = `
    mutation UpdateJob($input: UpdateJobInput!) {
  updateJob(input: $input) {
    job {
      ...JobFragments_jobSimple
      city {
        ...CityFragments_city
      }
      skillList {
        ...SkillFragments_skill
      }
    }
    errors {
      ...ErrorFragments_error
    }
  }
}
    ${JobFragments_JobSimpleFragmentDoc}
${CityFragments_CityFragmentDoc}
${SkillFragments_SkillFragmentDoc}
${ErrorFragments_ErrorFragmentDoc}`;
export const useUpdateJobMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<UpdateJobMutation, TError, UpdateJobMutationVariables, TContext>) =>
    useMutation<UpdateJobMutation, TError, UpdateJobMutationVariables, TContext>(
      ['UpdateJob'],
      (variables?: UpdateJobMutationVariables) => fetchData<UpdateJobMutation, UpdateJobMutationVariables>(UpdateJobDocument, variables)(),
      options
    );
export const UpdatePartialJobDocument = `
    mutation UpdatePartialJob($input: UpdateJobInput!) {
  updatePartialJob(input: $input) {
    job {
      ...JobFragments_jobSimple
    }
    errors {
      ...ErrorFragments_error
    }
  }
}
    ${JobFragments_JobSimpleFragmentDoc}
${ErrorFragments_ErrorFragmentDoc}`;
export const useUpdatePartialJobMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<UpdatePartialJobMutation, TError, UpdatePartialJobMutationVariables, TContext>) =>
    useMutation<UpdatePartialJobMutation, TError, UpdatePartialJobMutationVariables, TContext>(
      ['UpdatePartialJob'],
      (variables?: UpdatePartialJobMutationVariables) => fetchData<UpdatePartialJobMutation, UpdatePartialJobMutationVariables>(UpdatePartialJobDocument, variables)(),
      options
    );
export const CreatePaymentIntentDocument = `
    mutation CreatePaymentIntent($input: CreatePaymentIntentInput!) {
  createPaymentIntent(input: $input) {
    clientSecret
    errors {
      ...ErrorFragments_error
    }
  }
}
    ${ErrorFragments_ErrorFragmentDoc}`;
export const useCreatePaymentIntentMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<CreatePaymentIntentMutation, TError, CreatePaymentIntentMutationVariables, TContext>) =>
    useMutation<CreatePaymentIntentMutation, TError, CreatePaymentIntentMutationVariables, TContext>(
      ['CreatePaymentIntent'],
      (variables?: CreatePaymentIntentMutationVariables) => fetchData<CreatePaymentIntentMutation, CreatePaymentIntentMutationVariables>(CreatePaymentIntentDocument, variables)(),
      options
    );
export const SearchCityPriceDocument = `
    query SearchCityPrice($input: SearchCityPriceInput!) {
  searchCityPrice(input: $input) {
    cityPriceList {
      price
    }
  }
}
    `;
export const useSearchCityPriceQuery = <
      TData = SearchCityPriceQuery,
      TError = unknown
    >(
      variables: SearchCityPriceQueryVariables,
      options?: UseQueryOptions<SearchCityPriceQuery, TError, TData>
    ) =>
    useQuery<SearchCityPriceQuery, TError, TData>(
      ['SearchCityPrice', variables],
      fetchData<SearchCityPriceQuery, SearchCityPriceQueryVariables>(SearchCityPriceDocument, variables),
      options
    );
export const ProblemCategoryListDocument = `
    query ProblemCategoryList {
  problemCategoryList {
    problemCategoryList {
      id
      name
      iconName
      enabled
      problemSubcategoryConnection {
        id
        name
        skillId
        enabled
      }
    }
  }
}
    `;
export const useProblemCategoryListQuery = <
      TData = ProblemCategoryListQuery,
      TError = unknown
    >(
      variables?: ProblemCategoryListQueryVariables,
      options?: UseQueryOptions<ProblemCategoryListQuery, TError, TData>
    ) =>
    useQuery<ProblemCategoryListQuery, TError, TData>(
      variables === undefined ? ['ProblemCategoryList'] : ['ProblemCategoryList', variables],
      fetchData<ProblemCategoryListQuery, ProblemCategoryListQueryVariables>(ProblemCategoryListDocument, variables),
      options
    );
export const ChangePasswordDocument = `
    mutation ChangePassword($input: ChangePasswordInput!) {
  changePassword(input: $input) {
    profile {
      ...ProfileFragments_profile
    }
    errors {
      ...ErrorFragments_error
    }
  }
}
    ${ProfileFragments_ProfileFragmentDoc}
${ErrorFragments_ErrorFragmentDoc}`;
export const useChangePasswordMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<ChangePasswordMutation, TError, ChangePasswordMutationVariables, TContext>) =>
    useMutation<ChangePasswordMutation, TError, ChangePasswordMutationVariables, TContext>(
      ['ChangePassword'],
      (variables?: ChangePasswordMutationVariables) => fetchData<ChangePasswordMutation, ChangePasswordMutationVariables>(ChangePasswordDocument, variables)(),
      options
    );
export const ConfirmEmailDocument = `
    mutation ConfirmEmail($input: ConfirmEmailInput!) {
  confirmEmail(input: $input) {
    errors {
      ...ErrorFragments_error
    }
  }
}
    ${ErrorFragments_ErrorFragmentDoc}`;
export const useConfirmEmailMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<ConfirmEmailMutation, TError, ConfirmEmailMutationVariables, TContext>) =>
    useMutation<ConfirmEmailMutation, TError, ConfirmEmailMutationVariables, TContext>(
      ['ConfirmEmail'],
      (variables?: ConfirmEmailMutationVariables) => fetchData<ConfirmEmailMutation, ConfirmEmailMutationVariables>(ConfirmEmailDocument, variables)(),
      options
    );
export const CreateB2CClientProfileDocument = `
    mutation CreateB2CClientProfile($input: CreateB2CClientProfileInput!) {
  createB2CClientProfile(input: $input) {
    profile {
      ...ProfileFragments_profile
    }
    accessToken
    errors {
      ...ErrorFragments_error
    }
  }
}
    ${ProfileFragments_ProfileFragmentDoc}
${ErrorFragments_ErrorFragmentDoc}`;
export const useCreateB2CClientProfileMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<CreateB2CClientProfileMutation, TError, CreateB2CClientProfileMutationVariables, TContext>) =>
    useMutation<CreateB2CClientProfileMutation, TError, CreateB2CClientProfileMutationVariables, TContext>(
      ['CreateB2CClientProfile'],
      (variables?: CreateB2CClientProfileMutationVariables) => fetchData<CreateB2CClientProfileMutation, CreateB2CClientProfileMutationVariables>(CreateB2CClientProfileDocument, variables)(),
      options
    );
export const CreateProfileDocument = `
    mutation CreateProfile($input: CreateProfileInput!) {
  createProfile(input: $input) {
    profile {
      ...ProfileFragments_profile
    }
    accessToken
    errors {
      ...ErrorFragments_error
    }
  }
}
    ${ProfileFragments_ProfileFragmentDoc}
${ErrorFragments_ErrorFragmentDoc}`;
export const useCreateProfileMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<CreateProfileMutation, TError, CreateProfileMutationVariables, TContext>) =>
    useMutation<CreateProfileMutation, TError, CreateProfileMutationVariables, TContext>(
      ['CreateProfile'],
      (variables?: CreateProfileMutationVariables) => fetchData<CreateProfileMutation, CreateProfileMutationVariables>(CreateProfileDocument, variables)(),
      options
    );
export const ForgotPasswordConfirmEmailDocument = `
    mutation ForgotPasswordConfirmEmail($input: ForgotPasswordConfirmEmailInput!) {
  forgotPasswordConfirmEmail(input: $input) {
    profileId
    errors {
      ...ErrorFragments_error
    }
  }
}
    ${ErrorFragments_ErrorFragmentDoc}`;
export const useForgotPasswordConfirmEmailMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<ForgotPasswordConfirmEmailMutation, TError, ForgotPasswordConfirmEmailMutationVariables, TContext>) =>
    useMutation<ForgotPasswordConfirmEmailMutation, TError, ForgotPasswordConfirmEmailMutationVariables, TContext>(
      ['ForgotPasswordConfirmEmail'],
      (variables?: ForgotPasswordConfirmEmailMutationVariables) => fetchData<ForgotPasswordConfirmEmailMutation, ForgotPasswordConfirmEmailMutationVariables>(ForgotPasswordConfirmEmailDocument, variables)(),
      options
    );
export const ForgotPasswordSendEmailDocument = `
    mutation ForgotPasswordSendEmail($input: ForgotPasswordSendEmailInput!) {
  forgotPasswordSendEmail(input: $input) {
    errors {
      ...ErrorFragments_error
    }
  }
}
    ${ErrorFragments_ErrorFragmentDoc}`;
export const useForgotPasswordSendEmailMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<ForgotPasswordSendEmailMutation, TError, ForgotPasswordSendEmailMutationVariables, TContext>) =>
    useMutation<ForgotPasswordSendEmailMutation, TError, ForgotPasswordSendEmailMutationVariables, TContext>(
      ['ForgotPasswordSendEmail'],
      (variables?: ForgotPasswordSendEmailMutationVariables) => fetchData<ForgotPasswordSendEmailMutation, ForgotPasswordSendEmailMutationVariables>(ForgotPasswordSendEmailDocument, variables)(),
      options
    );
export const ProfileDetailsDocument = `
    query ProfileDetails($input: ProfileDetailsInput!) {
  profileDetails(input: $input) {
    profile {
      ...ProfileFragments_profile
    }
    errors {
      ...ErrorFragments_error
    }
  }
}
    ${ProfileFragments_ProfileFragmentDoc}
${ErrorFragments_ErrorFragmentDoc}`;
export const useProfileDetailsQuery = <
      TData = ProfileDetailsQuery,
      TError = unknown
    >(
      variables: ProfileDetailsQueryVariables,
      options?: UseQueryOptions<ProfileDetailsQuery, TError, TData>
    ) =>
    useQuery<ProfileDetailsQuery, TError, TData>(
      ['ProfileDetails', variables],
      fetchData<ProfileDetailsQuery, ProfileDetailsQueryVariables>(ProfileDetailsDocument, variables),
      options
    );
export const ResetPasswordDocument = `
    mutation ResetPassword($input: ResetPasswordInput!) {
  resetPassword(input: $input) {
    errors {
      ...ErrorFragments_error
    }
  }
}
    ${ErrorFragments_ErrorFragmentDoc}`;
export const useResetPasswordMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<ResetPasswordMutation, TError, ResetPasswordMutationVariables, TContext>) =>
    useMutation<ResetPasswordMutation, TError, ResetPasswordMutationVariables, TContext>(
      ['ResetPassword'],
      (variables?: ResetPasswordMutationVariables) => fetchData<ResetPasswordMutation, ResetPasswordMutationVariables>(ResetPasswordDocument, variables)(),
      options
    );
export const SearchProfileListDocument = `
    query SearchProfileList($input: SearchProfileListInput!) {
  searchProfileList(input: $input) {
    profileList {
      ...ProfileFragments_profile
    }
  }
}
    ${ProfileFragments_ProfileFragmentDoc}`;
export const useSearchProfileListQuery = <
      TData = SearchProfileListQuery,
      TError = unknown
    >(
      variables: SearchProfileListQueryVariables,
      options?: UseQueryOptions<SearchProfileListQuery, TError, TData>
    ) =>
    useQuery<SearchProfileListQuery, TError, TData>(
      ['SearchProfileList', variables],
      fetchData<SearchProfileListQuery, SearchProfileListQueryVariables>(SearchProfileListDocument, variables),
      options
    );
export const UpdateProfileDocument = `
    mutation UpdateProfile($input: UpdateProfileInput!) {
  updateProfile(input: $input) {
    profile {
      ...ProfileFragments_profile
    }
    accessToken
    errors {
      ...ErrorFragments_error
    }
  }
}
    ${ProfileFragments_ProfileFragmentDoc}
${ErrorFragments_ErrorFragmentDoc}`;
export const useUpdateProfileMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<UpdateProfileMutation, TError, UpdateProfileMutationVariables, TContext>) =>
    useMutation<UpdateProfileMutation, TError, UpdateProfileMutationVariables, TContext>(
      ['UpdateProfile'],
      (variables?: UpdateProfileMutationVariables) => fetchData<UpdateProfileMutation, UpdateProfileMutationVariables>(UpdateProfileDocument, variables)(),
      options
    );
export const CreateQuoteDocument = `
    mutation CreateQuote($input: CreateQuoteInput!) {
  createQuote(input: $input) {
    quote {
      id
    }
    errors {
      ...ErrorFragments_error
    }
  }
}
    ${ErrorFragments_ErrorFragmentDoc}`;
export const useCreateQuoteMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<CreateQuoteMutation, TError, CreateQuoteMutationVariables, TContext>) =>
    useMutation<CreateQuoteMutation, TError, CreateQuoteMutationVariables, TContext>(
      ['CreateQuote'],
      (variables?: CreateQuoteMutationVariables) => fetchData<CreateQuoteMutation, CreateQuoteMutationVariables>(CreateQuoteDocument, variables)(),
      options
    );
export const CreateRemoteQuoteDocument = `
    mutation CreateRemoteQuote($input: CreateRemoteQuoteInput!) {
  createRemoteQuote(input: $input) {
    errors {
      ...ErrorFragments_error
    }
  }
}
    ${ErrorFragments_ErrorFragmentDoc}`;
export const useCreateRemoteQuoteMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<CreateRemoteQuoteMutation, TError, CreateRemoteQuoteMutationVariables, TContext>) =>
    useMutation<CreateRemoteQuoteMutation, TError, CreateRemoteQuoteMutationVariables, TContext>(
      ['CreateRemoteQuote'],
      (variables?: CreateRemoteQuoteMutationVariables) => fetchData<CreateRemoteQuoteMutation, CreateRemoteQuoteMutationVariables>(CreateRemoteQuoteDocument, variables)(),
      options
    );
export const SeachJobReportDocument = `
    query SeachJobReport($input: SeachJobReportInput!) {
  seachJobReport(input: $input) {
    job {
      id
      referenceId
      remedialNotes
      adminJobReportNotes
      completionImages
      completionVideos
    }
  }
}
    `;
export const useSeachJobReportQuery = <
      TData = SeachJobReportQuery,
      TError = unknown
    >(
      variables: SeachJobReportQueryVariables,
      options?: UseQueryOptions<SeachJobReportQuery, TError, TData>
    ) =>
    useQuery<SeachJobReportQuery, TError, TData>(
      ['SeachJobReport', variables],
      fetchData<SeachJobReportQuery, SeachJobReportQueryVariables>(SeachJobReportDocument, variables),
      options
    );
export const GetJobReviewDetailsDocument = `
    query GetJobReviewDetails($input: FindJobItemInput!) {
  getJobReviewDetails(input: $input) {
    job {
      id
      referenceId
      address
      clientReview {
        supplierFeedbackRating
        supplierFeedbackDetails
        qeeperFeedbackRating
        qeeperFeedbackDetails
        qeeperComments
        reviewStatus
      }
    }
    errors {
      ...ErrorFragments_error
    }
  }
}
    ${ErrorFragments_ErrorFragmentDoc}`;
export const useGetJobReviewDetailsQuery = <
      TData = GetJobReviewDetailsQuery,
      TError = unknown
    >(
      variables: GetJobReviewDetailsQueryVariables,
      options?: UseQueryOptions<GetJobReviewDetailsQuery, TError, TData>
    ) =>
    useQuery<GetJobReviewDetailsQuery, TError, TData>(
      ['GetJobReviewDetails', variables],
      fetchData<GetJobReviewDetailsQuery, GetJobReviewDetailsQueryVariables>(GetJobReviewDetailsDocument, variables),
      options
    );
export const CreateReviewDocument = `
    mutation CreateReview($input: CreateReviewInput!) {
  createReview(input: $input) {
    review {
      id
    }
    errors {
      ...ErrorFragments_error
    }
  }
}
    ${ErrorFragments_ErrorFragmentDoc}`;
export const useCreateReviewMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<CreateReviewMutation, TError, CreateReviewMutationVariables, TContext>) =>
    useMutation<CreateReviewMutation, TError, CreateReviewMutationVariables, TContext>(
      ['CreateReview'],
      (variables?: CreateReviewMutationVariables) => fetchData<CreateReviewMutation, CreateReviewMutationVariables>(CreateReviewDocument, variables)(),
      options
    );
export const AnalyticSkillListDocument = `
    query AnalyticSkillList($input: AnalyticInput!) {
  analyticSkillList(input: $input) {
    dataList {
      label
      value
    }
  }
}
    `;
export const useAnalyticSkillListQuery = <
      TData = AnalyticSkillListQuery,
      TError = unknown
    >(
      variables: AnalyticSkillListQueryVariables,
      options?: UseQueryOptions<AnalyticSkillListQuery, TError, TData>
    ) =>
    useQuery<AnalyticSkillListQuery, TError, TData>(
      ['AnalyticSkillList', variables],
      fetchData<AnalyticSkillListQuery, AnalyticSkillListQueryVariables>(AnalyticSkillListDocument, variables),
      options
    );
export const ListSkillDocument = `
    query ListSkill {
  listSkill {
    ...SkillFragments_skill
  }
}
    ${SkillFragments_SkillFragmentDoc}`;
export const useListSkillQuery = <
      TData = ListSkillQuery,
      TError = unknown
    >(
      variables?: ListSkillQueryVariables,
      options?: UseQueryOptions<ListSkillQuery, TError, TData>
    ) =>
    useQuery<ListSkillQuery, TError, TData>(
      variables === undefined ? ['ListSkill'] : ['ListSkill', variables],
      fetchData<ListSkillQuery, ListSkillQueryVariables>(ListSkillDocument, variables),
      options
    );
export const LoginDocument = `
    mutation Login($input: LoginInput!) {
  login(input: $input) {
    profile {
      ...ProfileFragments_profile
    }
    accessToken
    errors {
      ...ErrorFragments_error
    }
  }
}
    ${ProfileFragments_ProfileFragmentDoc}
${ErrorFragments_ErrorFragmentDoc}`;
export const useLoginMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<LoginMutation, TError, LoginMutationVariables, TContext>) =>
    useMutation<LoginMutation, TError, LoginMutationVariables, TContext>(
      ['Login'],
      (variables?: LoginMutationVariables) => fetchData<LoginMutation, LoginMutationVariables>(LoginDocument, variables)(),
      options
    );
export const LogoutDocument = `
    mutation Logout {
  logout
}
    `;
export const useLogoutMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<LogoutMutation, TError, LogoutMutationVariables, TContext>) =>
    useMutation<LogoutMutation, TError, LogoutMutationVariables, TContext>(
      ['Logout'],
      (variables?: LogoutMutationVariables) => fetchData<LogoutMutation, LogoutMutationVariables>(LogoutDocument, variables)(),
      options
    );
export const MeDocument = `
    query Me {
  me {
    profile {
      ...ProfileFragments_profileDetailed
    }
    accessToken
    errors {
      ...ErrorFragments_error
    }
  }
}
    ${ProfileFragments_ProfileDetailedFragmentDoc}
${ErrorFragments_ErrorFragmentDoc}`;
export const useMeQuery = <
      TData = MeQuery,
      TError = unknown
    >(
      variables?: MeQueryVariables,
      options?: UseQueryOptions<MeQuery, TError, TData>
    ) =>
    useQuery<MeQuery, TError, TData>(
      variables === undefined ? ['Me'] : ['Me', variables],
      fetchData<MeQuery, MeQueryVariables>(MeDocument, variables),
      options
    );